
var nAgt = navigator.userAgent;
checKGoogleBoat = false;
//nAgt = 'AdsBot-Google (+http://www.google.com/adsbot.html)'
function checkGoogleBoatAgent(nAgt) {
  const robots = new RegExp([
    /bot/, /spider/, /crawl/,                            // GENERAL TERMS
    /APIs-Google/, /AdsBot/, /Googlebot/,                // GOOGLE ROBOTS
    /mediapartners/, /Google Favicon/,
    /FeedFetcher/, /Google-Read-Aloud/,
    /DuplexWeb-Google/, /googleweblight/,
    /bing/, /yandex/, /baidu/, /duckduck/, /yahoo/,        // OTHER ENGINES
    /ecosia/, /ia_archiver/,
    /semrush/,                                         // OTHER
  ].map((r) => r.source).join("|"), "i");               // BUILD REGEXP + "i" FLAG

  return robots.test(nAgt);
};
checKGoogleBoat = checkGoogleBoatAgent(nAgt);

if (nAgt.indexOf('www.google.com') != -1) {
  checKGoogleBoat = true;
}

if (!checKGoogleBoat) {

  /* globel variables */
  var startAt, user_date_with_weekoff_cutoff, passcartvalue, get_product_tag, cart_msg_apperance, custom_cart_label, specific_preview_design, sb_edd_obj, shoplanguage, country_name, plan, check_cutoff, cutofftime_enable, date_format, detail_page_class, msg_preview, display_on_other_page, year, month, monthName, monthShort, day, dayOrd, dayName, dayNameShort;
  var shopnamefull = getCartDate = deliveryMessageBefore = hide_default_message = message = today_date = custom_date_format = cartDateSign = hideOutOfStockMessage = hideDefaultMessage = cartAdditionalMessage = changeCartLabel = shopnamefull = user_full_date = message_lowercase = '';
  var check_currentDay_is_weekoff = showOnlyDateOnCartpage = 0;
  var shortcodeList = weekday = [];
  var activate_premium_feature = '1';
  var showDeliveryMessage = 1;
  var CollectionDelvieryClass = '';
  var msg_preview = {};
  var get_custom_date_format = 'not_set';
  var date_option = 'default';
  holidays = [];
  every_year_holidays = [];
  var check_week_off_for_startdate = 0;
  var add_day_in_next_date = 0;
  var add_animation_class = '';
  var set_country_msg = '0';
  var off_day = [];
  var get_shortcode_with_value = [];
  var edd_main_object = {};

  var page_builder_classes = [".beae-add-to-cart--submit", "gp-product-button", ".ecom-product-single__add-to-cart"];
  var page_builder_classes_parent = [".ecom-product-single__add-to-cart--submit, .page_builder_classes", "button.pf-button-1[data-product-id]"];

  var count_down_interval = '';

  var timer_translation = { "en": { "Days": "Days", "Hours": "Hours", "Minutes": "Minutes", "Seconds": "Seconds", "Hrs": "Hrs", "Mins": "Mins", "Secs": "Secs", "H": "H", "M": "M", "S": "S", "days": "days", "hours": "hours", "minutes": "minutes", "seconds": "seconds" }, "af": { "Days": "Dae", "Hours": "Ure", "Minutes": "Minute", "Seconds": "Sekondes", "Hrs": "Ure", "Mins": "Minute", "Secs": "Sekondes", "H": "H", "M": "M", "S": "S", "days": "dae", "hours": "ure", "minutes": "minute", "seconds": "sekondes" }, "ak": { "Days": "DÉ”m", "Hours": "DÉ”nhwere", "Minutes": "Minit", "Seconds": "SÉ›kÉ›nd", "Hrs": "DÉ”nhwere", "Mins": "Minit", "Secs": "SÉ›kÉ›nd", "H": "H", "M": "M", "S": "S", "days": "dÉ”m", "hours": "dÉ”nhwere", "minutes": "minit", "seconds": "sÉ›kÉ›nd" }, "sq": { "Days": "DitÃ«", "Hours": "OrÃ«", "Minutes": "Minuta", "Seconds": "Sekonda", "Hrs": "OrÃ«", "Mins": "Minuta", "Secs": "Sekonda", "H": "H", "M": "M", "S": "S", "days": "ditÃ«", "hours": "orÃ«", "minutes": "minuta", "seconds": "sekonda" }, "am": { "Days": "á‰€áŠ“á‰µ", "Hours": "áˆ°á‹“á‰µ", "Minutes": "á‹°á‰‚á‰ƒ", "Seconds": "áˆ°áŠ¨áŠ•á‹µ", "Hrs": "áˆ°á‹“á‰¶á‰½", "Mins": "á‹°á‰‚á‰ƒá‹Žá‰½", "Secs": "áˆ°áŠ¨áŠ•á‹¶á‰½", "H": "áˆ°", "M": "á‹°", "S": "áˆ°", "days": "á‰€áŠ“á‰µ", "hours": "áˆ°á‹“á‰µ", "minutes": "á‹°á‰‚á‰ƒ", "seconds": "áˆ°áŠ¨áŠ•á‹µ" }, "ar": { "Days": "Ø£ÙŠØ§Ù…", "Hours": "Ø³Ø§Ø¹Ø§Øª", "Minutes": "Ø¯Ù‚Ø§Ø¦Ù‚", "Seconds": "Ø«ÙˆØ§Ù†ÙŠ", "Hrs": "Ø³Ø§Ø¹Ø§Øª", "Mins": "Ø¯Ù‚Ø§Ø¦Ù‚", "Secs": "Ø«ÙˆØ§Ù†ÙŠ", "H": "Ø³", "M": "Ø¯", "S": "Ø«", "days": "Ø£ÙŠØ§Ù…", "hours": "Ø³Ø§Ø¹Ø§Øª", "minutes": "Ø¯Ù‚Ø§Ø¦Ù‚", "seconds": "Ø«ÙˆØ§Ù†ÙŠ" }, "hy": { "Days": "Õ•Ö€", "Hours": "ÔºÕ¡Õ´", "Minutes": "ÕÕ¸ÕºÕ¥", "Seconds": "ÕŽÕ¡ÕµÖ€Õ¯ÕµÕ¡Õ¶", "Hrs": "ÔºÕ¡Õ´", "Mins": "ÕÕ¸ÕºÕ¥", "Secs": "ÕŽÕ¡ÕµÖ€Õ¯ÕµÕ¡Õ¶", "H": "Ôº", "M": "Õ", "S": "ÕŽ", "days": "Ö…Ö€", "hours": "ÕªÕ¡Õ´", "minutes": "Õ¼Õ¸ÕºÕ¥", "seconds": "Õ¾Õ¡ÕµÖ€Õ¯ÕµÕ¡Õ¶" }, "as": { "Days": "à¦¦à¦¿à¦¨", "Hours": "à¦˜à¦£à§à¦Ÿà¦¾", "Minutes": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "Seconds": "à¦¸à§‡à¦•à§‡à¦£à§à¦¡", "Hrs": "à¦˜à¦£à§à¦Ÿà¦¾", "Mins": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "Secs": "à¦¸à§‡à¦•à§‡à¦£à§à¦¡", "H": "à¦˜", "M": "à¦®à¦¿", "S": "à¦¸à§‡", "days": "à¦¦à¦¿à¦¨", "hours": "à¦˜à¦£à§à¦Ÿà¦¾", "minutes": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "seconds": "à¦¸à§‡à¦•à§‡à¦£à§à¦¡" }, "az": { "Days": "GÃ¼n", "Hours": "Saat", "Minutes": "DÉ™qiqÉ™", "Seconds": "SaniyÉ™", "Hrs": "Saat", "Mins": "DÉ™qiqÉ™", "Secs": "SaniyÉ™", "H": "S", "M": "D", "S": "S", "days": "gÃ¼n", "hours": "saat", "minutes": "dÉ™qiqÉ™", "seconds": "saniyÉ™" }, "bm": { "Days": "DÃ¹n", "Hours": "SÃ²ro", "Minutes": "Miniti", "Seconds": "Sekondi", "Hrs": "SÃ²ro", "Mins": "Miniti", "Secs": "Sekondi", "H": "H", "M": "M", "S": "S", "days": "dÃ¹n", "hours": "sÃ²ro", "minutes": "miniti", "seconds": "sekondi" }, "bn": { "Days": "à¦¦à¦¿à¦¨", "Hours": "à¦˜à¦¨à§à¦Ÿà¦¾", "Minutes": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "Seconds": "à¦¸à§‡à¦•à§‡à¦¨à§à¦¡", "Hrs": "à¦˜à¦¨à§à¦Ÿà¦¾", "Mins": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "Secs": "à¦¸à§‡à¦•à§‡à¦¨à§à¦¡", "H": "à¦˜", "M": "à¦®à¦¿", "S": "à¦¸à§‡", "days": "à¦¦à¦¿à¦¨", "hours": "à¦˜à¦¨à§à¦Ÿà¦¾", "minutes": "à¦®à¦¿à¦¨à¦¿à¦Ÿ", "seconds": "à¦¸à§‡à¦•à§‡à¦¨à§à¦¡" }, "eu": { "Days": "Egun", "Hours": "Ordu", "Minutes": "Minutu", "Seconds": "Segundu", "Hrs": "Ordu", "Mins": "Minutu", "Secs": "Segundu", "H": "O", "M": "M", "S": "S", "days": "egun", "hours": "ordu", "minutes": "minutu", "seconds": "segundu" }, "be": { "Days": "Ð”Ð·ÐµÐ½ÑŒ", "Hours": "Ð“Ð°Ð´Ð·Ñ–Ð½Ð°", "Minutes": "Ð¥Ð²Ñ–Ð»Ñ–Ð½Ð°", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ð°", "Hrs": "Ð“Ð°Ð´Ð·Ñ–Ð½Ñ‹", "Mins": "Ð¥Ð²Ñ–Ð»Ñ–Ð½Ñ‹", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ñ‹", "H": "Ð“", "M": "Ð¥", "S": "Ð¡", "days": "Ð´Ð·ÐµÐ½ÑŒ", "hours": "Ð³Ð°Ð´Ð·Ñ–Ð½Ð°", "minutes": "Ñ…Ð²Ñ–Ð»Ñ–Ð½Ð°", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ð°" }, "bs": { "Days": "Dani", "Hours": "Sati", "Minutes": "Minute", "Seconds": "Sekunde", "Hrs": "Sati", "Mins": "Minute", "Secs": "Sekunde", "H": "S", "M": "M", "S": "S", "days": "dani", "hours": "sati", "minutes": "minute", "seconds": "sekunde" }, "br": { "Days": "DeizioÃ¹", "Hours": "Eur", "Minutes": "Miz", "Seconds": "Eilenn", "Hrs": "Eur", "Mins": "Miz", "Secs": "Eilenn", "H": "E", "M": "M", "S": "E", "days": "deizioÃ¹", "hours": "eur", "minutes": "miz", "seconds": "eilenn" }, "bg": { "Days": "Ð”Ð½Ð¸", "Hours": "Ð§Ð°ÑÐ°", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚Ð¸", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "Hrs": "Ð§Ð°ÑÐ°", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚Ð¸", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "H": "Ð§", "M": "Ðœ", "S": "Ð¡", "days": "Ð´Ð½Ð¸", "hours": "Ñ‡Ð°ÑÐ°", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚Ð¸", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ð¸" }, "my": { "Days": "á€›á€€á€º", "Hours": "á€”á€¬á€›á€®", "Minutes": "á€™á€­á€”á€…á€º", "Seconds": "á€…á€€á€¹á€€á€”á€ºá€·", "Hrs": "á€”á€¬á€›á€®", "Mins": "á€™á€­á€”á€…á€º", "Secs": "á€…á€€á€¹á€€á€”á€ºá€·", "H": "á€”", "M": "á€™", "S": "á€…", "days": "á€›á€€á€º", "hours": "á€”á€¬á€›á€®", "minutes": "á€™á€­á€”á€…á€º", "seconds": "á€…á€€á€¹á€€á€”á€ºá€·" }, "ca": { "Days": "Dies", "Hours": "Hores", "Minutes": "Minuts", "Seconds": "Segons", "Hrs": "Hores", "Mins": "Minuts", "Secs": "Segons", "H": "H", "M": "M", "S": "S", "days": "dies", "hours": "hores", "minutes": "minuts", "seconds": "segons" }, "ce": { "Days": "ÐšÓ€Ð¸Ð½Ð½", "Hours": "Ð¡Ð¾ÑŒÑ€", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ð¡Ð¾ÑŒÑ€", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ð¡", "M": "Ðœ", "S": "Ð¡", "days": "ÐºÓ€Ð¸Ð½Ð½", "hours": "ÑÐ¾ÑŒÑ€", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "zh-CN": { "Days": "å¤©", "Hours": "å°æ—¶", "Minutes": "åˆ†é’Ÿ", "Seconds": "ç§’", "Hrs": "å°æ—¶", "Mins": "åˆ†é’Ÿ", "Secs": "ç§’", "H": "æ—¶", "M": "åˆ†", "S": "ç§’", "days": "å¤©", "hours": "å°æ—¶", "minutes": "åˆ†é’Ÿ", "seconds": "ç§’" }, "zh-TW": { "Days": "å¤©", "Hours": "å°æ™‚", "Minutes": "åˆ†é˜", "Seconds": "ç§’", "Hrs": "å°æ™‚", "Mins": "åˆ†é˜", "Secs": "ç§’", "H": "æ™‚", "M": "åˆ†", "S": "ç§’", "days": "å¤©", "hours": "å°æ™‚", "minutes": "åˆ†é˜", "seconds": "ç§’" }, "kw": { "Days": "Dydh", "Hours": "Eur", "Minutes": "Munud", "Seconds": "Sekond", "Hrs": "Eur", "Mins": "Munud", "Secs": "Sekond", "H": "E", "M": "M", "S": "S", "days": "dydh", "hours": "eur", "minutes": "munud", "seconds": "sekond" }, "hr": { "Days": "Dani", "Hours": "Sati", "Minutes": "Minute", "Seconds": "Sekunde", "Hrs": "Sati", "Mins": "Minute", "Secs": "Sekunde", "H": "S", "M": "M", "S": "S", "days": "dani", "hours": "sati", "minutes": "minute", "seconds": "sekunde" }, "cs": { "Days": "Dny", "Hours": "Hodiny", "Minutes": "Minuty", "Seconds": "Sekundy", "Hrs": "Hodiny", "Mins": "Minuty", "Secs": "Sekundy", "H": "H", "M": "M", "S": "S", "days": "dny", "hours": "hodiny", "minutes": "minuty", "seconds": "sekundy" }, "da": { "Days": "Dage", "Hours": "Timer", "Minutes": "Minutter", "Seconds": "Sekunder", "Hrs": "Timer", "Mins": "Minutter", "Secs": "Sekunder", "H": "H", "M": "M", "S": "S", "days": "dage", "hours": "timer", "minutes": "minutter", "seconds": "sekunder" }, "nl": { "Days": "Dagen", "Hours": "Uren", "Minutes": "Minuten", "Seconds": "Seconden", "Hrs": "Uren", "Mins": "Minuten", "Secs": "Seconden", "H": "U", "M": "M", "S": "S", "days": "dagen", "hours": "uren", "minutes": "minuten", "seconds": "seconden" }, "dz": { "Days": "à½‰à½²à½“à¼‹à½šà½ºà½¦à¼", "Hours": "à½†à½´à¼‹à½šà½¼à½‘à¼", "Minutes": "à½¦à¾à½¢à¼‹à½˜à¼", "Seconds": "à½¦à¾à½¢à¼", "Hrs": "à½†à½´à¼‹à½šà½¼à½‘à¼", "Mins": "à½¦à¾à½¢à¼‹à½˜à¼", "Secs": "à½¦à¾à½¢à¼", "H": "à½†", "M": "à½¦à¾à½¢à¼‹", "S": "à½¦à¾à½¢à¼", "days": "à½‰à½²à½“à¼‹à½šà½ºà½¦à¼", "hours": "à½†à½´à¼‹à½šà½¼à½‘à¼", "minutes": "à½¦à¾à½¢à¼‹à½˜à¼", "seconds": "à½¦à¾à½¢à¼" }, "eo": { "Days": "Tagoj", "Hours": "Horoj", "Minutes": "Minutoj", "Seconds": "Sekundoj", "Hrs": "Horoj", "Mins": "Minutoj", "Secs": "Sekundoj", "H": "H", "M": "M", "S": "S", "days": "tagoj", "hours": "horoj", "minutes": "minutoj", "seconds": "sekundoj" }, "et": { "Days": "PÃ¤evad", "Hours": "Tunnid", "Minutes": "Minutid", "Seconds": "Sekundid", "Hrs": "Tunnid", "Mins": "Minutid", "Secs": "Sekundid", "H": "T", "M": "M", "S": "S", "days": "pÃ¤evad", "hours": "tunnid", "minutes": "minutid", "seconds": "sekundid" }, "ee": { "Days": "Dede", "Hours": "Awa", "Minutes": "Minutu", "Seconds": "Seiku", "Hrs": "Awa", "Mins": "Minutu", "Secs": "Seiku", "H": "A", "M": "M", "S": "S", "days": "dede", "hours": "awa", "minutes": "minutu", "seconds": "seiku" }, "fo": { "Days": "Dagar", "Hours": "TÃ­mar", "Minutes": "Minuttir", "Seconds": "Sekundir", "Hrs": "TÃ­mar", "Mins": "Minuttir", "Secs": "Sekundir", "H": "T", "M": "M", "S": "S", "days": "dagar", "hours": "tÃ­mar", "minutes": "minuttir", "seconds": "sekundir" }, "fil": { "Days": "Araw", "Hours": "Oras", "Minutes": "Minuto", "Seconds": "Segundo", "Hrs": "Oras", "Mins": "Minuto", "Secs": "Segundo", "H": "O", "M": "M", "S": "S", "days": "araw", "hours": "oras", "minutes": "minuto", "seconds": "segundo" }, "fi": { "Days": "PÃ¤ivÃ¤t", "Hours": "Tunnit", "Minutes": "Minuutit", "Seconds": "Sekunnit", "Hrs": "Tunnit", "Mins": "Minuutit", "Secs": "Sekunnit", "H": "T", "M": "M", "S": "S", "days": "pÃ¤ivÃ¤t", "hours": "tunnit", "minutes": "minuutit", "seconds": "sekunnit" }, "fr": { "Days": "Jours", "Hours": "Heures", "Minutes": "Minutes", "Seconds": "Secondes", "Hrs": "Heures", "Mins": "Minutes", "Secs": "Secondes", "H": "H", "M": "M", "S": "S", "days": "jours", "hours": "heures", "minutes": "minutes", "seconds": "secondes" }, "ff": { "Days": "Ã‘endu", "Hours": "Jallobi", "Minutes": "Minuti", "Seconds": "Sekond", "Hrs": "Jallobi", "Mins": "Minuti", "Secs": "Sekond", "H": "J", "M": "M", "S": "S", "days": "Ã±endu", "hours": "jallobi", "minutes": "minuti", "seconds": "sekond" }, "gl": { "Days": "DÃ­as", "Hours": "Horas", "Minutes": "Minutos", "Seconds": "Segundos", "Hrs": "Horas", "Mins": "Minutos", "Secs": "Segundos", "H": "H", "M": "M", "S": "S", "days": "dÃ­as", "hours": "horas", "minutes": "minutos", "seconds": "segundos" }, "lg": { "Days": "Ebikumi", "Hours": "Essawa", "Minutes": "Edakiika", "Seconds": "Esekendzi", "Hrs": "Essawa", "Mins": "Edakiika", "Secs": "Esekendzi", "H": "E", "M": "D", "S": "S", "days": "ebikumi", "hours": "essawa", "minutes": "edakiika", "seconds": "esekendzi" }, "ka": { "Days": "áƒ“áƒ¦áƒ”áƒ”áƒ‘áƒ˜", "Hours": "áƒ¡áƒáƒáƒ—áƒ”áƒ‘áƒ˜", "Minutes": "áƒ¬áƒ£áƒ—áƒ”áƒ‘áƒ˜", "Seconds": "áƒ¬áƒáƒ›áƒ”áƒ‘áƒ˜", "Hrs": "áƒ¡áƒáƒáƒ—áƒ”áƒ‘áƒ˜", "Mins": "áƒ¬áƒ£áƒ—áƒ”áƒ‘áƒ˜", "Secs": "áƒ¬áƒáƒ›áƒ”áƒ‘áƒ˜", "H": "áƒ¡", "M": "áƒ¬", "S": "áƒ¬", "days": "áƒ“áƒ¦áƒ”áƒ”áƒ‘áƒ˜", "hours": "áƒ¡áƒáƒáƒ—áƒ”áƒ‘áƒ˜", "minutes": "áƒ¬áƒ£áƒ—áƒ”áƒ‘áƒ˜", "seconds": "áƒ¬áƒáƒ›áƒ”áƒ‘áƒ˜" }, "de": { "Days": "Tage", "Hours": "Std", "Minutes": "Protokoll", "Seconds": "Sekunden", "Hrs": "Std", "Mins": "Min", "Secs": "Sek", "H": "H", "M": "M", "S": "S", "days": "tags", "hours": "std", "minutes": "protokoll", "seconds": "sekunden" }, "de-DE": { "Days": "Tage", "Hours": "Std", "Minutes": "Protokoll", "Seconds": "Sekunden", "Hrs": "Std", "Mins": "Min", "Secs": "Sek", "H": "H", "M": "M", "S": "S", "days": "tags", "hours": "std", "minutes": "protokoll", "seconds": "sekunden" }, "el": { "Days": "Î—Î¼Î­ÏÎµÏ‚", "Hours": "ÎÏÎµÏ‚", "Minutes": "Î›ÎµÏ€Ï„Î¬", "Seconds": "Î”ÎµÏ…Ï„ÎµÏÏŒÎ»ÎµÏ€Ï„Î±", "Hrs": "ÎÏÎµÏ‚", "Mins": "Î›ÎµÏ€Ï„Î¬", "Secs": "Î”ÎµÏ…Ï„ÎµÏÏŒÎ»ÎµÏ€Ï„Î±", "H": "Î©", "M": "Î›", "S": "Î”", "days": "Î·Î¼Î­ÏÎµÏ‚", "hours": "ÏŽÏÎµÏ‚", "minutes": "Î»ÎµÏ€Ï„Î¬", "seconds": "Î´ÎµÏ…Ï„ÎµÏÏŒÎ»ÎµÏ€Ï„Î±" }, "gu": { "Days": "àª¦àª¿àªµàª¸", "Hours": "àª•àª²àª¾àª•", "Minutes": "àª®àª¿àª¨àª¿àªŸ", "Seconds": "àª¸à«‡àª•àª‚àª¡", "Hrs": "àª•àª²àª¾àª•", "Mins": "àª®àª¿àª¨àª¿àªŸ", "Secs": "àª¸à«‡àª•àª‚àª¡", "H": "àª•", "M": "àª®àª¿", "S": "àª¸à«‡", "days": "àª¦àª¿àªµàª¸", "hours": "àª•àª²àª¾àª•", "minutes": "àª®àª¿àª¨àª¿àªŸ", "seconds": "àª¸à«‡àª•àª‚àª¡" }, "ha": { "Days": "Ranar", "Hours": "Awa", "Minutes": "Minti", "Seconds": "DaÆ™iÆ™Æ™un", "Hrs": "Awa", "Mins": "Minti", "Secs": "DaÆ™iÆ™Æ™un", "H": "A", "M": "M", "S": "D", "days": "ranar", "hours": "awa", "minutes": "minti", "seconds": "daÆ™iÆ™Æ™un" }, "he": { "Days": "×™×ž×™×", "Hours": "×©×¢×•×ª", "Minutes": "×“×§×•×ª", "Seconds": "×©× ×™×•×ª", "Hrs": "×©×¢×•×ª", "Mins": "×“×§×•×ª", "Secs": "×©× ×™×•×ª", "H": "×©", "M": "×“", "S": "×©", "days": "×™×ž×™×", "hours": "×©×¢×•×ª", "minutes": "×“×§×•×ª", "seconds": "×©× ×™×•×ª" }, "hi": { "Days": "à¤¦à¤¿à¤¨", "Hours": "à¤˜à¤‚à¤Ÿà¥‡", "Minutes": "à¤®à¤¿à¤¨à¤Ÿ", "Seconds": "à¤¸à¥‡à¤•à¤‚à¤¡", "Hrs": "à¤˜à¤‚à¤Ÿà¥‡", "Mins": "à¤®à¤¿à¤¨à¤Ÿ", "Secs": "à¤¸à¥‡à¤•à¤‚à¤¡", "H": "à¤˜", "M": "à¤®à¤¿", "S": "à¤¸à¥‡", "days": "à¤¦à¤¿à¤¨", "hours": "à¤˜à¤‚à¤Ÿà¥‡", "minutes": "à¤®à¤¿à¤¨à¤Ÿ", "seconds": "à¤¸à¥‡à¤•à¤‚à¤¡" }, "hu": { "Days": "Nap", "Hours": "Ã“ra", "Minutes": "Perc", "Seconds": "MÃ¡sodperc", "Hrs": "Ã“ra", "Mins": "Perc", "Secs": "MÃ¡sodperc", "H": "Ã“", "M": "P", "S": "M", "days": "nap", "hours": "Ã³ra", "minutes": "perc", "seconds": "mÃ¡sodperc" }, "is": { "Days": "Dagar", "Hours": "Klukkustundir", "Minutes": "MÃ­nÃºtur", "Seconds": "SekÃºndur", "Hrs": "Klst", "Mins": "MÃ­n", "Secs": "Sek", "H": "K", "M": "M", "S": "S", "days": "dagar", "hours": "klukkustundir", "minutes": "mÃ­nÃºtur", "seconds": "sekÃºndur" }, "ig": { "Days": "Uká»¥", "Hours": "Elekere", "Minutes": "Nkeji", "Seconds": "Otu", "Hrs": "Elekere", "Mins": "Nkeji", "Secs": "Otu", "H": "E", "M": "N", "S": "O", "days": "uká»¥", "hours": "elekere", "minutes": "nkeji", "seconds": "otu" }, "id": { "Days": "Hari", "Hours": "Jam", "Minutes": "Menit", "Seconds": "Detik", "Hrs": "Jam", "Mins": "Menit", "Secs": "Detik", "H": "J", "M": "M", "S": "D", "days": "hari", "hours": "jam", "minutes": "menit", "seconds": "detik" }, "ia": { "Days": "Dies", "Hours": "Horas", "Minutes": "Minutos", "Seconds": "Secundos", "Hrs": "Horas", "Mins": "Minutos", "Secs": "Secundos", "H": "H", "M": "M", "S": "S", "days": "dies", "hours": "horas", "minutes": "minutos", "seconds": "secundos" }, "ga": { "Days": "Laethanta", "Hours": "Uaireanta", "Minutes": "NÃ³imÃ©ad", "Seconds": "Soicind", "Hrs": "Uaireanta", "Mins": "NÃ³imÃ©ad", "Secs": "Soicind", "H": "U", "M": "N", "S": "S", "days": "laethanta", "hours": "uaireanta", "minutes": "nÃ³imÃ©ad", "seconds": "soicind" }, "it": { "Days": "Giorni", "Hours": "Ore", "Minutes": "Minuti", "Seconds": "Secondi", "Hrs": "Ore", "Mins": "Minuti", "Secs": "Secondi", "H": "O", "M": "M", "S": "S", "days": "giorni", "hours": "ore", "minutes": "minuti", "seconds": "secondi" }, "ja": { "Days": "æ—¥", "Hours": "æ™‚é–“", "Minutes": "åˆ†", "Seconds": "ç§’", "Hrs": "æ™‚é–“", "Mins": "åˆ†", "Secs": "ç§’", "H": "æ™‚", "M": "åˆ†", "S": "ç§’", "days": "æ—¥", "hours": "æ™‚é–“", "minutes": "åˆ†", "seconds": "ç§’" }, "jv": { "Days": "Dina", "Hours": "Jam", "Minutes": "Menit", "Seconds": "Detik", "Hrs": "Jam", "Mins": "Menit", "Secs": "Detik", "H": "J", "M": "M", "S": "D", "days": "dina", "hours": "jam", "minutes": "menit", "seconds": "detik" }, "kl": { "Days": "Ukiut", "Hours": "Tunniit", "Minutes": "Minutit", "Seconds": "Sekundit", "Hrs": "Tunniit", "Mins": "Minutit", "Secs": "Sekundit", "H": "T", "M": "M", "S": "S", "days": "ukiut", "hours": "tunniit", "minutes": "minutit", "seconds": "sekundit" }, "kn": { "Days": "à²¦à²¿à²¨à²—à²³à³", "Hours": "à²—à²‚à²Ÿà³†à²—à²³à³", "Minutes": "à²¨à²¿à²®à²¿à²·à²—à²³à³", "Seconds": "à²¸à³†à²•à³†à²‚à²¡à³à²—à²³à³", "Hrs": "à²—à²‚à²Ÿà³†à²—à²³à³", "Mins": "à²¨à²¿à²®à²¿à²·à²—à²³à³", "Secs": "à²¸à³†à²•à³†à²‚à²¡à³à²—à²³à³", "H": "à²—", "M": "à²¨", "S": "à²¸à³†", "days": "à²¦à²¿à²¨à²—à²³à³", "hours": "à²—à²‚à²Ÿà³†à²—à²³à³", "minutes": "à²¨à²¿à²®à²¿à²·à²—à²³à³", "seconds": "à²¸à³†à²•à³†à²‚à²¡à³à²—à²³à³" }, "ks": { "Days": "Ø±ÙˆØ²", "Hours": "Ú¯Ú¾Ù†Ù¹Û’", "Minutes": "Ù…Ù†Ù¹", "Seconds": "Ø³ÛŒÚ©Ù†Úˆ", "Hrs": "Ú¯Ú¾Ù†Ù¹Û’", "Mins": "Ù…Ù†Ù¹", "Secs": "Ø³ÛŒÚ©Ù†Úˆ", "H": "Ú¯", "M": "Ù…", "S": "Ø³", "days": "Ø±ÙˆØ²", "hours": "Ú¯Ú¾Ù†Ù¹Û’", "minutes": "Ù…Ù†Ù¹", "seconds": "Ø³ÛŒÚ©Ù†Úˆ" }, "kk": { "Days": "ÐšÒ¯Ð½", "Hours": "Ð¡Ð°Ò“Ð°Ñ‚", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ð¡Ð°Ò“Ð°Ñ‚", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ð¡", "M": "Ðœ", "S": "Ð¡", "days": "ÐºÒ¯Ð½", "hours": "ÑÐ°Ò“Ð°Ñ‚", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "km": { "Days": "ážáŸ’áž„áŸƒ", "Hours": "áž˜áŸ‰áŸ„áž„", "Minutes": "áž“áž¶áž‘áž¸", "Seconds": "ážœáž·áž“áž¶áž‘áž¸", "Hrs": "áž˜áŸ‰áŸ„áž„", "Mins": "áž“áž¶áž‘áž¸", "Secs": "ážœáž·áž“áž¶áž‘áž¸", "H": "áž˜áŸ‰áŸ„áž„", "M": "áž“áž¶áž‘áž¸", "S": "ážœáž·áž“áž¶áž‘áž¸", "days": "ážáŸ’áž„áŸƒ", "hours": "áž˜áŸ‰áŸ„áž„", "minutes": "áž“áž¶áž‘áž¸", "seconds": "ážœáž·áž“áž¶áž‘áž¸" }, "ki": { "Days": "MÄ©Ä©", "Hours": "Saa", "Minutes": "Dakika", "Seconds": "Sekunde", "Hrs": "Saa", "Mins": "Dakika", "Secs": "Sekunde", "H": "S", "M": "D", "S": "S", "days": "mÄ©Ä©", "hours": "saa", "minutes": "dakika", "seconds": "sekunde" }, "rw": { "Days": "Imyaka", "Hours": "Ama saa", "Minutes": "Ama minuti", "Seconds": "Ama segonde", "Hrs": "Ama saa", "Mins": "Ama minuti", "Secs": "Ama segonde", "H": "S", "M": "M", "S": "S", "days": "imyaka", "hours": "ama saa", "minutes": "ama minuti", "seconds": "ama segonde" }, "ko": { "Days": "ì¼", "Hours": "ì‹œê°„", "Minutes": "ë¶„", "Seconds": "ì´ˆ", "Hrs": "ì‹œê°„", "Mins": "ë¶„", "Secs": "ì´ˆ", "H": "ì‹œ", "M": "ë¶„", "S": "ì´ˆ", "days": "ì¼", "hours": "ì‹œê°„", "minutes": "ë¶„", "seconds": "ì´ˆ" }, "ku": { "Days": "Roj", "Hours": "Saet", "Minutes": "DeqÃ®qeyan", "Seconds": "Sekund", "Hrs": "Saet", "Mins": "DeqÃ®qeyan", "Secs": "Sekund", "H": "S", "M": "D", "S": "S", "days": "roj", "hours": "saet", "minutes": "deqÃ®qeyan", "seconds": "sekund" }, "ky": { "Days": "ÐšÒ¯Ð½", "Hours": "Ð¡Ð°Ð°Ñ‚", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ð¡Ð°Ð°Ñ‚", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ð¡", "M": "Ðœ", "S": "Ð¡", "days": "ÐºÒ¯Ð½", "hours": "ÑÐ°Ð°Ñ‚", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "lo": { "Days": "àº¡àº·à»‰", "Hours": "àºŠàº»à»ˆàº§à»‚àº¡àº‡", "Minutes": "àº™àº²àº—àºµ", "Seconds": "àº§àº´àº™àº²àº—àºµ", "Hrs": "àºŠàº»à»ˆàº§à»‚àº¡àº‡", "Mins": "àº™àº²àº—àºµ", "Secs": "àº§àº´àº™àº²àº—àºµ", "H": "àºŠ", "M": "àº™", "S": "àº§", "days": "àº¡àº·à»‰", "hours": "àºŠàº»à»ˆàº§à»‚àº¡àº‡", "minutes": "àº™àº²àº—àºµ", "seconds": "àº§àº´àº™àº²àº—àºµ" }, "lv": { "Days": "Dienas", "Hours": "Stundas", "Minutes": "MinÅ«tes", "Seconds": "Sekundes", "Hrs": "Stundas", "Mins": "MinÅ«tes", "Secs": "Sekundes", "H": "S", "M": "M", "S": "S", "days": "dienas", "hours": "stundas", "minutes": "minÅ«tes", "seconds": "sekundes" }, "ln": { "Days": "Bomoi", "Hours": "MpuÉ›lÉ›", "Minutes": "MinÃºtÉ›", "Seconds": "SÃ©kÉ”ndi", "Hrs": "MpuÉ›lÉ›", "Mins": "MinÃºtÉ›", "Secs": "SÃ©kÉ”ndi", "H": "M", "M": "M", "S": "S", "days": "bomoi", "hours": "mpuÉ›lÉ›", "minutes": "minÃºtÉ›", "seconds": "sÃ©kÉ”ndi" }, "lt": { "Days": "Dienos", "Hours": "Valandos", "Minutes": "MinutÄ—s", "Seconds": "SekundÄ—s", "Hrs": "Valandos", "Mins": "MinutÄ—s", "Secs": "SekundÄ—s", "H": "H", "M": "M", "S": "S", "days": "dienos", "hours": "valandos", "minutes": "minutÄ—s", "seconds": "sekundÄ—s" }, "lu": { "Days": "Bisangala", "Hours": "Ngonga", "Minutes": "MinÃºta", "Seconds": "SÃ©konde", "Hrs": "Ngonga", "Mins": "MinÃºta", "Secs": "SÃ©konde", "H": "H", "M": "M", "S": "S", "days": "bisangala", "hours": "ngonga", "minutes": "minÃºta", "seconds": "sÃ©konde" }, "lb": { "Days": "Deeg", "Hours": "Stonnen", "Minutes": "Minuten", "Seconds": "Sekonnen", "Hrs": "Stonnen", "Mins": "Minuten", "Secs": "Sekonnen", "H": "S", "M": "M", "S": "S", "days": "deeg", "hours": "stonnen", "minutes": "minuten", "seconds": "sekonnen" }, "mk": { "Days": "Ð”ÐµÐ½Ð¾Ð²Ð¸", "Hours": "Ð§Ð°ÑÐ¾Ð²Ð¸", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚Ð¸", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "Hrs": "Ð§Ð°ÑÐ¾Ð²Ð¸", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚Ð¸", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "H": "Ð§", "M": "Ðœ", "S": "Ð¡", "days": "Ð´ÐµÐ½Ð¾Ð²Ð¸", "hours": "Ñ‡Ð°ÑÐ¾Ð²Ð¸", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚Ð¸", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ð¸" }, "mg": { "Days": "Andro", "Hours": "Ora", "Minutes": "Minitra", "Seconds": "Segondra", "Hrs": "Ora", "Mins": "Minitra", "Secs": "Segondra", "H": "O", "M": "M", "S": "S", "days": "andro", "hours": "ora", "minutes": "minitra", "seconds": "segondra" }, "ms": { "Days": "Hari", "Hours": "Jam", "Minutes": "Minit", "Seconds": "Saat", "Hrs": "Jam", "Mins": "Minit", "Secs": "Saat", "H": "J", "M": "M", "S": "S", "days": "hari", "hours": "jam", "minutes": "minit", "seconds": "saat" }, "ml": { "Days": "à´¦à´¿à´µà´¸à´‚", "Hours": "à´®à´£à´¿à´•àµà´•àµ‚àµ¼", "Minutes": "à´®à´¿à´¨à´¿à´±àµà´±àµ", "Seconds": "à´¸àµ†à´•àµà´•à´¨àµà´±àµ", "Hrs": "à´®à´£à´¿à´•àµà´•àµ‚àµ¼", "Mins": "à´®à´¿à´¨à´¿à´±àµà´±àµ", "Secs": "à´¸àµ†à´•àµà´•à´¨àµà´±àµ", "H": "à´®à´£à´¿", "M": "à´®à´¿à´¨à´¿", "S": "à´¸àµ†à´•àµà´•àµ»à´±àµ", "days": "à´¦à´¿à´µà´¸à´‚", "hours": "à´®à´£à´¿à´•àµà´•àµ‚àµ¼", "minutes": "à´®à´¿à´¨à´¿à´±àµà´±àµ", "seconds": "à´¸àµ†à´•àµà´•à´¨àµà´±àµ" }, "mt": { "Days": "Jiem", "Hours": "SigÄ§at", "Minutes": "Minuti", "Seconds": "Sekondi", "Hrs": "SigÄ§at", "Mins": "Minuti", "Secs": "Sekondi", "H": "S", "M": "M", "S": "S", "days": "jiem", "hours": "sigÄ§at", "minutes": "minuti", "seconds": "sekondi" }, "gv": { "Days": "Laaghyn", "Hours": "Oor", "Minutes": "Ooyllyn", "Seconds": "Sekunnyn", "Hrs": "Oor", "Mins": "Ooyllyn", "Secs": "Sekunnyn", "H": "O", "M": "O", "S": "S", "days": "laaghyn", "hours": "oor", "minutes": "ooyllyn", "seconds": "sekunnyn" }, "mr": { "Days": "à¤¦à¤¿à¤µà¤¸", "Hours": "à¤¤à¤¾à¤¸", "Minutes": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¥‡", "Seconds": "à¤¸à¥‡à¤•à¤‚à¤¦", "Hrs": "à¤¤à¤¾à¤¸", "Mins": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¥‡", "Secs": "à¤¸à¥‡à¤•à¤‚à¤¦", "H": "à¤¤à¤¾", "M": "à¤®à¤¿", "S": "à¤¸à¥‡", "days": "à¤¦à¤¿à¤µà¤¸", "hours": "à¤¤à¤¾à¤¸", "minutes": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¥‡", "seconds": "à¤¸à¥‡à¤•à¤‚à¤¦" }, "mn": { "Days": "Ó¨Ð´Ó©Ñ€", "Hours": "Ð¦Ð°Ð³", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ð¦Ð°Ð³", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ð¦", "M": "Ðœ", "S": "Ð¡", "days": "Ó©Ð´Ó©Ñ€", "hours": "Ñ†Ð°Ð³", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "mi": { "Days": "NgÄ rÄ", "Hours": "Haora", "Minutes": "Meneti", "Seconds": "HÄ“kona", "Hrs": "Haora", "Mins": "Meneti", "Secs": "HÄ“kona", "H": "H", "M": "M", "S": "S", "days": "ngÄ rÄ", "hours": "haora", "minutes": "meneti", "seconds": "hÄ“kona" }, "ne": { "Days": "à¤¦à¤¿à¤¨à¤¹à¤°à¥‚", "Hours": "à¤˜à¤£à¥à¤Ÿà¤¾", "Minutes": "à¤®à¤¿à¤¨à¥‡à¤Ÿ", "Seconds": "à¤¸à¥‡à¤•à¥‡à¤¨à¥à¤¡", "Hrs": "à¤˜à¤£à¥à¤Ÿà¤¾", "Mins": "à¤®à¤¿à¤¨à¥‡à¤Ÿ", "Secs": "à¤¸à¥‡à¤•à¥‡à¤¨à¥à¤¡", "H": "à¤˜", "M": "à¤®à¤¿", "S": "à¤¸à¥‡", "days": "à¤¦à¤¿à¤¨à¤¹à¤°à¥‚", "hours": "à¤˜à¤£à¥à¤Ÿà¤¾", "minutes": "à¤®à¤¿à¤¨à¥‡à¤Ÿ", "seconds": "à¤¸à¥‡à¤•à¥‡à¤¨à¥à¤¡" }, "nd": { "Days": "Imihla", "Hours": "Ihora", "Minutes": "Iminithi", "Seconds": "Isekhondi", "Hrs": "Ihora", "Mins": "Iminithi", "Secs": "Isekhondi", "H": "I", "M": "I", "S": "I", "days": "imihla", "hours": "ihora", "minutes": "iminiti", "seconds": "isekhondi" }, "se": { "Days": "Beaivi", "Hours": "Girji", "Minutes": "Minuhta", "Seconds": "Secoonda", "Hrs": "Girji", "Mins": "Minuhta", "Secs": "Secoonda", "H": "G", "M": "M", "S": "S", "days": "beaivi", "hours": "girji", "minutes": "minuhta", "seconds": "secoonda" }, "no": { "Days": "Dager", "Hours": "Timer", "Minutes": "Minutter", "Seconds": "Sekunder", "Hrs": "Timer", "Mins": "Minutter", "Secs": "Sekunder", "H": "T", "M": "M", "S": "S", "days": "dager", "hours": "timer", "minutes": "minutter", "seconds": "sekunder" }, "nb": { "Days": "Dager", "Hours": "Timer", "Minutes": "Minutter", "Seconds": "Sekunder", "Hrs": "Timer", "Mins": "Minutter", "Secs": "Sekunder", "H": "T", "M": "M", "S": "S", "days": "dager", "hours": "timer", "minutes": "minutter", "seconds": "sekunder" }, "nn": { "Days": "Dagar", "Hours": "Timar", "Minutes": "Minutt", "Seconds": "Sekund", "Hrs": "Timar", "Mins": "Minutt", "Secs": "Sekund", "H": "T", "M": "M", "S": "S", "days": "dagar", "hours": "timar", "minutes": "minutt", "seconds": "sekund" }, "or": { "Days": "à¬¦à¬¿à¬¨", "Hours": "à¬˜à¬£à­à¬Ÿà¬¾", "Minutes": "à¬®à¬¿à¬¨à¬¿à¬Ÿ", "Seconds": "à¬¸à­‡à¬•à¬£à­à¬¢", "Hrs": "à¬˜à¬£à­à¬Ÿà¬¾", "Mins": "à¬®à¬¿à¬¨à¬¿à¬Ÿ", "Secs": "à¬¸à­‡à¬•à¬£à­à¬¢", "H": "à¬˜", "M": "à¬®à¬¿", "S": "à¬¸à­‡", "days": "à¬¦à¬¿à¬¨", "hours": "à¬˜à¬£à­à¬Ÿà¬¾", "minutes": "à¬®à¬¿à¬¨à¬¿à¬Ÿ", "seconds": "à¬¸à­‡à¬•à¬£à­à¬¢" }, "om": { "Days": "Guyyaa", "Hours": "Sa'a", "Minutes": "Daqiiqaa", "Seconds": "Kaayyoo", "Hrs": "Sa'a", "Mins": "Daqiiqaa", "Secs": "Kaayyoo", "H": "S", "M": "D", "S": "K", "days": "guyyaa", "hours": "sa'a", "minutes": "daqiiqaa", "seconds": "kaayyoo" }, "os": { "Days": "Ó”Ñ…Ñ‚Ó•Ð³Ñ‚Ó•", "Hours": "Ó”Ð½Ð´Ð¶Ñ‹Ð³Ñ‚Ó•", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚Ã¦", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ó”Ð½Ð´Ð¶Ñ‹Ð³Ñ‚Ó•", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚Ã¦", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ó”", "M": "Ðœ", "S": "Ð¡", "days": "Ó•Ñ…Ñ‚Ó•Ð³Ñ‚Ó•", "hours": "Ó•Ð½Ð´Ð¶Ñ‹Ð³Ñ‚Ó•", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚Ã¦", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "ps": { "Days": "ÙˆØ±Ú", "Hours": "Ø³Ø§Ø¹Øª", "Minutes": "Ø¯Ù‚ÛŒÙ‚Ù‡", "Seconds": "Ø«Ø§Ù†ÛŒÙ‡", "Hrs": "Ø³Ø§Ø¹Øª", "Mins": "Ø¯Ù‚ÛŒÙ‚Ù‡", "Secs": "Ø«Ø§Ù†ÛŒÙ‡", "H": "Ø³", "M": "Ø¯", "S": "Ø«", "days": "ÙˆØ±Ú", "hours": "Ø³Ø§Ø¹Øª", "minutes": "Ø¯Ù‚ÛŒÙ‚Ù‡", "seconds": "Ø«Ø§Ù†ÛŒÙ‡" }, "fa": { "Days": "Ø±ÙˆØ²", "Hours": "Ø³Ø§Ø¹Øª", "Minutes": "Ø¯Ù‚ÛŒÙ‚Ù‡", "Seconds": "Ø«Ø§Ù†ÛŒÙ‡", "Hrs": "Ø³Ø§Ø¹Øª", "Mins": "Ø¯Ù‚ÛŒÙ‚Ù‡", "Secs": "Ø«Ø§Ù†ÛŒÙ‡", "H": "Ø³", "M": "Ø¯", "S": "Ø«", "days": "Ø±ÙˆØ²", "hours": "Ø³Ø§Ø¹Øª", "minutes": "Ø¯Ù‚ÛŒÙ‚Ù‡", "seconds": "Ø«Ø§Ù†ÛŒÙ‡" }, "pl": { "Days": "Dni", "Hours": "Godziny", "Minutes": "Minuty", "Seconds": "Sekundy", "Hrs": "Godziny", "Mins": "Minuty", "Secs": "Sekundy", "H": "G", "M": "M", "S": "S", "days": "dni", "hours": "godziny", "minutes": "minuty", "seconds": "sekundy" }, "pt-BR": { "Days": "Dias", "Hours": "Horas", "Minutes": "Minutos", "Seconds": "Segundos", "Hrs": "Horas", "Mins": "Minutos", "Secs": "Segundos", "H": "H", "M": "M", "S": "S", "days": "dias", "hours": "horas", "minutes": "minutos", "seconds": "segundos" }, "pt-PT": { "Days": "Dias", "Hours": "Horas", "Minutes": "Minutos", "Seconds": "Segundos", "Hrs": "Horas", "Mins": "Minutos", "Secs": "Segundos", "H": "H", "M": "M", "S": "S", "days": "dias", "hours": "horas", "minutes": "minutos", "seconds": "segundos" }, "pa": { "Days": "à¨¦à¨¿à¨¨", "Hours": "à¨˜à©°à¨Ÿà©‡", "Minutes": "à¨®à¨¿à©°à¨Ÿ", "Seconds": "à¨¸à¨•à¨¿à©°à¨Ÿ", "Hrs": "à¨˜à©°à¨Ÿà©‡", "Mins": "à¨®à¨¿à©°à¨Ÿ", "Secs": "à¨¸à¨•à¨¿à©°à¨Ÿ", "H": "à¨˜", "M": "à¨®à¨¿", "S": "à¨¸", "days": "à¨¦à¨¿à¨¨", "hours": "à¨˜à©°à¨Ÿà©‡", "minutes": "à¨®à¨¿à©°à¨Ÿ", "seconds": "à¨¸à¨•à¨¿à©°à¨Ÿ" }, "qu": { "Days": "Ã‘iqin", "Hours": "Saqe", "Minutes": "Minutu", "Seconds": "Sekundu", "Hrs": "Saqe", "Mins": "Minutu", "Secs": "Sekundu", "H": "S", "M": "M", "S": "S", "days": "Ã±iqin", "hours": "saqe", "minutes": "minutu", "seconds": "sekundu" }, "ro": { "Days": "Zile", "Hours": "Ore", "Minutes": "Minute", "Seconds": "Secunde", "Hrs": "Ore", "Mins": "Minute", "Secs": "Secunde", "H": "O", "M": "M", "S": "S", "days": "zile", "hours": "ore", "minutes": "minute", "seconds": "secunde" }, "rm": { "Days": "Dias", "Hours": "Uras", "Minutes": "Minuts", "Seconds": "Secundas", "Hrs": "Uras", "Mins": "Minuts", "Secs": "Secundas", "H": "U", "M": "M", "S": "S", "days": "dias", "hours": "uras", "minutes": "minuts", "seconds": "secundas" }, "rn": { "Days": "Igisibo", "Hours": "Ama saa", "Minutes": "Amakuru", "Seconds": "Isekonedi", "Hrs": "Ama saa", "Mins": "Amakuru", "Secs": "Isekonedi", "H": "S", "M": "M", "S": "S", "days": "igisibo", "hours": "ama saa", "minutes": "amakuru", "seconds": "isekonedi" }, "ru": { "Days": "Ð”Ð½Ð¸", "Hours": "Ð§Ð°ÑÑ‹", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚Ñ‹", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ñ‹", "Hrs": "Ð§Ð°ÑÑ‹", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚Ñ‹", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ñ‹", "H": "Ð§", "M": "Ðœ", "S": "Ð¡", "days": "Ð´Ð½Ð¸", "hours": "Ñ‡Ð°ÑÑ‹", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚Ñ‹", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ñ‹" }, "sg": { "Days": "NgÃ y", "Hours": "Giá»", "Minutes": "PhÃºt", "Seconds": "GiÃ¢y", "Hrs": "Giá»", "Mins": "PhÃºt", "Secs": "GiÃ¢y", "H": "G", "M": "P", "S": "G", "days": "ngÃ y", "hours": "giá»", "minutes": "phÃºt", "seconds": "giÃ¢y" }, "sa": { "Days": "à¤¦à¤¿à¤¨à¤¾à¤ƒ", "Hours": "à¤˜à¤£à¥à¤Ÿà¤¾à¤ƒ", "Minutes": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¤¾à¤ƒ", "Seconds": "à¤¸à¥‡à¤•à¤‚à¤¡à¤¾à¤ƒ", "Hrs": "à¤˜à¤£à¥à¤Ÿà¤¾à¤ƒ", "Mins": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¤¾à¤ƒ", "Secs": "à¤¸à¥‡à¤•à¤‚à¤¡à¤¾à¤ƒ", "H": "à¤˜", "M": "à¤®à¤¿", "S": "à¤¸à¥‡", "days": "à¤¦à¤¿à¤¨à¤¾à¤ƒ", "hours": "à¤˜à¤£à¥à¤Ÿà¤¾à¤ƒ", "minutes": "à¤®à¤¿à¤¨à¤¿à¤Ÿà¤¾à¤ƒ", "seconds": "à¤¸à¥‡à¤•à¤‚à¤¡à¤¾à¤ƒ" }, "sc": { "Days": "Giornu", "Hours": "Oras", "Minutes": "Minuta", "Seconds": "Segundu", "Hrs": "Oras", "Mins": "Minuta", "Secs": "Segundu", "H": "O", "M": "M", "S": "S", "days": "giornu", "hours": "oras", "minutes": "minuta", "seconds": "segundu" }, "gd": { "Days": "Latha", "Hours": "Uairean", "Minutes": "Mionaidean", "Seconds": "Diog", "Hrs": "Uairean", "Mins": "Mionaidean", "Secs": "Diog", "H": "U", "M": "M", "S": "D", "days": "latha", "hours": "uairean", "minutes": "mionaidean", "seconds": "diog" }, "sr": { "Days": "Ð”Ð°Ð½Ð¸", "Hours": "Ð¡Ð°Ñ‚Ð¸", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚Ð°", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ðµ", "Hrs": "Ð¡Ð°Ñ‚Ð¸", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚Ð°", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ðµ", "H": "Ð¡", "M": "Ðœ", "S": "Ð¡", "days": "Ð´Ð°Ð½Ð¸", "hours": "ÑÐ°Ñ‚Ð¸", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚Ð°", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ðµ" }, "sn": { "Days": "Zuva", "Hours": "Masahora", "Minutes": "Miniti", "Seconds": "Seke", "Hrs": "Masahora", "Mins": "Miniti", "Secs": "Seke", "H": "M", "M": "M", "S": "S", "days": "zuva", "hours": "masahora", "minutes": "miniti", "seconds": "seke" }, "ii": { "Days": "ê‰êŒ ", "Hours": "ê‚°ê€‰", "Minutes": "ê„®ê‹„", "Seconds": "êˆ‡ê†ˆ", "Hrs": "ê‚°ê€‰", "Mins": "ê„®ê‹„", "Secs": "êˆ‡ê†ˆ", "H": "ê‚°", "M": "ê„®", "S": "êˆ‡", "days": "ê‰êŒ ", "hours": "ê‚°ê€‰", "minutes": "ê„®ê‹„", "seconds": "êˆ‡ê†ˆ" }, "sd": { "Days": "ÚÙŠÙ†Ù‡Ù†", "Hours": "ÚªÙ„Ø§Úª", "Minutes": "Ù…Ù†Ù½", "Seconds": "Ø³ÙŠÚªÙ†ÚŠ", "Hrs": "ÚªÙ„Ø§Úª", "Mins": "Ù…Ù†Ù½", "Secs": "Ø³ÙŠÚªÙ†ÚŠ", "H": "Úª", "M": "Ù…", "S": "Ø³", "days": "ÚÙŠÙ†Ù‡Ù†", "hours": "ÚªÙ„Ø§Úª", "minutes": "Ù…Ù†Ù½", "seconds": "Ø³ÙŠÚªÙ†ÚŠ" }, "si": { "Days": "à¶¯à·’à¶±", "Hours": "à¶´à·à¶º", "Minutes": "à¶¸à·’à¶±à·’à¶­à·Šà¶­à·”", "Seconds": "à¶­à¶­à·Šà¶´à¶»", "Hrs": "à¶´à·à¶º", "Mins": "à¶¸à·’à¶±à·’à¶­à·Šà¶­à·”", "Secs": "à¶­à¶­à·Šà¶´à¶»", "H": "à¶´", "M": "à¶¸à·’", "S": "à¶­", "days": "à¶¯à·’à¶±", "hours": "à¶´à·à¶º", "minutes": "à¶¸à·’à¶±à·’à¶­à·Šà¶­à·”", "seconds": "à¶­à¶­à·Šà¶´à¶»" }, "sk": { "Days": "Dni", "Hours": "Hodiny", "Minutes": "MinÃºty", "Seconds": "Sekundy", "Hrs": "Hodiny", "Mins": "MinÃºty", "Secs": "Sekundy", "H": "H", "M": "M", "S": "S", "days": "dni", "hours": "hodiny", "minutes": "minÃºty", "seconds": "sekundy" }, "sl": { "Days": "Dni", "Hours": "Ure", "Minutes": "Minute", "Seconds": "Sekunde", "Hrs": "Ure", "Mins": "Minute", "Secs": "Sekunde", "H": "U", "M": "M", "S": "S", "days": "dni", "hours": "ure", "minutes": "minute", "seconds": "sekunde" }, "so": { "Days": "Maalin", "Hours": "Saacadood", "Minutes": "Daqiiqo", "Seconds": "Ilmaan", "Hrs": "Saacadood", "Mins": "Daqiiqo", "Secs": "Ilmaan", "H": "S", "M": "D", "S": "I", "days": "maalin", "hours": "saacadood", "minutes": "daqiiqo", "seconds": "ilmaan" }, "es": { "Days": "DÃ­as", "Hours": "Horas", "Minutes": "Minutos", "Seconds": "Segundos", "Hrs": "Hrs", "Mins": "Mins", "Secs": "Segs", "H": "H", "M": "M", "S": "S", "days": "dÃ­as", "hours": "horas", "minutes": "minutos", "seconds": "segundos" }, "su": { "Days": "Dinten", "Hours": "Jam", "Minutes": "Menit", "Seconds": "Detik", "Hrs": "Jam", "Mins": "Menit", "Secs": "Detik", "H": "J", "M": "M", "S": "D", "days": "dinten", "hours": "jam", "minutes": "menit", "seconds": "detik" }, "sw": { "Days": "Siku", "Hours": "Saa", "Minutes": "Dakika", "Seconds": "Sekunde", "Hrs": "Saa", "Mins": "Dakika", "Secs": "Sekunde", "H": "S", "M": "D", "S": "S", "days": "siku", "hours": "saa", "minutes": "dakika", "seconds": "sekunde" }, "sv": { "Days": "Dagar", "Hours": "Timmar", "Minutes": "Minuter", "Seconds": "Sekunder", "Hrs": "Timmar", "Mins": "Minuter", "Secs": "Sekunder", "H": "H", "M": "M", "S": "S", "days": "dagar", "hours": "timmar", "minutes": "minuter", "seconds": "sekunder" }, "tg": { "Days": "Ð Ó¯Ð·", "Hours": "Ð¡Ð¾Ð°Ñ‚", "Minutes": "Ð”Ð°Ò›Ð¸Ò›Ð°", "Seconds": "Ð¡Ð¾Ð½Ð¸Ñ", "Hrs": "Ð¡Ð¾Ð°Ñ‚", "Mins": "Ð”Ð°Ò›Ð¸Ò›Ð°", "Secs": "Ð¡Ð¾Ð½Ð¸Ñ", "H": "Ð¡", "M": "Ð”", "S": "Ð¡", "days": "Ñ€Ó¯Ð·", "hours": "ÑÐ¾Ð°Ñ‚", "minutes": "Ð´Ð°Ò›Ð¸Ò›Ð°", "seconds": "ÑÐ¾Ð½Ð¸Ñ" }, "ta": { "Days": "à®¨à®¾à®Ÿà¯à®•à®³à¯", "Hours": "à®®à®£à®¿à®¨à¯‡à®°à®®à¯", "Minutes": "à®¨à®¿à®®à®¿à®Ÿà®™à¯à®•à®³à¯", "Seconds": "à®µà®¿à®©à®¾à®Ÿà®¿à®•à®³à¯", "Hrs": "à®®à®£à®¿à®¨à¯‡à®°à®®à¯", "Mins": "à®¨à®¿à®®à®¿à®Ÿà®™à¯à®•à®³à¯", "Secs": "à®µà®¿à®©à®¾à®Ÿà®¿à®•à®³à¯", "H": "à®®", "M": "à®¨à®¿", "S": "à®µà®¿", "days": "à®¨à®¾à®Ÿà¯à®•à®³à¯", "hours": "à®®à®£à®¿à®¨à¯‡à®°à®®à¯", "minutes": "à®¨à®¿à®®à®¿à®Ÿà®™à¯à®•à®³à¯", "seconds": "à®µà®¿à®©à®¾à®Ÿà®¿à®•à®³à¯" }, "tt": { "Days": "ÐšÓ©Ð½", "Hours": "Ð¡Ó™Ð³Ð°Ñ‚ÑŒ", "Minutes": "ÐœÐ¸Ð½ÑƒÑ‚", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´", "Hrs": "Ð¡Ó™Ð³Ð°Ñ‚ÑŒ", "Mins": "ÐœÐ¸Ð½ÑƒÑ‚", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´", "H": "Ð¡", "M": "Ðœ", "S": "Ð¡", "days": "ÐºÓ©Ð½", "hours": "ÑÓ™Ð³Ð°Ñ‚ÑŒ", "minutes": "Ð¼Ð¸Ð½ÑƒÑ‚", "seconds": "ÑÐµÐºÑƒÐ½Ð´" }, "te": { "Days": "à°°à±‹à°œà±à°²à±", "Hours": "à°—à°‚à°Ÿà°²à±", "Minutes": "à°¨à°¿à°®à°¿à°·à°¾à°²à±", "Seconds": "à°¸à±†à°•à°¨à±à°²à±", "Hrs": "à°—à°‚à°Ÿà°²à±", "Mins": "à°¨à°¿à°®à°¿à°·à°¾à°²à±", "Secs": "à°¸à±†à°•à°¨à±à°²à±", "H": "à°—", "M": "à°¨à°¿", "S": "à°¸à±†", "days": "à°°à±‹à°œà±à°²à±", "hours": "à°—à°‚à°Ÿà°²à±", "minutes": "à°¨à°¿à°®à°¿à°·à°¾à°²à±", "seconds": "à°¸à±†à°•à°¨à±à°²à±" }, "th": { "Days": "à¸§à¸±à¸™", "Hours": "à¸Šà¸±à¹ˆà¸§à¹‚à¸¡à¸‡", "Minutes": "à¸™à¸²à¸—à¸µ", "Seconds": "à¸§à¸´à¸™à¸²à¸—à¸µ", "Hrs": "à¸Šà¸±à¹ˆà¸§à¹‚à¸¡à¸‡", "Mins": "à¸™à¸²à¸—à¸µ", "Secs": "à¸§à¸´à¸™à¸²à¸—à¸µ", "H": "à¸Šà¸¡.", "M": "à¸™à¸².", "S": "à¸§à¸´.", "days": "à¸§à¸±à¸™", "hours": "à¸Šà¸±à¹ˆà¸§à¹‚à¸¡à¸‡", "minutes": "à¸™à¸²à¸—à¸µ", "seconds": "à¸§à¸´à¸™à¸²à¸—à¸µ" }, "bo": { "Days": "à½‰à½²à½“à¼‹à½šà½ºà½¦à¼", "Hours": "à½†à½´à¼‹à½šà½¼à½‘à¼", "Minutes": "à½¦à¾à½¢à¼", "Seconds": "à½¦à¾à½¢à¼", "Hrs": "à½†à½´à¼‹à½šà½¼à½‘à¼", "Mins": "à½¦à¾à½¢à¼", "Secs": "à½¦à¾à½¢à¼", "H": "à½†à½´à¼", "M": "à½¦à¾à½¢à¼", "S": "à½¦à¾à½¢à¼", "days": "à½‰à½²à½“à¼‹à½šà½ºà½¦à¼", "hours": "à½†à½´à¼‹à½šà½¼à½‘à¼", "minutes": "à½¦à¾à½¢à¼", "seconds": "à½¦à¾à½¢à¼" }, "ti": { "Days": "á‰€áŠ•", "Hours": "áˆ°á‹“á‰µ", "Minutes": "á‹°á‰‚á‰ƒá‹Žá‰½", "Seconds": "áˆ°áŠ¨áŠ•á‹¶á‰½", "Hrs": "áˆ°á‹“á‰µ", "Mins": "á‹°á‰‚á‰ƒá‹Žá‰½", "Secs": "áˆ°áŠ¨áŠ•á‹¶á‰½", "H": "áˆ°", "M": "á‹°", "S": "áˆ°", "days": "á‰€áŠ•", "hours": "áˆ°á‹“á‰µ", "minutes": "á‹°á‰‚á‰ƒá‹Žá‰½", "seconds": "áˆ°áŠ¨áŠ•á‹¶á‰½" }, "to": { "Days": "Ê»Aho", "Hours": "Houa", "Minutes": "Miniti", "Seconds": "Sekoni", "Hrs": "Houa", "Mins": "Miniti", "Secs": "Sekoni", "H": "H", "M": "M", "S": "S", "days": "Ê»aho", "hours": "houa", "minutes": "miniti", "seconds": "sekoni" }, "tr": { "Days": "GÃ¼n", "Hours": "Saat", "Minutes": "Dakika", "Seconds": "Saniye", "Hrs": "Saat", "Mins": "Dakika", "Secs": "Saniye", "H": "S", "M": "D", "S": "S", "days": "gÃ¼n", "hours": "saat", "minutes": "dakika", "seconds": "saniye" }, "tk": { "Days": "GÃ¼n", "Hours": "AgÅŸam", "Minutes": "MÃ¼Åˆ", "Seconds": "Saniye", "Hrs": "AgÅŸam", "Mins": "MÃ¼Åˆ", "Secs": "Saniye", "H": "A", "M": "M", "S": "S", "days": "gÃ¼n", "hours": "agÅŸam", "minutes": "mÃ¼Åˆ", "seconds": "saniye" }, "uk": { "Days": "Ð”Ð½Ñ–", "Hours": "Ð“Ð¾Ð´Ð¸Ð½Ð¸", "Minutes": "Ð¥Ð²Ð¸Ð»Ð¸Ð½Ð¸", "Seconds": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "Hrs": "Ð“Ð¾Ð´Ð¸Ð½Ð¸", "Mins": "Ð¥Ð²Ð¸Ð»Ð¸Ð½Ð¸", "Secs": "Ð¡ÐµÐºÑƒÐ½Ð´Ð¸", "H": "Ð“", "M": "Ð¥", "S": "Ð¡", "days": "Ð´Ð½Ñ–", "hours": "Ð³Ð¾Ð´Ð¸Ð½Ð¸", "minutes": "Ñ…Ð²Ð¸Ð»Ð¸Ð½Ð¸", "seconds": "ÑÐµÐºÑƒÐ½Ð´Ð¸" }, "ur": { "Days": "Ø¯Ù†", "Hours": "Ú¯Ú¾Ù†Ù¹Û’", "Minutes": "Ù…Ù†Ù¹", "Seconds": "Ø³ÛŒÚ©Ù†Úˆ", "Hrs": "Ú¯Ú¾Ù†Ù¹Û’", "Mins": "Ù…Ù†Ù¹", "Secs": "Ø³ÛŒÚ©Ù†Úˆ", "H": "Ú¯Ú¾", "M": "Ù…", "S": "Ø³", "days": "Ø¯Ù†", "hours": "Ú¯Ú¾Ù†Ù¹Û’", "minutes": "Ù…Ù†Ù¹", "seconds": "Ø³ÛŒÚ©Ù†Úˆ" }, "ug": { "Days": "ÙƒÛˆÙ†", "Hours": "Ø³Ø§Ø¦Û•Øª", "Minutes": "Ù…Ù‰Ù†Û‡Øª", "Seconds": "Ø³ÛÙƒÛ‡Ù†Øª", "Hrs": "Ø³Ø§Ø¦Û•Øª", "Mins": "Ù…Ù‰Ù†Û‡Øª", "Secs": "Ø³ÛÙƒÛ‡Ù†Øª", "H": "Ø³", "M": "Ù…", "S": "Ø³", "days": "ÙƒÛˆÙ†", "hours": "Ø³Ø§Ø¦Û•Øª", "minutes": "Ù…Ù‰Ù†Û‡Øª", "seconds": "Ø³ÛÙƒÛ‡Ù†Øª" }, "vi": { "Days": "NgÃ y", "Hours": "Giá»", "Minutes": "PhÃºt", "Seconds": "GiÃ¢y", "Hrs": "Giá»", "Mins": "PhÃºt", "Secs": "GiÃ¢y", "H": "G", "M": "P", "S": "G", "days": "ngÃ y", "hours": "giá»", "minutes": "phÃºt", "seconds": "giÃ¢y" }, "cy": { "Days": "Diwrnodau", "Hours": "Awr", "Minutes": "Munudau", "Seconds": "Eiliadau", "Hrs": "Awr", "Mins": "Munudau", "Secs": "Eiliadau", "H": "A", "M": "M", "S": "E", "days": "diwrnodau", "hours": "awr", "minutes": "munudau", "seconds": "eiliadau" }, "fy": { "Days": "Deien", "Hours": "Oeren", "Minutes": "Minuten", "Seconds": "Seconden", "Hrs": "Oeren", "Mins": "Minuten", "Secs": "Seconden", "H": "O", "M": "M", "S": "S", "days": "deien", "hours": "oeren", "minutes": "minuten", "seconds": "seconden" }, "wo": { "Days": "JÃ ngoo", "Hours": "Ã‘aari", "Minutes": "Minit", "Seconds": "SekÃ³nd", "Hrs": "Ã‘aari", "Mins": "Minit", "Secs": "SekÃ³nd", "H": "Ã‘", "M": "M", "S": "S", "days": "jÃ ngoo", "hours": "Ã±aari", "minutes": "minit", "seconds": "sekÃ³nd" }, "xh": { "Days": "Imihla", "Hours": "Ihora", "Minutes": "Imizuzu", "Seconds": "Isekhondi", "Hrs": "Ihora", "Mins": "Imizuzu", "Secs": "Isekhondi", "H": "I", "M": "I", "S": "I", "days": "imihla", "hours": "ihora", "minutes": "imizuzu", "seconds": "isekhondi" }, "yi": { "Days": "×˜×¢×’", "Hours": "×©×¢×”", "Minutes": "×ž×™× ×•×˜", "Seconds": "×–×¢×§×•× ×˜", "Hrs": "×©×¢×”", "Mins": "×ž×™× ×•×˜", "Secs": "×–×¢×§×•× ×˜", "H": "×©×¢×”", "M": "×ž×™× ×•×˜", "S": "×–×¢×§×•× ×˜", "days": "×˜×¢×’", "hours": "×©×¢×”", "minutes": "×ž×™× ×•×˜", "seconds": "×–×¢×§×•× ×˜" }, "yo": { "Days": "á»Œjá»Ì", "Hours": "WÃ¡kÃ tÃ­", "Minutes": "ÃŒsáº¹ÌjÃº", "Seconds": "ÃŒsáº¹ÌjÃº", "Hrs": "WÃ¡kÃ tÃ­", "Mins": "ÃŒsáº¹ÌjÃº", "Secs": "ÃŒsáº¹ÌjÃº", "H": "W", "M": "ÃŒ", "S": "ÃŒ", "days": "á»já»Ì", "hours": "wÃ¡kÃ tÃ­", "minutes": "Ã¬sáº¹ÌjÃº", "seconds": "Ã¬sáº¹ÌjÃº" }, "zu": { "Days": "Imihla", "Hours": "Izinsuku", "Minutes": "Iminithi", "Seconds": "Isekhondi", "Hrs": "Izinsuku", "Mins": "Iminithi", "Secs": "Isekhondi", "H": "I", "M": "I", "S": "I", "days": "imihla", "hours": "izinsuku", "minutes": "iminithi", "seconds": "isekhondi" } }

  var selected_checker_country = '';
  var country_checker_active = '0';

  var edd_cart_max_day = '';
  var edd_cart_min_day = '';

  var translation_obj = 'not_set';
  var translation_obj_for_all_language = 'not_set';

  var sb_edd_store_locatore_enable = 0;

  var change_date_to_today_tomorrow = false
  apply_today_tomorrow = sb_edd_options.apply_today_tomorrow;
  if (typeof apply_today_tomorrow != 'undefined') {
    if (apply_today_tomorrow == 1) {
      change_date_to_today_tomorrow = true;
    }else{
      change_date_to_today_tomorrow = false
    }
  }

  var zipcode_widget_title = checkUndefined('zipcode_widget_title', 'Check Your Product Availability');
  var zipcode_unserviceable_msg = checkUndefined("zipcode_unserviceable_msg", "Unfortunately, this product is not available in your area");
  var zipcode_empty_msg = checkUndefined("zipcode_empty_msg", "Please Enter a Zipcode");
  var zipcode_input_placeholder = checkUndefined("zipcode_input_placeholder", "Hint:35004,36925");
  var zipcode_button_text = checkUndefined("zipcode_button_text", "Check");
  var widget_btn_txt_hvr_color = checkUndefined("widget_btn_txt_hvr_color", "#fff");
  var widget_btn_txt_color = checkUndefined("widget_btn_txt_color", "#fff");
  var widget_btn_hvr_color = checkUndefined("widget_btn_hvr_color", "#000");
  var widget_btn_bg_color = checkUndefined("widget_btn_bg_color", "#000");
  var good_evas_customization = '0';
  var good_evas_max_date = 'not_set';
  
  var mayuri_customization = '0';
  if (shopnamefull == 'bijoux-mayuri.myshopify.com') {
    mayuri_customization = 1;
  }

  var healthy_meals_customization = '0';
  if (typeof sb_edd_options.healthy_meals_customization != 'undefined') {
    healthy_meals_customization = sb_edd_options.healthy_meals_customization;
  }
  var show_only_one_cart_date = '0';
  if (typeof add_one_cart_date != 'undefined') {
    var show_only_one_cart_date = '1';
  }


  /* get userfulldate */
  var donotupdateEDDmessage = '0';

  function getCurrentDateOfStoreAndUser(todayDate) {

    var format = "AM";
    var hour = todayDate.getHours();
    var min = todayDate.getMinutes();
    if (hour > 11) { format = "PM"; }
    if (hour > 12) { hour = hour - 12; }
    if (hour == 0) { hour = 12; }
    if (min < 10) { min = "0" + min; }

    current_date = todayDate.getMonth() + 1 + "/" + todayDate.getDate() + "/" + todayDate.getFullYear();
    current_time = hour + ":" + min + " " + format;
    return { current_date: current_date, current_time: current_time };
  }
  todayDate = new Date();
  user_current_time = getCurrentDateOfStoreAndUser(todayDate);
  user_current_time = user_current_time.current_date + ' ' + user_current_time.current_time;
  user_full_dateTime = user_current_time;
  user_full_dateTimearay = user_full_dateTime.split(' ');
  user_full_date = user_full_dateTimearay[0];
  /* get userfulldate */

  var calculate_shipping_weekoff = '0';
  if (typeof is_enable_shipping_weekoff != 'undefined') {
    calculate_shipping_weekoff = is_enable_shipping_weekoff;
  }
  if (typeof sb_edd_options.show_delivery_off_day_in_backend != 'undefined') {
    calculate_shipping_weekoff = sb_edd_options.show_delivery_off_day_in_backend
  }
  if (shopnamefull == 'textildruck-grossauflagen.myshopify.com') {
    calculate_shipping_weekoff = '1';
  }

  skip_current_day_for_delivery_weekoff = 0
  if(typeof sb_edd_options.skip_currentday_after_weekoff != 'undefined'){
    skip_current_day_for_delivery_weekoff = sb_edd_options.skip_currentday_after_weekoff;
  }

  inappropriate_customization = 0
  if(typeof sb_edd_options.inappropriate_customization != 'undefined'){
    inappropriate_customization = sb_edd_options.inappropriate_customization;
  }


  function checkUndefined(variabl, defaultval) {
    if (typeof (sb_edd_options[variabl]) != "undefined") {
      return sb_edd_options[variabl];
    }
    return defaultval;
  }

  var edd_zipcode_widget = `
      <div class="sb_edd_div">
        <div class="sb_edd_form">
            <div class="sb_edd_formTitle">
                <span> `+ zipcode_widget_title + `</span>
            </div> 
            <div class="sb_edd_formFields"> 
                <input type="text" class="sb_edd_pincode_input" placeholder="`+ zipcode_input_placeholder + `"> 
                <button class="sb_edd_check_btn">
                    <div class="sb_edd_loader"></div>
                    <span class="sb_edd_btn_text">`+ zipcode_button_text + `</span>
                </button>
                <br> 
            </div> 
            <div class="sb_edd_msgs">
                <span>`+ zipcode_unserviceable_msg + `</span>
            </div> 
        </div> 
      </div>
    </div>`;
  var edd_zipcode_widget_css = `<style>
      /* Widget css  */
  .sb_edd_div {
    border: 1px solid;
    width: 100%;
    border-radius: 10px;
    padding: 10px 20px;
    margin: 10px 0px;
    border-color: #cbc4c4;
  }

  .sb_edd_formTitle {
    width: 100%;
    margin: 0 0 0 0;
  }

  .sb_edd_formTitle span {
    float: left;
  }

  .sb_edd_form {
    width: 63%;
    display: contents;
    height: auto;
  }

  .sb_edd_formFields {
    width: 100%;
    position: relative;
    margin: 40px 0 10px 0;
  }

  .sb_edd_pincode_input {
    border: 0;
    outline: 0;
    padding: 0px;
    border-radius: 5px;
    width: 100%;
    padding: 20px 14px;
    height: 30px;
    box-shadow: none;
    background-color: #f7f5f5;
  }

  .sb_edd_check_btn {
    padding: 0 15px;
    position: absolute;
    border-radius: 5px;
    right: 0px;
    /* margin: 5px 8px 0 0; */
    z-index: 2;
    border: none;
    height: 40px;
    cursor: pointer;
    transform: translateX(2px);
    font-size: 14px;
    background: #000;
    color:#fff;
    background: ${widget_btn_bg_color};
    color: ${widget_btn_txt_color};
  }
 .sb_edd_check_btn:hover {
    background: ${widget_btn_hvr_color};
    color: ${widget_btn_txt_hvr_color};
  }
  .sb_edd_msgs {
    display: none;
    justify-content: start;
    color:red;
  }
  .sb_edd_hide_text{
    color: transparent;
  }

   .sb_edd_loader {
    display: none;
    z-index: 2;
    position: absolute;
    animation-name: spin;
    animation-duration: 500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    height: 22px;
    width: 22px;
    border: 3px solid #efefef;
    border-radius: 62%;
    border-top: 3px solid;
    left: 0;
    top: 8px;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    text-align: center;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  /*   desktop */
  @media only screen and (min-width: 768px) {
    .sb_edd_div {
      width: 55%;
    }
  }

  /*   tablets */
  @media only screen and (min-width: 600px) {
    .sb_edd_div {
      width: 55%;
    }
  }

  @media only screen and (min-width: 414px) {
    .sb_edd_div {
      /*width: 55%;*/
      width: auto;
      max-width: 437px;
    }
  }
    </style>`;

  /* when product add to cart from quick view 
we also add property name in add.cart.js code in theme.js file  */

  /* var getJSON = function (url, callback) {
var xhr = new XMLHttpRequest();
xhr.open('GET', url, true);
xhr.responseType = 'json';
xhr.onload = function () {
var status = xhr.status;
if (status === 200) {
callback(null, xhr.response);
} else {
callback(status, xhr.response);
}
};
xhr.send();
};*/

  var loadScript = function (url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          if (callback) { callback(); }
        }
      };
    } else {
      script.onload = function () {
        if (callback) { callback(); }
      };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  // var $;


  /* check Jquery loaded in theme or not */
  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {

    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
      jQuery191 = jQuery.noConflict(true);
      // $ = jQuery191;
      checkCookieForThemeExtension(jQuery191);
    });

  } else {
    // $ = jQuery;
    checkCookieForThemeExtension(jQuery);

  }

  function checkCookieForThemeExtension($) {

    checkEDDCookieSetInterval = setInterval(function () {
      var check_edd_data = getSbScriptCookie("edd_data");
      // if (check_edd_data != ""){
      //     clearInterval(checkEDDCookieSetInterval);
      //     myAppcallForMessage($);
      //   }
      if (typeof sb_is_rule_set_for_location == 'undefined') {

        clearInterval(checkEDDCookieSetInterval);
        myAppcallForMessage($);

      } else if (sb_is_rule_set_for_location == '0') {
        clearInterval(checkEDDCookieSetInterval);
        myAppcallForMessage($);
      }
      else if (sb_is_rule_set_for_location == '1') {
        if (get_location_response == '1') {
          clearInterval(checkEDDCookieSetInterval);
          setTimeout(function () {
            myAppcallForMessage($);
          }, 1000)
        }
      }
    }, 700)
    shipment_checker_change_event($)
    changeCountryChecker($);
  }


  function myAppcallForMessage($) {

    if ($(".sb_info").length) {
      $('.sb_info').remove();
      $('.sb_info_from_theme_ext').remove();
    }

    // if($('.sb_info').length > 1){
    //   $('.sb_info:first ').remove()
    // }

    if ($('.sb_info_extension').length == 0) {
      return false;
    }

    startAt = performance.now();
    if (typeof delivery_shop !== 'undefined') {
      shopnamefull = delivery_shop;
    } else {
      if (typeof Shopify !== 'undefined' && typeof Shopify.shop !== 'undefined') {
        shopnamefull = Shopify.shop;
      } else {
        if (typeof sb_edd_options.shop !== 'undefined') {
          shopnamefull = sb_edd_options.shop
        } else {
          shopnamefull = 'not_set';
        }
      }
    }

    if (typeof sb_edd_options.delivery_lunguage !== 'undefined') {
      var delivery_lunguage = sb_edd_options.delivery_lunguage
    }

    if (typeof delivery_lunguage !== 'undefined') {
      shoplanguage = delivery_lunguage;
    } else {
      if (typeof Shopify !== 'undefined' && typeof Shopify.locale !== 'undefined') {
        shoplanguage = Shopify.locale;
      } else {
        shoplanguage = 'en';
      }
    }

    if (typeof check_edd_on_home_page !== 'undefined' && check_edd_on_home_page != '') {
      edd_on_home_page = check_edd_on_home_page;
    }
    else {
      edd_on_home_page = 0;
    }

    if (typeof edd_is_collection_page !== 'undefined' && edd_is_collection_page == '1') {
      edd_is_collection_page = '1';
    } else {
      edd_is_collection_page = '0';
    }
    if (edd_is_collection_page == '1') {
      //return false;
    }

    remove_cart_property = '0';
    if (typeof do_not_add_cart_property !== 'undefined' && do_not_add_cart_property == '1') {
      remove_cart_property = '1';
    }

    if (typeof edd_for_customer_or_admin === 'undefined') {
      edd_for_customer_or_admin = 'admin';
    }



    weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    if (typeof sb_edd_options != 'undefined') {
      edd_main_object = {
        "is_active_payment": sb_edd_plan_info.is_active,
        "is_active": 1,
        "edd_plan_info": sb_edd_plan_info,
        "edd_options": sb_edd_options,
        //"is_install":edd_is_install,
        "is_enable": sb_edd_options.is_enabled,
        "message": sb_edd_options.message,
        "edd_logic": 'new'
      }
    }

    /* get globale object for standard plan */
    if (typeof edd_main_object !== 'undefined') {

      is_active = edd_main_object.is_active;
      is_install = edd_main_object.is_install;
      is_enable = edd_main_object.is_enable;

      /*check_trial_exists = JSON.stringify(edd_main_object).includes("trial_active")

      if(check_trial_exists){

        if(edd_main_object.trial_active == 1){
          trial_end_date = edd_main_object.trial_end_date;
          if((new Date() > new Date(trial_end_date) )  && is_active == 0){
            return false;
          }
          plan = 'premium';
        }                    
      }*/
      if (typeof sb_set_specific_msg !== 'undefined') {
        set_country_msg = sb_set_specific_msg;
      } else {
        set_country_msg = 0;
      }
      app_is_block = '0';
      if (typeof sb_edd_options.app_is_block != 'undefined'){
        app_is_block = sb_edd_options.app_is_block;
      }
      
      if (app_is_block == '1' || is_enable == 0 || edd_for_customer_or_admin == 'customer' || (hide_default_message == '1' && activate_premium_feature == '1' && set_country_msg == '0')) {
        return false;
      }
    } else {
      plan = 'updateFile';
    }
    if (shopnamefull == 'aviator-nation.myshopify.com') {
      plan = 'standard';
    }



    if (shopnamefull == 'goodevas.myshopify.com') {
      good_evas_customization = 1;
    }

    /* remove caching request*/
    if (typeof random_string !== 'undefined') {
      sb_random_string = random_string;
    } else {
      sb_random_string = 'not_set';
    }
    getStoreData($, edd_main_object);


  }

  function getStoreData($, sb_edd_obj) {

    is_active = sb_edd_obj.is_active;

    is_enable = sb_edd_obj.is_enable;

    /*04-10-2022 */
    trial_store = 0;
    allowed_store = 0;
    var check_edd_data = getSbScriptCookie('edd_data');
    if (check_edd_data != "") {

      if (check_edd_data.indexOf("expires") != -1) {
        check_edd_data = check_edd_data.split("expires")[0];
      }
      check_edd_data = JSON.parse(check_edd_data);
      trial_store = check_edd_data.trial_store;
      allowed_store = check_edd_data.allowed_store;
      plan_active = check_edd_data.plan_active;
      is_install = check_edd_data.is_install;

      edd_app_plan = 'premium';
      if (typeof sb_edd_obj.edd_plan_info != 'undefined') {
        //edd_app_plan = sb_edd_obj.edd_plan_info.plan;
      }
      if (typeof sb_edd_obj.plan != 'undefined') {
        //edd_app_plan = sb_edd_obj.plan;
      }


      if (typeof plan_active != 'undefined') {
        if (plan_active == 'active') {
          is_active = 1;
        } else {
          is_active = 0;
        }
        /*if(plan_active == null){
            is_active = 0;
        }*/
      }


      if ((trial_store == 1 && is_active == 0) || allowed_store == 1) {
        edd_app_plan = 'premium';
        is_active = 1;
      }

    }
    /*if(typeof edd_trial_store !== 'undefined'){
        if(edd_trial_store == 1){
          is_active = 1;
          edd_app_plan = 'premium';
        }
      }*/
    /*04-10-2022 */

    if (is_enable == 0 || is_active == 0 || is_install == 0 || (typeof sb_is_exclude_product !== 'undefined' && sb_is_exclude_product == '1')) {

      return false;
    }


    if (typeof edd_app_plan !== 'undefined' && (edd_app_plan == 'premium' || edd_app_plan == 'Premium Plan' || edd_app_plan == 'ode_plan_premium')) {
      activate_premium_feature = '1';
    }

    if (typeof sb_edd_message !== 'undefined' && sb_edd_message != 'not_set' && activate_premium_feature == '1') {
      message = sb_edd_message
    } else {
      message = sb_edd_obj.message;
    }

    if (typeof sb_edd_preview_design !== 'undefined' && sb_edd_preview_design != 'not_set' && activate_premium_feature == '1') {
      specific_preview_design = sb_edd_preview_design
    } else {
      specific_preview_design = sb_edd_obj.preview_design;
    }



    get_product_tag = sb_edd_obj.product_tag;
    store_full_dateTime = sb_edd_obj.store_full_dateTime;
    edd_options = sb_edd_obj.edd_options;
    is_instock = sb_edd_obj.is_instock;

    /* apply delivery weekoff day */
    off_day = edd_options.off_day;
    if(specific_weekoff != 'not_set'){
      off_day = specific_weekoff;
    }
    if (typeof edd_options.delivery_off_day != 'undefined' && edd_options.delivery_off_day != 'not_set') {
      delivery_off_day = edd_options.delivery_off_day;
    } else {
      delivery_off_day = edd_options.off_day;
      if(specific_weekoff != 'not_set'){
        delivery_off_day = specific_weekoff;
      }
    }
    if(specific_delivery_weekoff != 'not_set'){
      delivery_off_day = specific_delivery_weekoff
    }

    /* apply delivery weekoff day */
    
    countdownFormate = edd_options.countdown_formate;
    cutofftime_enable = edd_options.cutofftime_enable;
    date_format = edd_options.date_format;
    detail_page_class = edd_options.detail_page_class;
    msg_preview = edd_options.msg_preview;
    display_on_other_page = edd_options.display_on_other_page;
    hide_default_message = edd_options.hide_default_message;
    cart_msg_apperance = edd_options.cart_msg_apperance;
    //cart_msg_apperance = 'message';
    custom_cart_label = edd_options.custom_cart_label;

    /* get transalted word */
    if(typeof edd_options.translated_wrods != 'undefined'){
      translated_wrods = JSON.parse(edd_options.translated_wrods)
      for(p=0;p<translated_wrods.length;p++){
        check_lan_obj = translated_wrods[p]
        $.each(check_lan_obj, function(key, value) {
              if(key == shoplanguage ){
              translation_obj = value
              }
              if(key == 'all_language'){
              translation_obj_for_all_language = value
              }
             
          })
      }
  
      if(translation_obj == 'not_set' && translation_obj_for_all_language != 'not_set'){
        translation_obj = translation_obj_for_all_language
      }
      if(translation_obj != 'not_set'){
        check_cart_lable = translation_obj.trans_cart_label
        check_cart_lable_length = check_cart_lable.replaceAll(' ','')
        if(check_cart_lable_length.length > 0){
            custom_cart_label = check_cart_lable
        }
      }
    }
    
    /* get transalted word */

    if (typeof edd_options.show_only_one_cart_date != 'undefined') {
      show_only_one_cart_date = edd_options.show_only_one_cart_date
    }

    if (hide_default_message == 1 && activate_premium_feature == '1' && set_country_msg == '0') {

    }


    /* holidays */
    if (typeof edd_options.holidays != 'undefined') {
      holidays_object = JSON.parse(edd_options.holidays);
      $.each(holidays_object, function (key, sb_edd_obj) {
        holidays.push(sb_edd_obj.holiday)
        if (sb_edd_obj.every_year == 'Yes') {
          new_date = new Date(sb_edd_obj.holiday);

          month = new_date.getMonth() + 1; // like 5
          month = (('' + month).length < 2 ? '0' : '') + month; // like 05
          todate = new_date.getDate();
          todate = (('' + todate).length < 2 ? '0' : '') + todate;
          check_holidays = month + '-' + todate;
          every_year_holidays.push(check_holidays)
        }
      })
    }
    /* holidays */

     /* specific ETA rule holiday */
     if (typeof specific_holiday != 'undefined') {
      if (specific_holiday != 'not_set') {
        every_year_holidays = [];
        holidays = [];
        holidays_object = specific_holiday;
        $.each(holidays_object, function (key, sb_edd_obj) {
          holidays.push(sb_edd_obj.holiday)
          if (sb_edd_obj.every_year == 'Yes') {
            new_date = new Date(sb_edd_obj.holiday);
  
            month = new_date.getMonth() + 1; // like 5
            month = (('' + month).length < 2 ? '0' : '') + month; // like 05
            todate = new_date.getDate();
            todate = (('' + todate).length < 2 ? '0' : '') + todate;
            check_holidays = month + '-' + todate;
            every_year_holidays.push(check_holidays)
          }
        })
      }
    }
    /* specific ETA rule holiday */

    /* custom date */
    if (typeof edd_options.date_option != 'undefined') {
      date_option = edd_options.date_option;
    }
    if (typeof edd_options.custom_date_format != 'undefined') {
      custom_date_format = edd_options.custom_date_format
    }
    /* apply specific message date formate */
    if (typeof specific_date_option != 'undefined') {
      if (specific_date_option != 'not_set') { date_option = specific_date_option; }
    }
    if (typeof specific_date_format != 'undefined') {
      if (specific_date_format != 'not_set') { date_format = specific_date_format }
    }
    if (date_option == 'custom' && typeof specific_custom_date_format != 'undefined') {
      if (specific_custom_date_format != '' && specific_custom_date_format != 'not_set') {
        custom_date_format = specific_custom_date_format
      }
    }
    if (typeof specific_countdown_option != 'undefined') {
      if (specific_countdown_option != 'not_set') { countdownFormate = specific_countdown_option }
    }
    /* apply specific message date formate */
    custom_date_format = custom_date_format.replaceAll('  ', ' ')
    check_custom_date_format_length = custom_date_format.replaceAll(' ', '')

    if (custom_date_format != '' && date_option == 'custom' && check_custom_date_format_length != 0) {
      get_custom_date_format = 'get';
    }
    /* custom date */

    /* new code */


    if ($('.sb_info_extension .sb_store_date').length > 0) {
      getStoreDate = $('.sb_info_extension .sb_store_date').text()
      if (mayuri_customization == 1) {
        var dateasaa = $('.sb_info_extension .sb_store_date').text().split(":");
        getStoreDate = dateasaa[0].trim() + ":" + dateasaa[1];
      }
      todayDate = new Date(getStoreDate);
      storeTodayDate = new Date(getStoreDate);
      storeTodayDate = getCurrentDateOfStoreAndUser(storeTodayDate);
      cutoff_time = sb_edd_obj.edd_options.cutoff_time
      if (typeof specific_cutofftime != 'undefined' && specific_cutofftime != 'not_set') {
        cutoff_time = specific_cutofftime;
      }
      if (typeof specific_cutofftime_enable != 'undefined' && specific_cutofftime_enable != 'not_set') {
        cutofftime_enable = specific_cutofftime_enable
      }
      cutoff_time = cutoff_time.replace(' : ', ':')
      storeTodayDate = storeTodayDate.current_date + ' ' + cutoff_time;
      store_full_dateTime = storeTodayDate
    }

    if (cutofftime_enable == 1) {
      if (todayDate < new Date(store_full_dateTime)) {
        check_cutoff = 'more';
      } else {
        check_cutoff = 'less';
      }
    } else {
      check_cutoff = 'disabled';
    }
    /* new code */


    user_date_with_weekoff_cutoff = user_full_date;
    get_shortcode_with_value = {};
    get_shortcode_with_value_with_en_lag = [];
    get_shortcode_with_value_with_store_lag = [];
    getOutofStockProduct = false;

    today_date = new Date(user_full_date);
    eval(edd_options.additional_script);
    if (hideOutOfStockMessage == 1) {
      if (is_instock == 0) {
        getOutofStockProduct = true;
      }
    }

    if (message == 'not_set') {
      return false;
    }



    eval(edd_options.additional_script);
    if (getOutofStockProduct || (set_country_msg == 0 && (hideDefaultMessage == 1 || (hide_default_message == 1 && activate_premium_feature == '1' && set_country_msg == '0')))) {

      return false;

    } else {
      OrderDeliveryEstimationLogic($)
    }

    var endAt = performance.now(); //put this line at the end of your js code

    var difference_in_miliseconds = endAt - startAt;
    var difference_in_seconds = Math.floor((difference_in_miliseconds / 1000) % 60); //found the difference

  }

  function OrderDeliveryEstimationLogic($) {

    if (typeof donotupdateEDDmessageCustom != 'undefined') {
      donotupdateEDDmessage = donotupdateEDDmessageCustom;
    }
    if (edd_is_collection_page == '0') {
      addEstimatedMessageClass($);
    }

    addMultipleIcon($);

    addPremiumPlanFeture($);

    checkCurrentDayIsWorkngDay($, today_date);

    getShortCodeFromMessage($);

    if (inappropriate_customization == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayMrInapproprite($)
    } else if (mayuri_customization == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayMayuri($);
    } else if (healthy_meals_customization == '1') {
      getReplaceShortcodeAndGetDelvieryDateArrayHelathyMeals($);
    } else if (calculate_shipping_weekoff == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayWithDeliveryOffDay($);
    } else {
      //getReplaceShortcodeAndGetDelvieryDateArray($);
      getReplaceShortcodeAndGetDelvieryDateArrayWithDeliveryOffDay($);
    }

    if (donotupdateEDDmessage == '0') {
      addPreViewDesgin($);
    }


    getDeliveryDateANDapplyTOCartPage($);

    setDelvieryDateANDapplyTOCartPage($);

    appendDeveloperOption($);

    addAnimationClass($);

    add_additional_code($);

    threeStepTemplateOnHover($);

    displayStorePickup($);

  }

  function threeStepTemplateOnHover($){
    $(document).on('mouseenter','.hightlight_date',function(){
      $('.ETA_hover_effect').addClass('active')
    })
    $(document).on('mouseleave','.hightlight_date',function(){
      $('.ETA_hover_effect').removeClass('active')
    })
  }

  function variantWiseInstockOutofstockMsgFromEDDScript($) {
    addPremiumPlanFeture($);

    addMultipleIcon($);

    getShortCodeFromMessage($);

    if (inappropriate_customization == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayMrInapproprite($)
    } else if (mayuri_customization == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayMayuri($);
    } else if (healthy_meals_customization == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayHelathyMeals($);
    } else if (calculate_shipping_weekoff == 1) {
      getReplaceShortcodeAndGetDelvieryDateArrayWithDeliveryOffDay($);
    } else {
      getReplaceShortcodeAndGetDelvieryDateArray($);
    }
    getDeliveryDateANDapplyTOCartPage($);

    setDelvieryDateANDapplyTOCartPage($);

    addPreViewDesgin($);

    addAnimationClass($);

  }

  function appendDeveloperOption($) {
    if (typeof edd_options.custom_css != 'undefined') {
      $('body').append('<style>' + edd_options.custom_css + '</style>')
    }
    if (typeof edd_options.custom_js != 'undefined') {
      $('body').append('<script>' + edd_options.custom_js + '</script>')
    }
      $('body').append("<script>if(typeof $ == 'undefined' && typeof jQuery191 != 'undefined'){$=jQuery191;}if(typeof $ != 'undefined'){$('.delivery_msg .template_11 .step_template ').removeClass('active').addClass('inactive');$('.delivery_msg .template_11 .step_1').addClass('active').removeClass('inactive'); var sb_template_11_step = 1;var general_template_interval = setInterval(function () {$('.delivery_msg  .template_11 .step_template ').removeClass('active').addClass('inactive');$('.delivery_msg .template_11 .step_' + sb_template_11_step).addClass('active').removeClass('inactive');sb_template_11_step++;if (sb_template_11_step > $('.delivery_msg .step_template').length) {sb_template_11_step = 1; }}, 2000);$('.template_11').parent().css('display','grid')}</script>")
  }
  function addAnimationClass($) {
    if (typeof edd_options.animation_class != 'undefined' && edd_options.animation_class != 'not_set' && set_country_msg == '0') {
      $('.sb_delivery .animation_class').addClass(edd_options.animation_class)
    }
  }
  function getTimerText(getWord) {
    if (typeof (timer_translation[shoplanguage]) != "undefined") {
      return timer_translation[shoplanguage][getWord];
    }
    return getWord;
  }

  function addCountDownTimer($) {

    message = message.replaceAll('{countdown_timer}', '<span class="count_down_timer hightlight_date"></span>');
    message = message.replaceAll('{Countdown_Timer}', '<span class="count_down_timer hightlight_date"></span>');
    message = message.replaceAll('{COUNTDOWN_TIMER}', '<span class="count_down_timer hightlight_date"></span>');

    defaultTime = store_full_dateTime.replace(' AM', '');
    defaultTime = store_full_dateTime.replace(' PM', '');
    defaultTime = defaultTime.split(' ');
    defaultTime = defaultTime[0];
    var date = new Date(defaultTime);
    date.setDate(date.getDate() + 1);
    defaultTime = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    defaultTime = defaultTime + ' 12:00 AM';
    count_down_interval = setInterval(function () {

      sb_distance = getCutdownDate($, defaultTime, count_down_interval);

      var sb_days = Math.floor(sb_distance / (1000 * 60 * 60 * 24));
      var sb_hours = Math.floor((sb_distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var sb_minutes = Math.floor((sb_distance % (1000 * 60 * 60)) / (1000 * 60));
      var sb_seconds = Math.floor((sb_distance % (1000 * 60)) / 1000);

      var daysArray = sb_days.toString(10).replace(/\D/g, '0').split('').map(Number);
      var minutesArray = sb_minutes.toString(10).replace(/\D/g, '0').split('').map(Number);
      var secondsArray = sb_seconds.toString(10).replace(/\D/g, '0').split('').map(Number);
      var hoursArray = sb_hours.toString(10).replace(/\D/g, '0').split('').map(Number);
      var dayswithClass = (('' + sb_days).length < 2 ? '<span class="digit">0</span><span class="digit">' + sb_days + '</span>' : '<span class="digit">' + daysArray[0] + '</span><span class="digit">' + daysArray[1] + '</span>');
      var hourswithClass = (('' + sb_hours).length < 2 ? '<span class="digit">0</span><span class="digit">' + sb_hours + '</span>' : '<span class="digit">' + hoursArray[0] + '</span><span class="digit">' + hoursArray[1] + '</span>');
      var minuteswithClass = (('' + sb_minutes).length < 2 ? '<span class="digit">0</span><span class="digit">' + sb_minutes + '</span>' : '<span class="digit">' + minutesArray[0] + '</span><span class="digit">' + minutesArray[1] + '</span>');
      var secondswithClass = (('' + sb_seconds).length < 2 ? '<span class="digit">0</span><span class="digit">' + sb_seconds + '</span>' : '<span class="digit">' + secondsArray[0] + '</span><span class="digit">' + secondsArray[1] + '</span>');
      var sb_totalMinutes = (sb_hours * 60) + sb_minutes;

      switch (countdownFormate) {
        case '1': var timer = sb_days + ' ' + getTimerText('Days') + ' ' + sb_hours + ' ' + getTimerText('Hours') + ' ' + sb_minutes + ' ' + getTimerText('Minutes') + ' ' + sb_seconds + ' ' + getTimerText('Seconds') + ' '; break;
        case '2': var timer = sb_hours + ' ' + getTimerText('Hours') + ' ' + sb_minutes + ' ' + getTimerText('Minutes') + ' ' + sb_seconds + ' ' + getTimerText('Seconds') + ' '; break;
        case '3': var timer = sb_hours + ' ' + getTimerText('Hrs') + ' ' + sb_minutes + ' ' + getTimerText('Mins') + ' ' + sb_seconds + ' ' + getTimerText('Secs') + ' '; break;
        case '4': var timer = sb_hours + ' ' + getTimerText('Hrs') + ' ' + sb_minutes + ' ' + getTimerText('Mins') + ' '; break;
        case '5': var timer = sb_hours + '' + getTimerText('H') + ' : ' + sb_minutes + getTimerText('M') + ' : ' + sb_seconds + getTimerText('S') + ' '; break;
        case '6': var timer = sb_days + '<sup>' + getTimerText('Days') + '</sup> / ' + sb_hours + '<sup>' + getTimerText('Hours') + '</sup> / ' + sb_minutes + '<sup>' + getTimerText('Minutes') + '</sup> / ' + sb_seconds + '<sup>' + getTimerText('Seconds') + '</sup>'; break;
        case '7': var timer = '<div class="timeContainer1"><div class="wrapper"><div class="hours"><h2 id="hours">' + hourswithClass + '</h2>' + getTimerText('Hours') + '</div><div class="minutes"><h2 id="minutes">' + minuteswithClass + '</h2>' + getTimerText('Minutes') + '</div><div class="seconds"><h2 id="seconds">' + secondswithClass + '</h2>' + getTimerText('Seconds') + '</div></div></div>'; break;
        case '8': var timer = '<div class="timeContainer2"><div class="wrapper"><div class="hours"><h2 id="hours">' + hourswithClass + '</h2>' + getTimerText('Hours') + '</div><div class="minutes"><h2 id="minutes">' + minuteswithClass + '</h2>' + getTimerText('Minutes') + '</div><div class="seconds"><h2 id="seconds">' + secondswithClass + '</h2>' + getTimerText('Seconds') + '</div></div></div>'; break;
        case '9': var timer = sb_totalMinutes + ' ' + getTimerText('Mins') + ' ' + sb_seconds + ' ' + getTimerText('Secs') + ' '; break;

        default: var timer = sb_hours + ' ' + getTimerText('Hrs') + ' ' + sb_minutes + ' ' + getTimerText('Mins') + ' ' + sb_seconds + ' ' + getTimerText('Secs') + ' '; break;
      }
      if (shopnamefull == 'costa-pasticceria.myshopify.com') {
        var timer = sb_hours + ' Ore ' + sb_minutes + ' minuti ';
      }
      if (shopnamefull == 'pvgrafiklab.myshopify.com') {
        var timer = sb_hours + ' Ore ' + sb_minutes + ' minuti ' + sb_seconds + ' Secondo';
      }
      /* add custom timer formate */
      if (typeof sb_edd_options.custom_timer_format != 'undefined' && sb_edd_options.custom_timer_format != 'not_set') {
        eval(sb_edd_options.custom_timer_format);

        // add below details in edd_options
        // var show_timer_sb_days = '1';var show_timer_sb_hour = '1';var show_timer_sb_minut = '1';var show_timer_sb_second = '1';day_timer_sb_label='day';var hover_timer_sb_label='h';var minute_timer_sb_label = 'min';var second_timer_sb_label='sec';timer_sepretor = ' / ';letter_seperator = ' ';timer_design = 'not_set'

        var timer = '';
        if (timer_design != 'not_set' && timer_design != '') {
          timer = '<div class="timeContainer' + timer_design + '"><div class="wrapper">';
          if (show_timer_sb_days == '1') {
            timer += '<div class="days"><h2 id="days">' + dayswithClass + '</h2>' + day_timer_sb_label + '</div>'
          }
          if (show_timer_sb_hour == '1') {
            timer += '<div class="hours"><h2 id="hours">' + hourswithClass + '</h2>' + hover_timer_sb_label + '</div>'
          }
          if (show_timer_sb_minut == '1') {
            timer += '<div class="minutes"><h2 id="minutes">' + minuteswithClass + '</h2>' + minute_timer_sb_label + '</div>'
          }
          if (show_timer_sb_second == '1') {
            timer += '<div class="seconds"><h2 id="seconds">' + secondswithClass + '</h2>' + second_timer_sb_label + '</div>'
          }
          timer += '</div></div>'
        } else {

          if (show_timer_sb_days == '1') {
            timer += sb_days + '' + letter_seperator + '' + day_timer_sb_label
          }
          if (show_timer_sb_days == '1' && show_timer_sb_hour == '1') {
            timer += timer_sepretor
          }
          if (show_timer_sb_hour == '1') {
            timer += sb_hours + '' + letter_seperator + '' + hover_timer_sb_label
          }
          if (show_timer_sb_hour == '1' && show_timer_sb_minut == '1') {
            timer += timer_sepretor
          }
          if (show_timer_sb_minut == '1') {
            timer += sb_minutes + '' + letter_seperator + '' + minute_timer_sb_label
          }
          if (show_timer_sb_minut == '1' && show_timer_sb_second == '1') {
            timer += timer_sepretor
          }
          if (show_timer_sb_second == '1') {
            timer += sb_seconds + '' + letter_seperator + '' + second_timer_sb_label + ''
          }
        }
      }
      /* add custom timer formate */

      $('.count_down_timer').html(timer);
      setDelvieryDateANDapplyTOCartPage($)

    }, 1000);
  }



  function getCutdownDate($, defaultTime, count_down_interval) {
    if (cutofftime_enable == 1) {
      countDownDate = store_full_dateTime;
    } else {
      countDownDate = defaultTime;
    }
    var sb_now = new Date().getTime();
    countDownDate = new Date(countDownDate).getTime();
    var sb_distance = countDownDate - sb_now;
    if (sb_distance < 0) {
      var setubridge_coundown_coockie = getSbScriptCookie("setubridge_coundown_coockie");

      if (setubridge_coundown_coockie == "") {

        /* setCookieNew();
      $('.deliverydate ,.add_hidden_delivery').remove();    
      $.getScript("https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/edd-proxy/main/optimized_script_delivery.js");*/
      }
      if (cutofftime_enable == 1) {
        var storeTime = new Date(store_full_dateTime);
        storeTime = storeTime.setDate(storeTime.getDate() + 1);
        countDownDate = storeTime;

      } else {
        var date = new Date(defaultTime);
        defaultTime = date.setDate(date.getDate() + 1);
        countDownDate = defaultTime;
      }
      countDownDate = new Date(countDownDate).getTime();
      sb_distance = countDownDate - sb_now;

      if (sb_distance < 0) {
        if (cutofftime_enable == 1) {
          var storeTime = new Date(storeTime);
          storeTime = storeTime.setDate(storeTime.getDate() + 1);
          countDownDate = storeTime;

        } else {
          var date = new Date(defaultTime);
          defaultTime = date.setDate(date.getDate() + 1);
          countDownDate = defaultTime;
        }

      }
      countDownDate = new Date(countDownDate).getTime();
      sb_distance = countDownDate - sb_now;
    }
    return sb_distance;
  }

  function setCookieNew(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getSbScriptCookie(cname) {
    var name = cname + "=";
    // var decodedCookie = decodeURIComponent(document.cookie);
    // var ca = decodedCookie.split(';');
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function addMultipleIcon() {

    var countIcon = (message.match(/src/g) || []).length;
    message = replaceAllOccurance(message, countIcon, 'https://www.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_', 'img/icon_');
    message = replaceAllOccurance(message, countIcon, 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_', 'img/icon_');
    message = replaceAllOccurance(message, countIcon, 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app_edd/admin/img/icon_', 'img/icon_');
    message = replaceAllOccurance(message, countIcon, 'img/icon_', 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/icon_');

    message = replaceAllOccurance(message, countIcon, 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/cus_temp_imgs', 'img/cus_temp_imgs');
    message = replaceAllOccurance(message, countIcon, 'img/cus_temp_imgs', 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/cus_temp_imgs');

    message = replaceAllOccurance(message, countIcon, 'https://www.setubridgeapps.com/estimated-delivery-days/app/admin/img/', 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/');


  }

  function replaceAllOccurance(message, tempCount, replace_word, replace_with) {

    tempMessage = message;
    for (i = 0; i < tempCount; i++) {
      tempMessage = tempMessage.replace(replace_word, 'temp_variable');
    }
    for (i = 0; i < tempCount; i++) {
      tempMessage = tempMessage.replace('temp_variable', replace_with);
    }
    return tempMessage;
  }

  function getDeliveryDateANDapplyTOCartPage($) {
    getCartDate = '';

    // ninetwofive-nl.myshopify.com out-stock message to cart condition
    if (shopnamefull == 'ninetwofive-nl.myshopify.com') {
      if (sb_product_have_qty == 0 || sb_product_have_qty == "0") {
        get_shortcode_with_value = {};
      }
    }
    // ninetwofive-nl.myshopify.com out-stock message to cart condition

    edd_cart_max_day_only = edd_cart_max_day;

    if (edd_cart_min_day != edd_cart_max_day) {
      edd_cart_max_day = ' - ' + edd_cart_max_day;
    } else {
      edd_cart_max_day = '';
    }
    if (Object.keys(get_shortcode_with_value).length) {
      Object.keys(get_shortcode_with_value).forEach(key => {
        const regex = new RegExp(`\\b${key}\\b`, 'g'); // Use word boundaries to ensure full match

        if (getCartDate == '') {
          getCartDate = get_shortcode_with_value[key]
        } else {
          eval(edd_options.additional_script);
          if (cartDateSign != '' && (showOnlyDateOnCartpage == 1 || cart_msg_apperance == 'date')) {
            getCartDate = cartDateSign + ' ' + edd_cart_min_day + edd_cart_max_day;
          } else {
            getCartDate = edd_cart_min_day + edd_cart_max_day;
          }
        }

        if (show_only_one_cart_date == '1' || show_only_one_cart_date == 1) {
          getCartDate = edd_cart_max_day_only
        }

        message = message.replace(regex, '<span class="hightlight_date">'+get_shortcode_with_value[key]+'</span>');
      });

    } else {

      // ninetwofive-nl.myshopify.com out-stock message to cart condition
      getCartDate = $(".deliverydate.sb_delivery").text();
      // ninetwofive-nl.myshopify.com out-stock message to cart condition
    }

    // country checker dropdown
    if (typeof is_country_dropdown_on != 'undefined') {
      if (is_country_dropdown_on == "true") {
        
        if (message.indexOf("{country_dropdown}") != -1) {
          if ($(".deliverydate.sb_delivery").parent().find(".edd_country_msg_change").length != 0) {
            $(".deliverydate.sb_delivery").parent().find(".edd_country_msg_change").remove();
          }
          add_country_checker_shortcode(message, $);
        } else {
          add_country_checker(message, $);
        }
      }
    }
    // country checker dropdown

    if (donotupdateEDDmessage == '0') {
      if (typeof (sb_edd_zipcode_enable) != "undefined" && $(".sb_edd_div").length == 0) {
        if (sb_edd_zipcode_enable == "1") {
          $('.deliverydate.sb_delivery').before(edd_zipcode_widget_css);
          $('.deliverydate.sb_delivery').before(edd_zipcode_widget);
          $('.deliverydate.sb_delivery,.shipment_method_selector').hide();
          checkValidZipcodes($, message);
        } else {
          $('.delivery_msg').html(message);
          $('.delivery_msg').attr('contenteditable', false);
          if ($(".deliverydate.sb_delivery").parent().find(".shipment_method_selector").length == 0 && typeof sb_edd_zipcode_enable != 'undefined' && sb_edd_zipcode_enable == '0') {
            shipment_checker($)
          }
        }
      } else {
        $('.delivery_msg').html(message);
        $('.delivery_msg').attr('contenteditable', false);
      }
    }

    $('.hightlight_date').css({ 'color': msg_preview.highlight_clr });
    /* add changes*/

    if (typeof $('.template_order').attr('eta_hover_effect') != 'undefined') {
      total_eta_date =  $('.sb_delivery  .hightlight_date').length
      three_step_eta_date = $('.sb_delivery  .template_order   .hightlight_date').length
      if(total_eta_date > three_step_eta_date ){
        $('.template_order').addClass('ETA_hover_effect')
        $('.sb_delivery').addClass('ETA_hover_effect_wrap')
        $('body').append('<style>.ETA_hover_effect_wrap .hightlight_date{cursor:pointer;border-bottom: 1px dotted #000000e6;}.ETA_hover_effect .hightlight_date{border-bottom : 0 }.ETA_hover_effect{display:none !important;} .ETA_hover_effect.active{display:inline-flex !important;position: absolute;width: 100%;margin-top: 10px;z-index: 9999;right: 0;border-radius: 10px;box-shadow: 0rem 0.0625rem 1rem 0rem rgb(26 26 26 / 70%)}.deliverydate.sb_delivery{position: relative;overflow: initial !important;}</style>')
      }
    }else{
      if($('.template_order').hasClass('template_10')){
        $('.template_order').css('position','relative')
      }
    }

    $('.deliverydate  img').css({ "opacity": "1", "margin": "0px 4px 3px", "vertical-align": "middle", "display": "inline-block", "height": "auto" });


    if (typeof $('.template_order').attr('desing_2_icon_bk_color') != 'undefined') {
      icon_box_color = $('.template_order').attr('desing_2_icon_bk_color')
      $('.deliverydate .step_template img').css({ "background": icon_box_color });
    }
    else if (typeof $('.template_order').attr('img_background_set') == 'undefined') {
      $('.deliverydate .step_template img').css({ "background": '#fff' });
    }
  }

  /* check zipcode with prefic */
  function checkZipcodeWiseEddMessageLooping(check_edd_msg) {
    temp_array = [];
    get_edd_msg_arr = check_edd_msg[0];
    var zipcode_with_shipping_set = '0';

    for (i = 0; i < check_edd_msg.length; i++) {
      if (typeof (check_edd_msg[i].zipcode_enable) != "undefined" && typeof (check_edd_msg[i].shipping_enable) != "undefined") {
        if (check_edd_msg[i].zipcode_enable == "1" && check_edd_msg[i].shipping_enable == '1') {

          get_edd_msg_arr = check_edd_msg[i];
          sb_edd_zipcode_list = get_edd_msg_arr.zipcode_list;
          sb_edd_zipcode_list = sb_edd_zipcode_list.replaceAll('\t', '')
          var inputVal = document.getElementsByClassName("sb_edd_pincode_input")[0].value;
          inputVal = inputVal.replaceAll(' ', '')

          sb_edd_zipcode_prefix_list = get_edd_msg_arr.zipcode_prefix_set;
          sb_edd_zipcode_prefix_list = sb_edd_zipcode_prefix_list.replaceAll('\t', '')
          check_zipcode_prefix = checkZipcodePrefix(inputVal, sb_edd_zipcode_prefix_list)

          if (typeof inputVal != 'undefined') {
            if ((sb_edd_zipcode_list.includes(inputVal) || checkZipcodeRange(inputVal, sb_edd_zipcode_list))) {
              get_edd_msg_arr = check_edd_msg[i];
              temp_array = [];
              temp_array.push(check_edd_msg[i])

              break
            } else if (check_zipcode_prefix == '1') {
              get_edd_msg_arr = check_edd_msg[i];
              temp_array = [];
              temp_array.push(check_edd_msg[i])
              break
            }
          }

        }
      }
    }
    if (zipcode_with_shipping_set == '0') {
      for (i = 0; i < check_edd_msg.length; i++) {
        if (typeof (check_edd_msg[i].zipcode_enable) != "undefined" && typeof (check_edd_msg[i].shipping_enable) != "undefined") {
          if (check_edd_msg[i].zipcode_enable == "1" && check_edd_msg[i].shipping_enable == '0') {

            get_edd_msg_arr = check_edd_msg[i];
            sb_edd_zipcode_list = get_edd_msg_arr.zipcode_list;
            sb_edd_zipcode_list = sb_edd_zipcode_list.replaceAll('\t', '')
            var inputVal = document.getElementsByClassName("sb_edd_pincode_input")[0].value;
            inputVal = inputVal.replaceAll(' ', '')

            sb_edd_zipcode_prefix_list = get_edd_msg_arr.zipcode_prefix_set;
            sb_edd_zipcode_prefix_list = sb_edd_zipcode_prefix_list.replaceAll('\t', '')
            check_zipcode_prefix = checkZipcodePrefix(inputVal, sb_edd_zipcode_prefix_list)
            if (typeof inputVal != 'undefined') {
              if ((sb_edd_zipcode_list.includes(inputVal) || checkZipcodeRange(inputVal, sb_edd_zipcode_list))) {
                get_edd_msg_arr = check_edd_msg[i];
                temp_array = [];
                temp_array.push(check_edd_msg[i])
                break
              } else if (check_zipcode_prefix == '1') {
                get_edd_msg_arr = check_edd_msg[i];
                temp_array = [];
                temp_array.push(check_edd_msg[i])
                break
              }
            }

          }
        }
      }
      for (i = 0; i < check_edd_msg.length; i++) {
        if (typeof (check_edd_msg[i].zipcode_enable) != "undefined" && typeof (check_edd_msg[i].shipping_enable) == "undefined") {
          if (check_edd_msg[i].zipcode_enable == "1") {

            get_edd_msg_arr = check_edd_msg[i];
            sb_edd_zipcode_list = get_edd_msg_arr.zipcode_list;
            sb_edd_zipcode_list = sb_edd_zipcode_list.replaceAll('\t', '')
            var inputVal = document.getElementsByClassName("sb_edd_pincode_input")[0].value;
            inputVal = inputVal.replaceAll(' ', '')

            sb_edd_zipcode_prefix_list = get_edd_msg_arr.zipcode_prefix_set;
            sb_edd_zipcode_prefix_list = sb_edd_zipcode_prefix_list.replaceAll('\t', '')
            check_zipcode_prefix = checkZipcodePrefix(inputVal, sb_edd_zipcode_prefix_list)

            if (typeof inputVal != 'undefined') {
              if ((sb_edd_zipcode_list.includes(inputVal) || checkZipcodeRange(inputVal, sb_edd_zipcode_list))) {
                get_edd_msg_arr = check_edd_msg[i];
                temp_array = [];
                temp_array.push(check_edd_msg[i])
                break
              } else if (check_zipcode_prefix == '1') {
                get_edd_msg_arr = check_edd_msg[i];
                temp_array = [];
                temp_array.push(check_edd_msg[i])
                break
              }
            }

          }
        }
      }
    }
    edd_multiple_rule_for_shipping = temp_array;
    return get_edd_msg_arr;

  }

  function checkZipcodeRange(inputVal, edd_zipcodelist_data) {
    check_zipcode_in_range = false
    edd_zipcodelist_data = edd_zipcodelist_data.replaceAll(' ', '')
    if (edd_zipcodelist_data.length > 0) {
      edd_zipcodelist_data = edd_zipcodelist_data.split(',')
      for (q = 0; q < edd_zipcodelist_data.length; q++) {
        zipRange = edd_zipcodelist_data[q];
        if (zipRange.includes('-')) {
          var bounds = zipRange.split('-');
          var minZip = parseInt(bounds[0]);
          var maxZip = parseInt(bounds[1]);
          if (inputVal >= minZip && inputVal <= maxZip) {
            isInRange = true;
            check_zipcode_in_range = true;
          }
        }
      };
    }
    return check_zipcode_in_range;
  }

  function checkZipcodePrefix(inputVal, edd_zipcodelist_data) {

    check_zipcode_prefix = '0';
    if (edd_zipcodelist_data != 'not_set' && edd_zipcodelist_data != '') {
      edd_zipcodelist_data = edd_zipcodelist_data.split(',')
      for (k = 0; k < edd_zipcodelist_data.length; k++) {
        get_prefix_from_input = inputVal.substring(0, edd_zipcodelist_data[k].length)
        if (get_prefix_from_input.toLowerCase() == edd_zipcodelist_data[k].toLowerCase() && inputVal.length >= get_prefix_from_input.length) {
          check_zipcode_prefix = '1'
        }
      }
    }

    return check_zipcode_prefix;
  }

  function checkValidZipcodes($, message) {
    if (typeof (sb_edd_zipcode_list) != "undefined") {
      if (sb_edd_zipcode_list != "not_set") {
        sb_edd_zipcode_list = sb_edd_zipcode_list.replaceAll('\t', '')
        sb_edd_zipcode_list = sb_edd_zipcode_list.split(",");

        $(".sb_edd_check_btn").on('click', function (e) {
          e.preventDefault();
          var inputVal = $(".sb_edd_pincode_input").val();
          inputVal = inputVal.replaceAll(' ', '')
          inputVal = inputVal.toLowerCase();

          $('.sb_edd_loader').css({ "display": "block" });
          $(".sb_edd_btn_text").addClass("sb_edd_hide_text");
          setTimeout(function () {
            $('.sb_edd_loader').css({ "display": "none" });
            $(".sb_edd_btn_text").removeClass("sb_edd_hide_text");

            var thisrulematch = false;
            if (typeof (sb_edd_rule_list) !== "undefined") {
              sb_edd_rule_list.forEach(function name(params) {
                zipcode_list = params.zipcode_list.replaceAll(' ', '')
                zipcode_list = zipcode_list.replaceAll('\t', '')
                zipcode_list = zipcode_list.toLowerCase();

                edd_zipcodelist_data = zipcode_list.split(",");

                edd_zipcodelist_data = $.map(edd_zipcodelist_data, function (val) {
                  return val.replace(/\n/g, "");
                });

                check_zipcode_in_range = checkZipcodeRange(inputVal, edd_zipcodelist_data.join(","));

                check_zipcode_prefix = '0';
                check_prefix = params.zipcode_prefix_set;
                check_prefix = check_prefix.replaceAll(' ', '')
                if (check_prefix.length > 1 && check_prefix != 'not_set') {
                  check_zipcode_prefix = checkZipcodePrefix(inputVal, check_prefix)
                }

                if ((edd_zipcodelist_data.includes(inputVal) || check_zipcode_prefix == '1' || check_zipcode_in_range) && !thisrulematch) {

                  thisrulematch = true;
                  check_edd_msg = checkZipcodeWiseEddMessageLooping(sb_edd_rule_list)
                  $(".deliverydate.sb_delivery,.shipment_method_selector").hide();
                  sb_edd_preview_design = params.preview_design;
                  sb_edd_message = params.message;
                  sb_edd_message = getLanguageWiseMsg(check_edd_msg, sb_edd_message);
                  sb_edd_zipcode_enable = params.zipcode_enable;
                  sb_edd_zipcode_list = params.zipcode_list;
                  sb_edd_zipcode_list = sb_edd_zipcode_list.replaceAll('\t', '')
                  sb_edd_store_locatore_list  = params.store_locatore_list;
                  getStoreData($, edd_main_object);

                  $('.deliverydate.sb_delivery,.delivery_msg,.shipment_method_selector').show();

                  shipment_checker($)
                  // $('.delivery_msg').html(message);
                  // $('.delivery_msg').attr('contenteditable',false);
                  $(".sb_edd_msgs").hide();

                  setDelvieryDateANDapplyTOCartPage($);
                  $('.add_hidden_delivery').val(passcartvalue);

                }
              })

              if (!thisrulematch) {
                if (inputVal == "") {
                  $(".sb_edd_msgs span").text("" + zipcode_empty_msg + "").css({ "color": "red" });
                  $(".sb_edd_msgs").show();
                  $(".delivery_msg,.deliverydate.sb_delivery,.shipment_method_selector").hide();
                  $('.add_hidden_delivery').val("");
                } else {
                  $(".sb_edd_msgs span").text("" + zipcode_unserviceable_msg + "").css({ "color": "red" });
                  $(".sb_edd_msgs").show();
                  $(".delivery_msg,.deliverydate.sb_delivery,.shipment_method_selector").hide();
                  $('.add_hidden_delivery').val("");
                }
              }
            } else {
              if (sb_edd_zipcode_list.includes(inputVal) && inputVal != "") {

                $('.deliverydate.sb_delivery,.delivery_msg').show();
                $('.delivery_msg').html(message);
                $('.delivery_msg').attr('contenteditable', false);
                $(".sb_edd_msgs").hide();

                setDelvieryDateANDapplyTOCartPage($);
                $('.add_hidden_delivery').val(passcartvalue);


              } else if (inputVal == "") {
                $(".sb_edd_msgs span").text("" + zipcode_empty_msg + "").css({ "color": "red" });
                $(".sb_edd_msgs").show();
                $(".delivery_msg,.deliverydate.sb_delivery,.shipment_method_selector").hide();
                $('.add_hidden_delivery').val("");
              } else {
                $(".sb_edd_msgs span").text("" + zipcode_unserviceable_msg + "").css({ "color": "red" });
                $(".sb_edd_msgs").show();
                $(".delivery_msg,.deliverydate.sb_delivery,.shipment_method_selector").hide();
                $('.add_hidden_delivery').val("");
              }
            }


            // if (sb_edd_zipcode_list.includes(inputVal) && inputVal != "") {

            //     $('.deliverydate.sb_delivery,.delivery_msg').show();
            //     $('.delivery_msg').html(message);
            //     $('.delivery_msg').attr('contenteditable',false);
            //     $(".sb_edd_msgs").hide();

            //    setDelvieryDateANDapplyTOCartPage($);
            //    
            //    $('.add_hidden_delivery').val(passcartvalue);


            // } else {
            //     // $(".sb_edd_msgs span").text("" + zipcode_unserviceable_msg + "").css({ "color": "red" });
            //     $(".sb_edd_msgs").show();
            //     $(".delivery_msg,.deliverydate.sb_delivery").hide();
            //     $('.add_hidden_delivery').val("");
            // }
          }, 1000);
        });

        $(".sb_edd_pincode_input").keyup(function () {
          if ($(this).val() == "") {
            $(".sb_edd_msgs").hide();
            $(".delivery_msg,.deliverydate.sb_delivery,.shipment_method_selector").hide();
          }
        });
      }
    }
  }
  /* check zipcode with prefic */

  function setDelvieryDateANDapplyTOCartPage($) {
    /* add delviery date on detail page */
    /* add changes*/
    //message = message.replaceAll('div','span');




    eval(edd_options.additional_script);
    /* add cart filed value */
    if (display_on_other_page == '1' && activate_premium_feature == '1') {
      cartvalue = '';
      cartvalue = $('.deliverydate .delivery_msg').text();

      if (showOnlyDateOnCartpage == 1 || cart_msg_apperance == 'date') {
        if (getCartDate != '') {
          passcartvalue = getCartDate;
        } else {
          passcartvalue = cartvalue;
        }
        if (good_evas_customization == 1 && $('.sb_delivery .step_2_date').length) {
          passcartvalue = $('.sb_delivery .step_2_date').text()
          passcartvalue = passcartvalue.replace(/\s+/g, ' ').trim();
          if (passcartvalue.includes("-")) {
            passcartvalue = passcartvalue.split('-');
            good_evas_max_date = passcartvalue[1]
          } else {
            good_evas_max_date = passcartvalue
          }
          good_evas_max_date = good_evas_max_date.trim()

          date_key = get_shortcode_with_value_with_store_lag.indexOf(good_evas_max_date);
          good_evas_max_date = get_shortcode_with_value_with_en_lag[date_key]

          var currentYear = new Date().getFullYear();
          var fullDateString = `${good_evas_max_date} ${currentYear}`; // "Jan 5 2024"
          var fullDateString = fullDateString.replace(/\b(\d+)(st|nd|rd|th)\b/, '$1');

          // Parse into a Date object
          var check_date = new Date(fullDateString);

          if (!isNaN(check_date)) {
            // Format back to original date format (YYYY-MM-DD)
            var year = check_date.getFullYear();
            var month = (check_date.getMonth() + 1).toString().padStart(2, "0"); // Ensure 2-digit month
            var day = check_date.getDate().toString().padStart(2, "0"); // Ensure 2-digit day

            var originalFormat = `${year}-${month}-${day}`;
            good_evas_max_date = apply_date_formate($, 16, originalFormat,shoplanguage)

            $('.good_evas_max_date').text(good_evas_max_date)
          } else {
            $('.good_evas_max_date').text(passcartvalue)
          }
        }

      } else {
        passcartvalue = cartvalue;
      }
      if (cartAdditionalMessage != '') {
        passcartvalue = passcartvalue + ' ' + cartAdditionalMessage;
      }
      // for 3 step template add only first message to cart 
      // if($(".deliverydate.sb_delivery").find(".template_order").length > 0){
      //   var edd_template_msg = $(".deliverydate.sb_delivery .delivery_msg").clone();
      //   $(edd_template_msg ).find(".template_order").remove();
      //   $('.add_hidden_delivery').val($(edd_template_msg).text());
      // }else{
      if (donotupdateEDDmessage == '0') {
        if (typeof (sb_edd_zipcode_enable) == "undefined") {
          $('.add_hidden_delivery').val(passcartvalue);
        } else {
          if (sb_edd_zipcode_enable != "1") {
            $('.add_hidden_delivery').val(passcartvalue);
          }
        }
      }
      // }

    }

  }

  function getReplaceShortcodeAndGetDelvieryDateArrayHelathyMeals($) {
    var counteddsb = 0;
    var min_cart_index = 0;
    var max_cart_index = 0;

    for (var aeddsb = 0; aeddsb < shortcodeList.length; aeddsb++) {

      getMinMaxValue = shortcodeList[aeddsb].split(',');
      checkSHortcode = getMinMaxValue[0].toLowerCase();
      var is_numeric = $.isNumeric(getMinMaxValue[1]);
      var getValueFromShortcode = parseInt(getMinMaxValue[1]);
      var lead_days_from_shortcode = parseInt(getMinMaxValue[1]);
      var dontAddcutoff = false;
      var dontAddWeekoff = false;
      if (message.indexOf('3_step_1_date') != -1 && (getValueFromShortcode == '0' || getValueFromShortcode == 0)) {
        dontAddcutoff = true;
        dontAddWeekoff = true;
      }

      user_full_date = user_full_dateTimearay[0];
      var date = new Date(user_full_date);
      if (getValueFromShortcode != 0) {
        check_currentdate_is_sunday = false;
        while (!check_currentdate_is_sunday) {
          if (weekday[date.getDay()] != 'Sunday') {
            user_full_date = date.setDate(date.getDate() + 1);
            user_full_date = date.toString('dd' / 'MM' / 'yyyy');
          } else {
            check_currentdate_is_sunday = true;
            break;
          }
        }

        Cookday = 'Saturday';
        check_currentdate_is_saturday = false;
        while (!check_currentdate_is_saturday) {
          if (weekday[date.getDay()] != Cookday) {
            user_full_date = date.setDate(date.getDate() + 1);
            user_full_date = date.toString('dd' / 'MM' / 'yyyy');
          } else {
            check_currentdate_is_saturday = true;
            break;
          }
        }
      }
      if (checkOffDay($, date)) {
        check_currentDay_is_weekoff = 1;
      }
      check_cutoff = 'disabled'
      var newuser_full_date = new Date(user_full_date)

      if (is_numeric && (checkSHortcode.indexOf('min') != -1 || checkSHortcode.indexOf('max') != -1)) {

        /* check cutoff value and chanage the date accrdongly */
        var cut_off_enable = false;
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          // getValueFromShortcode = getValueFromShortcode + 1;
          date.setDate(date.getDate() + 1);
          newuser_full_date.setDate(newuser_full_date.getDate() + 1);
          cut_off_enable = true;
        }

        var first_day_week_off_checked = false;
        var up_next_is_not_week_off = false;

        for (keddsb = 1; keddsb <= getValueFromShortcode; keddsb++) {
          var current_day_weekoff = false;

          getNextDay = keddsb + 1;
          var user_current_day = weekday[date.getDay()];

          first_day_week_off_checked = true;
          if (checkOffDay($, date)) {
            if (dontAddcutoff && dontAddWeekoff) {
            } else {
              getValueFromShortcode = getValueFromShortcode + 1;
              current_day_weekoff = true;
            }
          }
          if (!current_day_weekoff) {
            if (checkDeliveryOffDay($, date)) {
              getValueFromShortcode = getValueFromShortcode + 1;
            }
          }
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
          check_currentDay_is_weekoff = 0;
        }

        /* get min/max delviery date */
        var date = new Date(user_full_date);
        if (cut_off_enable) {
          if (dontAddcutoff && dontAddWeekoff) { } else {
            getValueFromShortcode = getValueFromShortcode + 1
          }
        }

        check_last_weekday = false;
        if ((getMinMaxValue[2] == 'apply_weekoff' || getMinMaxValue[2] == 'apply_cutoff_weekoff' || message.indexOf('3_step_1_date') == -1) && (lead_days_from_shortcode == 0 || lead_days_from_shortcode == '0')) {
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)
          while (!check_last_weekday) {
            if (checkOffDay($, user_date_with_weekoff_cutoff)) {
              user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
              user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
            } else {
              check_last_weekday = true;
              break;
            }
          }
        } else {
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');

          if (getValueFromShortcode != '0' && getValueFromShortcode != 0) {
            while (!check_last_weekday) {
              if (checkDeliveryOffDay($, user_date_with_weekoff_cutoff)) {
                user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
                user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
              } else {
                check_last_weekday = true;
                break;
              }
            }
          }
        }

        if (counteddsb == 0) {
          edd_cart_min_day = getValueFromShortcode;
          edd_cart_max_day = getValueFromShortcode;
        }
        if (edd_cart_max_day < getValueFromShortcode) {
          edd_cart_min_day = edd_cart_max_day;
          min_cart_index = max_cart_index;
          edd_cart_max_day = getValueFromShortcode;
          max_cart_index = counteddsb
        }
        // if (edd_cart_min_day >= getValueFromShortcode) {
        //   edd_cart_min_day = getValueFromShortcode;
        //   min_cart_index = counteddsb
        // }

        user_date_with_weekoff_cutoff = apply_date_formate($, date_format, user_date_with_weekoff_cutoff,shoplanguage);
        get_shortcode_with_value['value' + counteddsb] = user_date_with_weekoff_cutoff;

      } else {
        /* get incorrect shortcode */
        get_shortcode_with_value['value' + counteddsb] = '{' + shortcodeList[aeddsb] + '}';
      }

      message_lowercase = message_lowercase.replace('{' + shortcodeList[aeddsb] + '}', "value" + counteddsb);
      /* replace short code in actual message */
      message = message.replace('{' + shortcodeList[aeddsb].toLowerCase() + '}', "value" + counteddsb);
      message = message.replace('{' + shortcodeList[aeddsb].toUpperCase() + '}', "value" + counteddsb);
      capitalizeSHortcode = shortcodeList[aeddsb].toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });

      message = message.replaceAll('{' + capitalizeSHortcode + '}', "value" + counteddsb);
      counteddsb++;
    }
    edd_cart_max_day = get_shortcode_with_value['value' + max_cart_index];
    edd_cart_min_day = get_shortcode_with_value['value' + min_cart_index];
  }

  function getReplaceShortcodeAndGetDelvieryDateArrayMrInapproprite($) {
    console.log('call mr inappropite logic')
    var counteddsb = 0;
    var min_cart_index = 0;
    var max_cart_index = 0;

    for (var aeddsb = 0; aeddsb < shortcodeList.length; aeddsb++) {
      getMinMaxValue = shortcodeList[aeddsb].split(',');
      checkSHortcode = getMinMaxValue[0].toLowerCase();
      var is_numeric = $.isNumeric(getMinMaxValue[1]);
      var getValueFromShortcode = parseInt(getMinMaxValue[1]);
      var lead_days_from_shortcode = parseInt(getMinMaxValue[1]);
      var dontAddcutoff = false;
      var dontAddWeekoff = false;
      var check_do_not_add_cutoff_globel = false

      if (skip_current_day_for_delivery_weekoff == 1) {
      check_date1 = new Date(user_full_date)
      user_full_date = new Date(user_full_date)
      check_current_day = weekday[user_full_date.getDay()]
      
      getSunday = false
      
      if (checkOffDay($, new Date()) && checkDeliveryOffDay($, new Date())) {
        check_currentDay_is_weekoff = 0;
        getSunday = true
      }

      if (checkOffDay($, user_full_date, 'weekoff')) {
        check_do_not_add_cutoff_globel = true;
        user_full_date = user_full_date.setDate(user_full_date.getDate() - 1);
        user_full_date = new Date(user_full_date)
        if (checkOffDay($, user_full_date, 'weekoff')) {
          user_full_date = user_full_date.setDate(user_full_date.getDate() - 1);
          user_full_date = new Date(user_full_date)
        }
      }
      /* check cut off less for friday */
      if (check_cutoff == 'less') {
        check_date1 = check_date1.setDate(check_date1.getDate() + 1);
        if (checkOffDay($, check_date1, 'weekoff')) {
          check_do_not_add_cutoff_globel = true;
        }
      }
      if(getSunday){
        check_do_not_add_cutoff_globel = false;
      }
    }

      if (message.indexOf('3_step_1_date') != -1 && (getValueFromShortcode == '0' || getValueFromShortcode == 0)) {
        dontAddcutoff = true;
        dontAddWeekoff = true;
      }

      if (typeof getMinMaxValue[2] != 'undefined') {
        if (getMinMaxValue[2] == 'apply_cutoff') {
          dontAddcutoff = false
        }
        else if (getMinMaxValue[2] == 'apply_weekoff') {
          dontAddWeekoff = false
        }
        else if (getMinMaxValue[2] == 'apply_cutoff_weekoff') {
          dontAddWeekoff = false
          dontAddcutoff = false
        }
        else if (getMinMaxValue[2] == 'no_cutoff') {
          dontAddcutoff = true
        }
        else if (getMinMaxValue[2] == 'no_weekoff') {
          dontAddWeekoff = true
        }
        else if (getMinMaxValue[2] == 'no_cutoff_weekoff') {
          dontAddWeekoff = true
          dontAddcutoff = true
        }
      }
      if (check_do_not_add_cutoff_globel) {
        dontAddcutoff = true
      }
      
      var date = new Date(user_full_date);
      var newuser_full_date = new Date(user_full_date)

      if (is_numeric && (checkSHortcode.indexOf('min') != -1 || checkSHortcode.indexOf('max') != -1)) {

        var cut_off_enable = false;
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          // getValueFromShortcode = getValueFromShortcode + 1;
          date.setDate(date.getDate() + 1);
          newuser_full_date.setDate(newuser_full_date.getDate() + 1);
          cut_off_enable = true;
        }
        getValueFromShortcode = parseInt(getValueFromShortcode);

        dispatch_day = 0;
        if(getValueFromShortcode > 0 ){
          prepareation_day = getValueFromShortcode;
          dispatch_day = 1;
          if(prepareation_day % 2 != 0){
            dispatch_day = 2
          }
        }
        prepareation_day = getValueFromShortcode - dispatch_day;
        
        if (cut_off_enable) {
          if (dontAddcutoff && dontAddWeekoff) { } else {
            if (dontAddcutoff) {

            } else {
              prepareation_day = prepareation_day + 1
            }
          }
        }
        
        user_date_with_weekoff_cutoff = new Date();
        var date = new Date(user_full_date);
        for (keddsb = 1; keddsb <= prepareation_day; keddsb++) {

          var current_day_weekoff = false;

          var user_current_day = weekday[date.getDay()];

          first_day_week_off_checked = true;
          if (checkOffDay($, date)) {
            if (dontAddcutoff && dontAddWeekoff) {

            } else {
              prepareation_day = prepareation_day + 1;
              current_day_weekoff = true;
            }

          }

          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        }

        check_last_weekday = false;
        while (!check_last_weekday) {
          if (checkOffDay($, user_date_with_weekoff_cutoff)) {
            console.log('get week off day in final date')
            user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
            user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
          } else {
            check_last_weekday = true;
            break;
          }
        }
        
        /* add dispatch day */
        for (keddsb = 1; keddsb <= dispatch_day; keddsb++) {
        var user_current_day = weekday[date.getDay()];
        if (checkDeliveryOffDay($, date)) {
          if (dontAddcutoff && dontAddWeekoff) {
          } else {
            dispatch_day = dispatch_day + 1;
          }

        }
        user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1)
        user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        }

        // user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
        // user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        /* add dispatch day */

        check_last_weekday = false;
        while (!check_last_weekday) {
          if (checkDeliveryOffDay($,user_date_with_weekoff_cutoff)) {
            console.log('get delivery off day in final date')
            user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
            user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
          } else {
            check_last_weekday = true;
            break;
          }
        }

        if (counteddsb == 0) {
          edd_cart_min_day = getValueFromShortcode;
          edd_cart_max_day = getValueFromShortcode;
        }
        if (edd_cart_max_day < getValueFromShortcode) {
          edd_cart_max_day = getValueFromShortcode;
          max_cart_index = counteddsb
        }
        if (edd_cart_min_day >= getValueFromShortcode) {
          edd_cart_min_day = getValueFromShortcode;
          min_cart_index = counteddsb
        }

        user_date_with_weekoff_cutoff = apply_date_formate($,date_format, user_date_with_weekoff_cutoff);
        /* apply today & tomorrow */

        if(change_date_to_today_tomorrow){

          if (getValueFromShortcode == '0') {
            today_transation = sb_edd_options.today_transation;
            if (typeof today_transation == 'undefined') {
              today_transation = 'Today';
            }
            if(translation_obj != 'not_set'){
              translation_today_from_obj = translation_obj.trans_today_transation
              check_translation_today_from_obj = translation_today_from_obj.replaceAll(' ','')
              if(typeof translation_today_from_obj != 'undefined' && check_translation_today_from_obj.length > 0){
                  today_transation = translation_today_from_obj
              }
            }
            user_date_with_weekoff_cutoff = today_transation
          }
          if (getValueFromShortcode == '1') {
            tomorrow_transation = sb_edd_options.tomorrow_transation;
            if (typeof tomorrow_transation == 'undefined') {
              tomorrow_transation = 'Tomorrow';
            }
            if(translation_obj != 'not_set'){
              translation_tomorrow_from_obj = translation_obj.trans_tomorrow_transation;
              check_translation_tomorrow_from_obj = translation_tomorrow_from_obj.replaceAll(' ','')
              if(typeof translation_tomorrow_from_obj != 'undefined' && check_translation_tomorrow_from_obj.length > 0){
                tomorrow_transation = translation_tomorrow_from_obj
              }
            }
            user_date_with_weekoff_cutoff = tomorrow_transation
          }
      }
        /* apply today & tomorrow */
        get_shortcode_with_value['value' + counteddsb] = user_date_with_weekoff_cutoff;

      } else {
        /* get incorrect shortcode */
        get_shortcode_with_value['value' + counteddsb] = '{' + shortcodeList[aeddsb] + '}';
      }

      message_lowercase = message_lowercase.replace('{' + shortcodeList[aeddsb] + '}', "value" + counteddsb);
      /* replace short code in actual message */
      message = message.replace('{' + shortcodeList[aeddsb].toLowerCase() + '}', "value" + counteddsb);
      message = message.replace('{' + shortcodeList[aeddsb].toUpperCase() + '}', "value" + counteddsb);
      capitalizeSHortcode = shortcodeList[aeddsb].toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });

      message = message.replaceAll('{' + capitalizeSHortcode + '}', "value" + counteddsb);
      counteddsb++;
    }
    edd_cart_max_day = get_shortcode_with_value['value' + max_cart_index];
    edd_cart_min_day = get_shortcode_with_value['value' + min_cart_index];

  }



  function getReplaceShortcodeAndGetDelvieryDateArrayWithDeliveryOffDay($) {
    var counteddsb = 0;
    var min_cart_index = 0;
    var max_cart_index = 0;
    var check_do_not_add_cutoff_globel = false

    if(skip_current_day_for_delivery_weekoff == 1){
      check_date1 = new Date(user_full_date)
      user_full_date = new Date(user_full_date)
      check_current_day = weekday[check_date1.getDay()]
        /* check current day is Saturday */
        if (checkOffDay($, user_full_date)) {
            check_do_not_add_cutoff_globel = true;
            user_full_date = user_full_date.setDate(user_full_date.getDate() - 1);
            user_full_date = new Date(user_full_date)
            /* check current day is Sunday */
          if (checkOffDay($, user_full_date)) {
            user_full_date = user_full_date.setDate(user_full_date.getDate() - 1);  
            user_full_date = new Date(user_full_date)
          }
        }
        /* check cut off less for friday */
        if(check_cutoff == 'less'){ 
          check_date1 = check_date1.setDate(check_date1.getDate() + 1);
          if (checkOffDay($, check_date1)) {
            check_do_not_add_cutoff_globel = true;
          }
        }
    }

    for (var aeddsb = 0; aeddsb < shortcodeList.length; aeddsb++) {

      getMinMaxValue = shortcodeList[aeddsb].split(',');
      checkSHortcode = getMinMaxValue[0].toLowerCase();
      var is_numeric = $.isNumeric(getMinMaxValue[1]);
      var getValueFromShortcode = parseInt(getMinMaxValue[1]);
      var lead_days_from_shortcode = parseInt(getMinMaxValue[1]);
      var dontAddcutoff = false;
      var dontAddWeekoff = false;
      if (message.indexOf('3_step_1_date') != -1 && (getValueFromShortcode == '0' || getValueFromShortcode == 0)) {
        dontAddcutoff = true;
        dontAddWeekoff = true;
      }
      if (message.indexOf('3_step_2_date') != -1 && (getValueFromShortcode == '1' || getValueFromShortcode == 1)) {
        // dontAddcutoff = true;
        //dontAddWeekoff = true;
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          //  dontAddWeekoff = true;
        }

      }

      apply_weekoff_for_0_day = 0;
      if (typeof getMinMaxValue[2] != 'undefined') {
        if (getMinMaxValue[2] == 'apply_cutoff') {
          dontAddcutoff = false
        }
        else if (getMinMaxValue[2] == 'apply_weekoff') {
          dontAddWeekoff = false;
          apply_weekoff_for_0_day = 1
        }
        else if (getMinMaxValue[2] == 'apply_cutoff_weekoff') {
          dontAddWeekoff = false
          dontAddcutoff = false
          apply_weekoff_for_0_day = 1
        }
        else if (getMinMaxValue[2] == 'no_cutoff') {
          dontAddcutoff = true
        }
        else if (getMinMaxValue[2] == 'no_weekoff') {
          dontAddWeekoff = true
        }
        else if (getMinMaxValue[2] == 'no_cutoff_weekoff') {
          dontAddWeekoff = true
          dontAddcutoff = true
        }

      }

      if(check_do_not_add_cutoff_globel){
        dontAddcutoff = true
      }

      var date = new Date(user_full_date);
      var newuser_full_date = new Date(user_full_date)

      if (is_numeric && (checkSHortcode.indexOf('min') != -1 || checkSHortcode.indexOf('max') != -1)) {

        /* check cutoff value and chanage the date accrdongly */
        var cut_off_enable = false;
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          // getValueFromShortcode = getValueFromShortcode + 1;
          date.setDate(date.getDate() + 1);
          newuser_full_date.setDate(newuser_full_date.getDate() + 1);
          cut_off_enable = true;
        }

        var first_day_week_off_checked = false;
        var up_next_is_not_week_off = false;

        for (keddsb = 1; keddsb <= getValueFromShortcode; keddsb++) {
          var current_day_weekoff = false;

          getNextDay = keddsb + 1;
          var user_current_day = weekday[date.getDay()];

          // if (!up_next_is_not_week_off) {
          first_day_week_off_checked = true;
          if (checkOffDay($, date)) {
            if (dontAddcutoff && dontAddWeekoff) {
            } else {
              getValueFromShortcode = getValueFromShortcode + 1;
              current_day_weekoff = true;
            }

          }
          //}

          if (!current_day_weekoff) {
            if (checkDeliveryOffDay($, date)) {

              getValueFromShortcode = getValueFromShortcode + 1;
            }
          }

          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        }

        /* get min/max delviery date */
        var date = new Date(user_full_date);
        if (cut_off_enable) {
          if (dontAddcutoff && dontAddWeekoff) { } else {
            if(dontAddcutoff){

            }else{  
                getValueFromShortcode = getValueFromShortcode + 1
            }
          }
        }
        
        check_last_weekday = false;
        if ((apply_weekoff_for_0_day == 1 || message.indexOf('3_step_1_date') == -1) && (lead_days_from_shortcode == 0 || lead_days_from_shortcode == '0')) {
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)

          while (!check_last_weekday) {
            if (checkOffDay($, user_date_with_weekoff_cutoff)) {
              getValueFromShortcode = getValueFromShortcode + 1 //update the ETA when cutoff & week off got & working day is off 27-03-25
              user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
              user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
            } else {
              check_last_weekday = true;
              break;
            }
          }
        } else {
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
          while (!check_last_weekday) {
            if (checkDeliveryOffDay($, user_date_with_weekoff_cutoff)) {
              user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
              user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
            } else {
              check_last_weekday = true;
              break;
            }
          }
        }

        if (counteddsb == 0) {
          edd_cart_min_day = getValueFromShortcode;
          edd_cart_max_day = getValueFromShortcode;
        }
        if (edd_cart_max_day < getValueFromShortcode) {
          edd_cart_min_day = edd_cart_max_day;
          min_cart_index = max_cart_index;
          edd_cart_max_day = getValueFromShortcode;
          max_cart_index = counteddsb
        }
        // if (edd_cart_min_day >= getValueFromShortcode) {
        //   edd_cart_min_day = getValueFromShortcode;
        //   min_cart_index = counteddsb
        // }

        user_date_with_weekoff_cutoff = apply_date_formate($, date_format, user_date_with_weekoff_cutoff,shoplanguage);

        if(change_date_to_today_tomorrow){

            if (getValueFromShortcode == '0') {
              today_transation = sb_edd_options.today_transation;
              if (typeof today_transation == 'undefined') {
                today_transation = 'Today';
              }
              if(translation_obj != 'not_set'){
                translation_today_from_obj = translation_obj.trans_today_transation
                check_translation_today_from_obj = translation_today_from_obj.replaceAll(' ','')
                if(typeof translation_today_from_obj != 'undefined' && check_translation_today_from_obj.length > 0){
                    today_transation = translation_today_from_obj
                }
              }
              user_date_with_weekoff_cutoff = today_transation
            }
            if (getValueFromShortcode == '1') {
              tomorrow_transation = sb_edd_options.tomorrow_transation;
              if (typeof tomorrow_transation == 'undefined') {
                tomorrow_transation = 'Tomorrow';
              }
              if(translation_obj != 'not_set'){
                translation_tomorrow_from_obj = translation_obj.trans_tomorrow_transation;
                check_translation_tomorrow_from_obj = translation_tomorrow_from_obj.replaceAll(' ','')
                if(typeof translation_tomorrow_from_obj != 'undefined' && check_translation_tomorrow_from_obj.length > 0){
                  tomorrow_transation = translation_tomorrow_from_obj
                }
              }
              user_date_with_weekoff_cutoff = tomorrow_transation
            }
        }
        
        get_shortcode_with_value['value' + counteddsb] = user_date_with_weekoff_cutoff;

      } else {
        /* get incorrect shortcode */
        get_shortcode_with_value['value' + counteddsb] = '{' + shortcodeList[aeddsb] + '}';
      }

      message_lowercase = message_lowercase.replace('{' + shortcodeList[aeddsb] + '}', "value" + counteddsb);
      /* replace short code in actual message */
      message = message.replace('{' + shortcodeList[aeddsb].toLowerCase() + '}', "value" + counteddsb);
      message = message.replace('{' + shortcodeList[aeddsb].toUpperCase() + '}', "value" + counteddsb);
      capitalizeSHortcode = shortcodeList[aeddsb].toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });

      message = message.replaceAll('{' + capitalizeSHortcode + '}', "value" + counteddsb);
      counteddsb++;
    }
    edd_cart_max_day = get_shortcode_with_value['value' + max_cart_index];
    edd_cart_min_day = get_shortcode_with_value['value' + min_cart_index];
  }

  function getReplaceShortcodeAndGetDelvieryDateArray($) {
    //Object.keys(get_shortcode_with_value).length;
    var counteddsb = 0;
    var min_cart_index = 0;
    var max_cart_index = 0;
    var edd_date_formate = { day: '2-digit', month: '2-digit', year: '2-digit' };

    for (var aeddsb = 0; aeddsb < shortcodeList.length; aeddsb++) {
      getMinMaxValue = shortcodeList[aeddsb].split(',');
      checkSHortcode = getMinMaxValue[0].toLowerCase();
      var is_numeric = $.isNumeric(getMinMaxValue[1]);
      var getValueFromShortcode = parseInt(getMinMaxValue[1]);

      var date = new Date(user_full_date);
      if (is_numeric && (checkSHortcode.indexOf('min') != -1 || checkSHortcode.indexOf('max') != -1)) {

        /* get new min/max value if get week offday */
        for (keddsb = 0; keddsb <= getValueFromShortcode; keddsb++) {

          var dontAddcutoff = false;
          var dontAddWeekoff = false;
          if (message.indexOf('3_step_1_date') != -1 && (getValueFromShortcode == '0' || getValueFromShortcode == 0)) {
            dontAddcutoff = true;
            dontAddWeekoff = true;
          }
          if (message.indexOf('3_step_2_date') != -1 && (getValueFromShortcode == '1' || getValueFromShortcode == 1)) {
            //dontAddcutoff = true;
            //dontAddWeekoff = true;
            if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
              //dontAddWeekoff = true;
            }

          }

          if (typeof getMinMaxValue[2] != 'undefined') {
            if (getMinMaxValue[2] == 'apply_cutoff') {
              dontAddcutoff = false
            }
            else if (getMinMaxValue[2] == 'apply_weekoff') {
              dontAddWeekoff = false
            }
            else if (getMinMaxValue[2] == 'apply_cutoff_weekoff') {
              dontAddWeekoff = false
              dontAddcutoff = false
            }
            else if (getMinMaxValue[2] == 'no_cutoff') {
              dontAddcutoff = true
            }
            else if (getMinMaxValue[2] == 'no_weekoff') {
              dontAddWeekoff = true
            }
            else if (getMinMaxValue[2] == 'no_cutoff_weekoff') {
              dontAddWeekoff = true
              dontAddcutoff = true
            }

          }

          getNextDay = keddsb + 1;

          var user_current_day = weekday[date.getDay()];

          if (checkOffDay($, date)) {
            if (dontAddcutoff && dontAddWeekoff) {

            } else {
              getValueFromShortcode = getValueFromShortcode + 1;
            }
          }


          var date = new Date(user_full_date);
          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getNextDay)
          if (shopnamefull == 'janyas-closet1.myshopify.com') {
            user_date_with_weekoff_cutoff = date.toLocaleDateString(edd_date_formate);
          } else {
            user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
          }
        }


        /* get min/max delviery date */
        var date = new Date(user_full_date);
        user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)
        //user_date_with_weekoff_cutoff =date.toString('dd'/'MM'/'yyyy');
        if (shopnamefull == 'janyas-closet1.myshopify.com') {
          user_date_with_weekoff_cutoff = date.toLocaleDateString(edd_date_formate);
        } else {
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        }

        apply_cutoff_for_working_day = 0;
        /* check cutoff value and chanage the date accrdongly */
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          if (dontAddcutoff && dontAddWeekoff) {
          } else {
            apply_cutoff_for_working_day = apply_cutoff_for_working_day  + 1
            user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
            //user_date_with_weekoff_cutoff =date.toString('dd'/'MM'/'yyyy');
            if (shopnamefull == 'janyas-closet1.myshopify.com') {
              user_date_with_weekoff_cutoff = date.toLocaleDateString(edd_date_formate);
            } else {
              user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
            }
          }
        }

        if (dontAddcutoff && dontAddWeekoff) {
        } else {
          /* after cutoff check the date is week off day or not */
          check_last_weekday = false;
          while (!check_last_weekday) {
            if (checkOffDay($, user_date_with_weekoff_cutoff)) {
              apply_cutoff_for_working_day = apply_cutoff_for_working_day  + 1
              user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
              //user_date_with_weekoff_cutoff =date.toString('dd'/'MM'/'yyyy');
              if (shopnamefull == 'janyas-closet1.myshopify.com') {
                user_date_with_weekoff_cutoff = date.toLocaleDateString(edd_date_formate);
              } else {
                user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
              }
            } else {
              check_last_weekday = true;
              break;
            }
          }

          /* check last date is delivery weekoff days*/
          check_last_weekday = false;
          while (!check_last_weekday) {
            if (checkDeliveryOffDay($, user_date_with_weekoff_cutoff)) {
              apply_cutoff_for_working_day = apply_cutoff_for_working_day  + 1
              user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1);
              user_date_with_weekoff_cutoff = date.toString('dd-MM-yy');
            } else {
              check_last_weekday = true;
              break;
            }
          }
        }

        if (counteddsb == 0) {
          edd_cart_min_day = getValueFromShortcode;
          edd_cart_max_day = getValueFromShortcode;
        }
        if (edd_cart_max_day < getValueFromShortcode) {
          edd_cart_min_day = edd_cart_max_day;
          min_cart_index = max_cart_index;
          edd_cart_max_day = getValueFromShortcode;
          max_cart_index = counteddsb
        }
        // if (edd_cart_min_day >= getValueFromShortcode) {
        //   edd_cart_min_day = getValueFromShortcode;
        //   min_cart_index = counteddsb
        // }

        // if (edd_cart_min_day <= getValueFromShortcode && edd_cart_min_day < edd_cart_max_day && getValueFromShortcode < edd_cart_max_day) {
        //   edd_cart_min_day = getValueFromShortcode;
        //   min_cart_index = counteddsb
        // }
        date_in_en_lan = apply_date_formate($, date_format, user_date_with_weekoff_cutoff,'en');
        user_date_with_weekoff_cutoff = apply_date_formate($, date_format, user_date_with_weekoff_cutoff,shoplanguage);

        /* apply today & tomorrow instead of today & tomorrow date */
        if(change_date_to_today_tomorrow){
          check_shortcode_value = getValueFromShortcode
          if(apply_cutoff_for_working_day != 0){
            check_shortcode_value = getValueFromShortcode + apply_cutoff_for_working_day
          }
          
            if (getValueFromShortcode == '0') {
              today_transation = sb_edd_options.today_transation;
              if (typeof today_transation == 'undefined') {
                today_transation = 'Today';
              }
              if(translation_obj != 'not_set'){
                translation_today_from_obj = translation_obj.trans_today_transation
                check_translation_today_from_obj = translation_today_from_obj.replaceAll(' ','')
                if(typeof translation_today_from_obj != 'undefined' && check_translation_today_from_obj.length > 0){
                    today_transation = translation_today_from_obj
                }
              }
              user_date_with_weekoff_cutoff = today_transation
            }
            if (check_shortcode_value == '1') {
              tomorrow_transation = sb_edd_options.tomorrow_transation;
              if (typeof tomorrow_transation == 'undefined') {
                tomorrow_transation = 'Tomorrow';
              }
              if(translation_obj != 'not_set'){
                translation_tomorrow_from_obj = translation_obj.trans_tomorrow_transation;
                check_translation_tomorrow_from_obj = translation_tomorrow_from_obj.replaceAll(' ','')
                if(typeof translation_tomorrow_from_obj != 'undefined' && check_translation_tomorrow_from_obj.length > 0){
                  tomorrow_transation = translation_tomorrow_from_obj
                }
              }
              user_date_with_weekoff_cutoff = tomorrow_transation
            }
        }

        /* apply today & tomorrow instead of today & tomorrow date */

        get_shortcode_with_value['value' + counteddsb] = user_date_with_weekoff_cutoff;
        get_shortcode_with_value_with_en_lag.push(date_in_en_lan)
        get_shortcode_with_value_with_store_lag.push(user_date_with_weekoff_cutoff)

      } else {
        /* get incorrect shortcode */
        get_shortcode_with_value['value' + counteddsb] = '{' + shortcodeList[aeddsb] + '}';
        get_shortcode_with_value_with_en_lag.push('{' + shortcodeList[aeddsb] + '}')
        get_shortcode_with_value_with_store_lag.push('{' + shortcodeList[aeddsb] + '}')
      }

      message_lowercase = message_lowercase.replace('{' + shortcodeList[aeddsb] + '}', "value" + counteddsb);
      /* replace short code in actual message */
      message = message.replace('{' + shortcodeList[aeddsb].toLowerCase() + '}', "value" + counteddsb);
      message = message.replace('{' + shortcodeList[aeddsb].toUpperCase() + '}', "value" + counteddsb);
      capitalizeSHortcode = shortcodeList[aeddsb].toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });

      message = message.replaceAll('{' + capitalizeSHortcode + '}', "value" + counteddsb);
      counteddsb++;
    }
    edd_cart_max_day = get_shortcode_with_value['value' + max_cart_index];
    edd_cart_min_day = get_shortcode_with_value['value' + min_cart_index];
  }


  function getReplaceShortcodeAndGetDelvieryDateArrayMayuri($) {
    var counteddsb = 0;
    var min_cart_index = 0;
    var max_cart_index = 0;

    for (var aeddsb = 0; aeddsb < shortcodeList.length; aeddsb++) {

      getMinMaxValue = shortcodeList[aeddsb].split(',');
      checkSHortcode = getMinMaxValue[0].toLowerCase();
      var is_numeric = $.isNumeric(getMinMaxValue[1]);
      var getValueFromShortcode = parseInt(getMinMaxValue[1]);

      var date = new Date(user_full_date);
      var newuser_full_date = new Date(user_full_date)

      if (is_numeric && (checkSHortcode.indexOf('min') != -1 || checkSHortcode.indexOf('max') != -1)) {

        /* check cutoff value and chanage the date accrdongly */
        var cut_off_enable = false;
        if (check_cutoff == 'less' && check_currentDay_is_weekoff == 0) {
          // getValueFromShortcode = getValueFromShortcode + 1;
          date.setDate(date.getDate() + 1);
          newuser_full_date.setDate(newuser_full_date.getDate() + 1);
          cut_off_enable = true;
        }

        var first_day_week_off_checked = false;
        var up_next_is_not_week_off = false;

        for (keddsb = 1; keddsb <= getValueFromShortcode; keddsb++) {
          var current_day_weekoff = false;

          getNextDay = keddsb + 1;
          var user_current_day = weekday[date.getDay()];

          if (!up_next_is_not_week_off) {
            first_day_week_off_checked = true;
            if (checkOffDay($, date)) {
              getValueFromShortcode = getValueFromShortcode + 1;
              current_day_weekoff = true;
            }
            else {
              up_next_is_not_week_off = true;
            }
          }

          if (!current_day_weekoff) {
            if (checkDeliveryOffDay($, date)) {
              getValueFromShortcode = getValueFromShortcode + 1;
            }
          }

          user_date_with_weekoff_cutoff = date.setDate(date.getDate() + 1)
          user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');
        }

        /* get min/max delviery date */
        var date = new Date(user_full_date);
        if (!cut_off_enable) {
          getValueFromShortcode = getValueFromShortcode - 1
        }
        user_date_with_weekoff_cutoff = date.setDate(date.getDate() + getValueFromShortcode)
        user_date_with_weekoff_cutoff = date.toString('dd' / 'MM' / 'yyyy');

        if (counteddsb == 0) {
          edd_cart_min_day = getValueFromShortcode;
          edd_cart_max_day = getValueFromShortcode;
        }
        if (edd_cart_max_day < getValueFromShortcode) {
          edd_cart_max_day = getValueFromShortcode;
          max_cart_index = counteddsb
        }
        if (edd_cart_min_day >= getValueFromShortcode) {
          edd_cart_min_day = getValueFromShortcode;
          min_cart_index = counteddsb
        }

        user_date_with_weekoff_cutoff = apply_date_formate($, date_format, user_date_with_weekoff_cutoff,shoplanguage);
        get_shortcode_with_value['value' + counteddsb] = user_date_with_weekoff_cutoff;

      } else {
        /* get incorrect shortcode */
        get_shortcode_with_value['value' + counteddsb] = '{' + shortcodeList[aeddsb] + '}';
      }

      message_lowercase = message_lowercase.replace('{' + shortcodeList[aeddsb] + '}', "value" + counteddsb);
      /* replace short code in actual message */
      message = message.replace('{' + shortcodeList[aeddsb].toLowerCase() + '}', "value" + counteddsb);
      message = message.replace('{' + shortcodeList[aeddsb].toUpperCase() + '}', "value" + counteddsb);
      capitalizeSHortcode = shortcodeList[aeddsb].toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });

      message = message.replaceAll('{' + capitalizeSHortcode + '}', "value" + counteddsb);
      counteddsb++;
    }
    edd_cart_max_day = get_shortcode_with_value['value' + max_cart_index];
    edd_cart_min_day = get_shortcode_with_value['value' + min_cart_index];
  }

  function getShortCodeFromMessage($) {
    var rxp = /{([^}]+)}/g, curMatch;
    message_lowercase = message.toLowerCase();

    for (i = 0; i < shortcodeList.length + 1; i++) {
      shortcodeList.pop();
    }
    shortcodeList = [];
    while (curMatch = rxp.exec(message_lowercase)) {
      lowercase_shortcode = curMatch[1];
      shortcodeList.push(lowercase_shortcode.toLowerCase());
    }
  }

  function checkCurrentDayIsWorkngDay($, date) {
    var user_current_day = weekday[date.getDay()];
    if (checkOffDay($, date)) {
      check_currentDay_is_weekoff = 1;
    }
  }

  /* holiday */
  function checkOffDay($, date) {
    date = new Date(date);
    year = date.getFullYear();   //like 2021

    month = date.getMonth() + 1; // like 5
    month = (('' + month).length < 2 ? '0' : '') + month; // like 05

    singleDigitday = date.getDate();     //like 2
    day = date.getDate();
    day = (('' + day).length < 2 ? '0' : '') + day;

    check_holidays = year + '-' + month + '-' + day
    check_every_year_holidays = month + '-' + day
    var user_current_day = weekday[date.getDay()];
    get_off_day = false;


    if (off_day.includes(user_current_day) || holidays.includes(check_holidays) || every_year_holidays.includes(check_every_year_holidays)) {
      get_off_day = true;
    }

    return get_off_day;
  }
  function checkDeliveryOffDay($, date) {
    date = new Date(date);
    year = date.getFullYear();   //like 2021

    month = date.getMonth() + 1; // like 5
    month = (('' + month).length < 2 ? '0' : '') + month; // like 05

    singleDigitday = date.getDate();     //like 2
    day = date.getDate();
    day = (('' + day).length < 2 ? '0' : '') + day;

    check_holidays = year + '-' + month + '-' + day
    check_every_year_holidays = month + '-' + day
    var user_current_day = weekday[date.getDay()];
    get_off_day = false;


    if (delivery_off_day.includes(user_current_day) || holidays.includes(check_holidays) || every_year_holidays.includes(check_every_year_holidays)) {
      get_off_day = true;
    }

    return get_off_day;
  }
  /* holiday */

  function addPremiumPlanFeture($) {
    //if (activate_premium_feature == '1') {
    checkShortcode = message.toLowerCase();
    if (checkShortcode.indexOf('shipping_dropdown') != -1) {
      message = message.replaceAll('{shipping_dropdown}', '<span class="shipping_shortcode hightlight_date"></span>');
    }

    if (checkShortcode.indexOf('countdown') != -1) {
      addCountDownTimer($);
    }
    if (checkShortcode.indexOf('country') != -1) {
      message = add_country_flag_name(message);
    }
    if (checkShortcode.indexOf('store_pickup_link') != -1 ) {
      sb_edd_store_locatore_enable = '1';
      message =  updateStoreLocatorMessage(message);
     }
    if (display_on_other_page == '1' && remove_cart_property == '0') {
      displayOnCartPage($);
    }
    //  }
  }



  var translateOrdinalJson = {
    af: { st: "ste", nd: "de", rd: "de", th: "ste" },
    am: { st: "áŠ­ááˆ", nd: "áŠ­á‹áˆ", rd: "áŠ­ááˆ", th: "áŠ­á‹áˆ" },
    ar: { st: "Ø§Ù„Ø£ÙˆÙ„", nd: "Ø§Ù„Ø«Ø§Ù†ÙŠ", rd: "Ø§Ù„Ø«Ø§Ù„Ø«", th: "Ø§Ù„Ø«Ø§Ù†ÙŠ" },
    az: { st: "ci", nd: "ci", rd: "ci", th: "ci" },
    be: { st: "Ñ‹", nd: "Ñ‹", rd: "Ñ‹", th: "Ñ‹" },
    bg: { st: "Ð²Ð¸", nd: "Ñ€Ð¸", rd: "Ñ‚Ð¸", th: "Ñ‚Ð¸" },
    bn: { st: "à¦®", nd: "à¦°", rd: "à¦°à§à¦¥", th: "à¦°à§à¦¥" },
    bs: { st: ".", nd: ".", rd: ".", th: "." },
    ca: { st: "Ã¨", nd: "Ã¨", rd: "Ã¨", th: "Ã¨" },
    cs: { st: ".", nd: ".", rd: ".", th: "." },
    cy: { st: "af", nd: "ail", rd: "ydd", th: "ydd" },
    da: { st: ".", nd: ".", rd: ".", th: "." },
    de: { st: ".", nd: ".", rd: ".", th: "." },
    el: { st: "Î¿ÏƒÏ„ÏŒÏ‚", nd: "Î¿Ï‚", rd: "ÏŒÏ‚", th: "ÏŒÏ‚" },
    en: { st: "st", nd: "nd", rd: "rd", th: "th" },
    eo: { st: "a", nd: "a", rd: "a", th: "a" },
    es: { st: "ro", nd: "do", rd: "ro", th: "to" },
    et: { st: ".", nd: ".", rd: ".", th: "." },
    eu: { st: ".", nd: ".", rd: ".", th: "." },
    fa: { st: "Ù…", nd: "Ù…", rd: "Ù…", th: "Ù…" },
    fi: { st: ".", nd: ".", rd: ".", th: "." },
    fil: { st: "unang", nd: "ikalawa", rd: "ikatlo", th: "ika-" },
    fo: { st: ".", nd: ".", rd: ".", th: "." },
    fr: { st: "er", nd: "nd", rd: "rd", th: "e" },
    ga: { st: "dÃ©", nd: "Ãº", rd: "Ãº", th: "Ãº" },
    gl: { st: "Âº", nd: "Âº", rd: "Âº", th: "Âº" },
    gu: { st: "àª¥à«‹", nd: "àª¥à«€", rd: "àª¥à«€", th: "àª¥à«€" },
    ha: { st: ".", nd: ".", rd: ".", th: "." },
    he: { st: ".", nd: ".", rd: ".", th: "." },
    hi: { st: "à¤µà¤¾", nd: "à¤°à¤¾", rd: "à¤°à¤¾", th: "à¤°à¤¾" },
    hr: { st: ".", nd: ".", rd: ".", th: "." },
    hu: { st: ".", nd: ".", rd: ".", th: "." },
    hy: { st: "Õ¥Ö€Õ¯Õ¸Ö‚", nd: "Ö€Õ¸Ö€Õ¤", rd: "Ö€Ö€Õ¤", th: "Ö€Ö€Õ¤" },
    id: { st: "ke", nd: "ke", rd: "ke", th: "ke" },
    ig: { st: ".", nd: ".", rd: ".", th: "." },
    is: { st: ".", nd: ".", rd: ".", th: "." },
    it: { st: "Â°", nd: "Â°", rd: "Â°", th: "Â°" },
    ja: { st: "æ—¥", nd: "æ—¥", rd: "æ—¥", th: "æ—¥" },
    ka: { st: ".", nd: ".", rd: ".", th: "." },
    kk: { st: "-ÑˆÑ–", nd: "-ÑˆÑ–", rd: "-ÑˆÑ–", th: "-ÑˆÑ–" },
    km: { st: "áž‘áž¸", nd: "áž‘áž¸", rd: "áž‘áž¸", th: "áž‘áž¸" },
    kn: { st: "à²¨à³‡", nd: "à²¨à³†", rd: "à²¨à³†", th: "à²¨à³†" },
    ko: { st: "ì¼", nd: "ì´", rd: "ì‚¼", th: "ì¼" },
    ky: { st: "-Ñ‡Ð¸", nd: "-Ñ‡Ð¸", rd: "-Ñ‡Ð¸", th: "-Ñ‡Ð¸" },
    lb: { st: ".", nd: ".", rd: ".", th: "." },
    lo: { st: "àº—àºµà»ˆ", nd: "àº—àºµà»ˆ", rd: "àº—àºµà»ˆ", th: "àº—àºµà»ˆ" },
    lt: { st: "-asis", nd: "-asis", rd: "-asis", th: "-asis" },
    lv: { st: ".", nd: ".", rd: ".", th: "." },
    mg: { st: ".", nd: ".", rd: ".", th: "." },
    mi: { st: "tuatahi", nd: "tuarua", rd: "tuatoru", th: "tuawha" },
    mk: { st: ".", nd: ".", rd: ".", th: "." },
    ml: { st: "à´¨àµà´‚", nd: "à´¨àµà´‚", rd: "à´¨àµà´‚", th: "à´¨àµà´‚" },
    mn: { st: "-Ñ€", nd: "-Ñ€", rd: "-Ñ€", th: "-Ñ€" },
    mr: { st: "à¤²à¤¾", nd: "à¤²à¤¾", rd: "à¤²à¤¾", th: "à¤²à¤¾" },
    ms: { st: "ke", nd: "ke", rd: "ke", th: "ke" },
    mt: { st: ".", nd: ".", rd: ".", th: "." },
    my: { st: ".", nd: ".", rd: ".", th: "." },
    ne: { st: "à¤”à¤‚", nd: "à¤”à¤‚", rd: "à¤”à¤‚", th: "à¤”à¤‚" },
    nl: { st: "e", nd: "e", rd: "e", th: "e" },
    no: { st: ".", nd: ".", rd: ".", th: "." },
    nso: { st: ".", nd: ".", rd: ".", th: "." },
    ny: { st: ".", nd: ".", rd: ".", th: "." },
    or: { st: "à¬¤à¬®", nd: "à¬¤à¬°", rd: "à¬¤à¬°", th: "à¬¤à¬°" },
    pa: { st: "à¨µà©€à¨‚", nd: "à¨µà©€à¨‚", rd: "à¨µà©€à¨‚", th: "à¨µà©€à¨‚" },
    pl: { st: ".", nd: ".", rd: ".", th: "." },
    ps: { st: "Ø§ÙˆÙ„", nd: "Ø¯ÙˆÛŒÙ…", rd: "Ø³ÙˆÙ…", th: "Ø³ÙˆÙ…" },
    pt: { st: "Âº", nd: "Âº", rd: "Âº", th: "Âº" },
    ro: { st: ".", nd: ".", rd: ".", th: "." },
    ru: { st: "-Ð¹", nd: "-Ð¹", rd: "-Ð¹", th: "-Ð¹" },
    rw: { st: ".", nd: ".", rd: ".", th: "." },
    sd: { st: "Ú€Ø±", nd: "Ú¾ÙŠ", rd: "Ú¾ÙŠ", th: "Ú¾ÙŠ" },
    si: { st: ".", nd: ".", rd: ".", th: "." },
    sk: { st: ".", nd: ".", rd: ".", th: "." },
    sl: { st: ".", nd: ".", rd: ".", th: "." },
    sm: { st: "muamua", nd: "lua", rd: "lua", th: "lua" },
    sn: { st: ".", nd: ".", rd: ".", th: "." },
    so: { st: ".", nd: ".", rd: ".", th: "." },
    sq: { st: ".", nd: ".", rd: ".", th: "." },
    sr: { st: ".", nd: ".", rd: ".", th: "." },
    st: { st: ".", nd: ".", rd: ".", th: "." },
    su: { st: ".", nd: ".", rd: ".", th: "." },
    sv: { st: ".", nd: ".", rd: ".", th: "." },
    sw: { st: "ya", nd: "ya", rd: "ya", th: "ya" },
    ta: { st: "à®†", nd: "à®†", rd: "à®†", th: "à®†" },
    te: { st: "à°µ", nd: "à°°", rd: "à°°", th: "à°°" },
    tg: { st: "-ÑƒÐ¼", nd: "-ÑƒÐ¼", rd: "-ÑƒÐ¼", th: "-ÑƒÐ¼" },
    th: { st: "à¸—à¸µà¹ˆ", nd: "à¸—à¸µà¹ˆ", rd: "à¸—à¸µà¹ˆ", th: "à¸—à¸µà¹ˆ" },
    ti: { st: ".", nd: ".", rd: ".", th: "." },
    tk: { st: "-Ð½Ñ‡Ð¸", nd: "-Ð½Ñ‡Ð¸", rd: "-Ð½Ñ‡Ð¸", th: "-Ð½Ñ‡Ð¸" },
    tl: { st: "ika", nd: "ika", rd: "ika", th: "ika" },
    tr: { st: ".", nd: ".", rd: ".", th: "." },
    ug: { st: "-Ù†Ú†Ù‰", nd: "-Ù†Ú†Ù‰", rd: "-Ù†Ú†Ù‰", th: "-Ù†Ú†Ù‰" },
    uk: { st: "-Ð¹", nd: "-Ð¹", rd: "-Ð¹", th: "-Ð¹" },
    ur: { st: "ÙˆÛŒÚº", nd: "ÙˆÛŒÚº", rd: "ÙˆÛŒÚº", th: "ÙˆÛŒÚº" },
    uz: { st: "-Ð¸Ð½Ñ‡Ð¸", nd: "-Ð¸Ð½Ñ‡Ð¸", rd: "-Ð¸Ð½Ñ‡Ð¸", th: "-Ð¸Ð½Ñ‡Ð¸" },
    vi: { st: "thá»© nháº¥t", nd: "thá»© hai", rd: "thá»© ba", th: "thá»©" },
    xh: { st: ".", nd: ".", rd: ".", th: "." },
    yi: { st: ".", nd: ".", rd: ".", th: "." },
    yo: { st: ".", nd: ".", rd: ".", th: "." },
    // zh: { st: "ç¬¬ä¸€", nd: "ç¬¬äºŒ", rd: "ç¬¬ä¸‰", th: "æ—¥" },
    zh: { st: "æ—¥", nd: "æ—¥", rd: "æ—¥", th: "æ—¥" },
    zu: { st: ".", nd: ".", rd: ".", th: "." },
  };

  function translateOrdinal(number, language) {
    // Get the language translations from the JSON object
    if (language.indexOf("-") != -1) {
      language = language.split("-")[0];
    }
    const translations = translateOrdinalJson[language];

    // Check if translations exist for the specified language
    if (translations) {
      // Get the last two digits of the number
      const lastTwoDigits = number % 100;

      // Determine the suffix based on the last two digits
      let suffix;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        suffix = "th"; // For 11th, 12th, 13th
      } else {
        const lastDigit = number % 10;
        suffix =
          lastDigit === 1
            ? "st"
            : lastDigit === 2
              ? "nd"
              : lastDigit === 3
                ? "rd"
                : "th";
      }

      // Translate the suffix based on the language
      const translatedSuffix = translations[suffix];
      return number + translatedSuffix;
    } else {
      // If translations for the specified language are not found, return the original number
      return number;
    }
  }


   /* CUSTOM DATE */
   function apply_date_formate($, date_format, user_date_with_weekoff_cutoff,language) {

    if(typeof language != 'undefined'){
      date_language = language
    }else{
      date_language = shoplanguage
    }
    
    var d = new Date(user_date_with_weekoff_cutoff);
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var weekdayShort = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    var ord = ["st", "nd", "rd"];
    var exceptions = [11, 12, 13]
    var nth = ord[(day % 10) - 1] == undefined || exceptions.includes(day % 100) ? "th" : ord[(day % 10) - 1]

    /* monthName= monthNames[d.getMonth()];   //like august
           monthShort= monthNamesShort[d.getMonth()];   //like aug                      
           dayOrd =  day + nth;             // like 12th
           dayName = weekday[d.getDay()];   // like sunday
           dayNameShort = weekdayShort[d.getDay()];   // like sun*/

    year = d.getFullYear();   //like 2021
    twoDigityear = year.toString().substr(-2); //like 21
    singleDigitmonth = d.getMonth() + 1; // like 5
    month = (('' + month).length < 2 ? '0' : '') + month; // like 05
    monthName = d.toLocaleDateString(date_language, { month: 'long' });   //like august
    monthShort = d.toLocaleDateString(date_language, { month: 'short' });   //like aug

    if (date_language == 'en') {
      monthShort = monthNamesShort[d.getMonth()];
    }
    singleDigitday = d.getDate();     //like 2
    singleDigitDayOrd = singleDigitday + nth // like 2nd
    day = (('' + day).length < 2 ? '0' : '') + day;   //like 02
    dayOrd = day + nth;             // like 02nd

    dayName = d.toLocaleDateString(date_language, { weekday: 'long' });   // like sunday
    dayNameShort = d.toLocaleDateString(date_language, { weekday: 'short' });   // like sun

    monthShort = monthShort.replace('.', '');
    monthName = monthName.replace('.', '');
    dayNameShort = dayNameShort.replace('.', '');
    dayName = dayName.replace('.', '');

    if (typeof edd_country_code != 'undefined') {
      if (edd_country_code == 'ES' || edd_country_code == 'MT') {
        dayOrd = day;
      }
    }

    date_array_list = [];
    date_array_list['dd'] = date_array_list['dayNameShort'] = dayNameShort;
    date_array_list['dddd'] = date_array_list['dayName'] = dayName;

    date_array_list['D'] = date_array_list['singleDigitday'] = singleDigitday;
    date_array_list['DD'] = date_array_list['day'] = day;
    date_array_list['DDD'] = date_array_list['singleDigitDayOrd'] = singleDigitDayOrd;
    date_array_list['DDDD'] = date_array_list['dayOrd'] = dayOrd;

    date_array_list['M'] = date_array_list['singleDigitmonth'] = singleDigitmonth;
    date_array_list['MM'] = date_array_list['month'] = month;
    date_array_list['MMM'] = date_array_list['monthShort'] = monthShort;
    date_array_list['MMMM'] = date_array_list['monthName'] = monthName;

    date_array_list['YYYY'] = date_array_list['year'] = year;
    date_array_list['YY'] = twoDigityear;
    date_array_list['YYY'] = '`' + twoDigityear;

    date_format_arry = [
      "",
      date_array_list["year"] + "-" + date_array_list["month"] + "-" + date_array_list["day"],
      date_array_list["month"] + "-" + date_array_list["day"] + "-" + date_array_list["year"],
      date_array_list["month"] + "/" + date_array_list["day"] + "/" + date_array_list["year"],
      date_array_list["monthShort"] + ", " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + " " + date_array_list["year"],
      translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + ", " + date_array_list["monthShort"] + " " + date_array_list["year"],
      date_array_list["dayNameShort"] + ", " + date_array_list["monthShort"] + " " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + " " + date_array_list["year"],
      date_array_list["dayNameShort"] + ", " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + " " + date_array_list["monthShort"] + " " + date_array_list["year"],
      date_array_list["day"] + "." + date_array_list["month"] + "." + date_array_list["year"],
      date_array_list["day"] + "-" + date_array_list["month"] + "-" + date_array_list["year"],
      date_array_list["month"] + "." + date_array_list["day"] + "." + date_array_list["year"],
      date_array_list["year"] + "." + date_array_list["month"] + "." + date_array_list["day"],
      date_array_list["year"] + "/" + date_array_list["month"] + "/" + date_array_list["day"],
      date_array_list["day"] + "/" + date_array_list["month"] + "/" + date_array_list["year"],
      translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + " " + date_array_list["monthShort"],
      date_array_list["dayNameShort"] + ", " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language) + " " + date_array_list["monthShort"],
      date_array_list["dayName"] + ", " + date_array_list["monthName"] + " " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language),
      date_array_list["monthShort"] + " " + translateOrdinal(parseInt(date_array_list["dayOrd"]), date_language),
    ];


    /* set custom date format */
    check_custom_date_length = custom_date_format.replaceAll(' ', '')
    if ((get_custom_date_format != 'not_set' && check_custom_date_length.length != 0) || (date_option == 'custom' && custom_date_format != ' ' && check_custom_date_length.length != 0)) {
      //eval(edd_options.additional_script);
      // if (typeof custom_date_format != 'undefined' && date_option == 'custom' && custom_date_format != ' ') {
      //   client_custom_date_format = custom_date_format;
      //   custom_date_format = client_custom_date_format;
      // }
      custom_date_format_temp = custom_date_format;
      custom_date_format_temp = replaceAllOccurance(custom_date_format_temp, 4, '-', ' - ');

      custom_date_format_temp = replaceAllOccurance(custom_date_format_temp, 4, ',', ' , ');

      custom_date_format_temp = replaceAllOccurance(custom_date_format_temp, 4, '.', ' . ');

      custom_date_format_temp = replaceAllOccurance(custom_date_format_temp, 4, '/', ' / ');

      custom_date_format_array = custom_date_format_temp.split(" ");
      create_cusom_date = '';
      for (b = 0; b < custom_date_format_array.length; b++) {
        if (custom_date_format_array[b] != '') {
          if (custom_date_format_array[b] == ',' || custom_date_format_array[b] == '-' || custom_date_format_array[b] == '.' || custom_date_format_array[b] == '/') {
            create_cusom_date = create_cusom_date + '' + custom_date_format_array[b];
            create_cusom_date = create_cusom_date.replace(' ' + custom_date_format_array[b], custom_date_format_array[b])
          } else {
            if (typeof date_array_list[custom_date_format_array[b]] != 'undefined') {
              if (custom_date_format_array[b] == "DDD" || custom_date_format_array[b] == "DDDD") {
                create_cusom_date = create_cusom_date + "" + translateOrdinal(parseInt(date_array_list[custom_date_format_array[b]]), date_language) + ' ';
              } else {
                create_cusom_date = create_cusom_date + "" + date_array_list[custom_date_format_array[b]] + ' ';
              }
            }
          }
        } else {
          create_cusom_date = create_cusom_date + ' ';
        }
      }
      var date = create_cusom_date;
    } else {
      var isEmpty = function (data) {
        if (typeof (data) === 'string') {
          if (!data.trim()) {
            return true;
          }
          return false;
        } else {
          return false;
        }
      }

      if (!isEmpty(date_format)) {
        var date = date_format_arry[date_format];
      } else {
        var date = date_format_arry[5];
      }
    }
    return date;
  }
  /* CUSTOM DATE */


  function addEstimatedMessageClass($) {
    eval(edd_options.additional_script);
    if (typeof sb_edd_preview_design !== 'undefined' && sb_edd_preview_design != null && sb_edd_preview_design != 'null') {
      if (typeof (sb_edd_preview_design.animation_class) != 'undefined') {
        add_animation_class = sb_edd_preview_design.animation_class;
      }
    }

   

    if (typeof deliveryMessageBefore != 'undefined') { /*16-02-24 */
      if (deliveryMessageBefore != '') {
        $(deliveryMessageBefore).before('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
        return false;
      }
    }

    if ($('.sb_delivery.deliverydate').length == 0) {
      // $('.delivery_message_collection').html('<p class="deliverydate sb_delivery"><span class="delivery_icon"></span><span class="delivery_msg"></span></p>');                     
      if ($(".delivery_date_shortcode").length) {
        $('.delivery_date_shortcode:first').html('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
      } else {
        if ($.type(detail_page_class) != 'undefined' && detail_page_class != '' && ($(detail_page_class).length > 0)) {

          $(detail_page_class + ':first').after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
        } else {
          var get_cart_form_all = $("form");
          var get_cart_form_count = get_cart_form_all.length;
          $("form").each(function (index) {
            var getForm = $(this).attr("action");
            if (typeof (getForm) != "undefined") {
              if (getForm.includes("/cart/add")) {
                var getCartButton = $(this).find("button[type=submit]");
                if (getCartButton) {
                  if (index == get_cart_form_count - 1) {
                    $(this).after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                  }
                }
              }
            }
            return false;
          });
          if ($('.sb_delivery.deliverydate').length == 0) {

            // page buider compatibility
            for (let i = 0; i < page_builder_classes.length; i++) {
              if ($(`body ${page_builder_classes[i]}`).length > 0) {
                $(`body ${page_builder_classes[i]}`).first().after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                $("body").append("<style>.ecom-core div.sb_edd_loader{display: none;}</style>");
                // $(`body ${page_builder_classes[i]}`).first().parent().after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                return false;
              }
            }
            if ($('.sb_delivery.deliverydate').length == 0) {
              for (let i = 0; i < page_builder_classes_parent.length; i++) {
                if ($(`body ${page_builder_classes_parent[i]}`).length > 0) {
                  // $(`body ${page_builder_classes_parent[i]}`).first().after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                  $(`body ${page_builder_classes_parent[i]}`).first().parent().after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                  $("body").append("<style>.ecom-core div.sb_edd_loader{display: none;}</style>");
                  return false;
                }
              }
            }
            // page buider compatibility end

            if ($(".sb_delivery.deliverydate").length == 0) {
              $("form").each(function (index) {
                getForm = $(this).attr("action");
                if ((typeof getForm !== "undefined") && (getForm.indexOf("/cart/add") != -1)) {
                  $(this).after('<div class="deliverydate sb_delivery"><div class="animation_class ' + add_animation_class + '"><span class="delivery_icon"></span><span class="delivery_msg"></span></div></div>');
                  return false;
                }
              });
            }
          }
        }
      }
    }
    if ($('.deliverydate').length == 0) {
      $('.delivery_message_collection').append('<div class="deliverydate sb_delivery" style="display:none"><span class="delivery_icon"></span><span class="delivery_msg"></span></div>');
    }
    $('body').append("<style>.sb_delivery{position:relative;font-size:14px;  line-height: 1.4;}.template_order{--temp_order_bg_color: #ffffff; --liBorderStyle: solid;}.template_order .li_border{--liBorderBgColor: #1d1d1d; } .chrismas_order .li_border{ --liBorderBgColor: #303030; } .template_order .li_border:after{  content: ''; position: absolute; top: 1.6em; left: calc(50% + 23px); border-top: 5px; border-bottom: 0; border-left: 0;border-right: 0; border-color: var(--liBorderBgColor); border-style: var(--liBorderStyle); z-index: 0;  margin-top: 10px; width: 100%;}.template_order .li_border:last-child:after {  display: none;}.template_order span {padding:10px 0;    word-break: break-all;} @media only screen and (max-width: 768px) { .deliverydate.sb_delivery .sb_edd_ffd_template { font-size: 24px !important; } .deliverydate.sb_delivery .sb_edd_clock_icon {width: 40px !important} }</style>");
    $('body').append("<style>div.animated_template:before {background: -webkit-gradient(linear, 0% 0%, 100% 0%, from(rgba(211, 211, 211, 0)), to(rgba(211, 211, 211, 0.3)));content: '';display: block;height: 100%;position: absolute;top: 0px;transform: skewX(-25deg);width: 50%;animation: 2s ease 0s infinite normal none running fOrDIg;}@keyframes fOrDIg {from {width: 0;}to {width: 100%;}}</style>");
    $('body').append("<style>div.slide_effect:before {background: -webkit-gradient(linear, 0% 0%, 100% 0%, from(rgba(211, 211, 211, 0)), to(rgba(211, 211, 211, 0.3)));content: '';display: block;height: 100%;position: absolute;top: 0px;transform: skewX(-25deg);width: 50%;animation: 2s ease 0s infinite normal none running fOrDIg;}@keyframes fOrDIg {from {width: 0;}to {width: 100%;}}</style>");
    $('body').append("<style>.sb_delivery{position:relative;}.chrismas_order .li_border:after{left: calc(50% + 35px);border-top: 5px; border-bottom: 0; border-left: 0;border-right: 0; border-color: var(--liBorderBgColor); border-style: var(--liBorderStyle);width: 90%;top: 2.2em;}</style>");
    $('body').append("<style>.timeContainer1 .wrapper h2{background: #1b1c1c;color: white;width: 90px;box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);padding: 10px;}.timeContainer2 .wrapper .digit{background: #1b1c1c;color: white;margin: 3px;box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);padding: 0px 10px;border-radius:5px;}.timeContainer1 .wrapper h2 ,.timeContainer2 .wrapper h2{font-size: 30px;margin: 5px 0; color: #ccc;text-align: center;border-radius: 12px;}.timeContainer1 .wrapper,.timeContainer2 .wrapper {padding: 10px;display: flex;justify-content: center;gap: 20px;text-align: center;}</style>");
    $('body').append("<style>.template_order.arrow_order .step_template{padding: 15px 0;}.template_order.arrow_order .li_border {border-right: 1px solid var(--liBorderBgColor) !important;}.template_order.arrow_order .li_border:after {display: block;left: unset; margin-top:0px;position: absolute;z-index: 2;content: '';top: 50%;right: 0;border: medium none;background-color:var(--temp_order_bg_color);width: 1.14285714em;height: 1.14285714em;border-style: solid;border-color:var(--liBorderBgColor);border-width: 0 1px 1px 0;-webkit-transition: background-color .1s ease,opacity .1s ease,color .1s ease,box-shadow .1s ease;transition: background-color .1s ease,opacity .1s ease,color .1s ease,box-shadow .1s ease;-webkit-transform: translateY(-50%) translateX(50%) rotate(-45deg);transform: translateY(-50%) translateX(50%) rotate(-45deg);animation:unset}.template_order.arrow_order .li_border{border-right:1px solid var(--liBorderBgColor); }.template_order.arrow_order{border: 1px solid; }</style>");
    $('body').append("<style>.sb_delivery .edd_country_msg_change{width: auto;border: 0;cursor:pointer}.sb_delivery select.edd_country_msg_change:focus-visible {outline: 0;box-shadow: unset;}.edd_country_msg_change{  color: #000 !important;margin: 0.5rem 0;   width:100%; border-radius: 5px; border: 1px solid #767676;   padding: 8px;height: 37px;}</style>");
    $('body').append("<style>.preview_shipping_description p {margin:0 !important;}.shipping_input_radio_btn_with_desc{position: absolute;top: 40%;left: 1rem;}.shipping_input_radio_description{    padding-left: 1rem;}.shipping_input_having_radio_description{margin-bottom: 10px;border-radius: 8px;padding: 5px;transition: transform 0.2s;display: flex;flex-direction: column;position: relative;padding-left: 3rem;}.shipment_method_selector label{cursor:pointer !important;}</style>")
    $('body').append('<style>.template_order.template_5 .step_template.step_1::after {     left: calc(50% + 15px) !important;   margin-top: 7px;border-image-slice: 1;border-image-source: var(--first_step_bg_color) }.template_order.template_5 .li_border:after {border-width: 5px;}</style>')
    $('body').append('<style>.sb_delivery{ animation: drop-in 1s ease 200ms backwards;}.sb_delivery .count_down_timer, .sb_delivery .template_order  img,.sb_delivery .template_order  svg{animation: drop-in 1s ease 400ms backwards;}.sb_delivery .step_template:after{animation: drop-in 1s ease 600ms backwards;}@keyframes drop-in {from {opacity: 0;transform: translate(0px);}to {opacity: 1;transform: translate(0px);}}</style>');
    $('body').append('<style>.template_order.template_9{background:transparent !important;}.template_order.template_9 .li_border:after, .template_order.template_8 .li_border:after,.template_order.template_7 .li_border:after, .template_order.template_6 .li_border:after{opacity: 0;display:none}.template_order.template_6{background : transparent !important;}.template_order.template_6 .step_template:first-child{border-radius: 10px 0 0 10px;}.template_order.template_6 .step_template:last-child{border-radius: 0 10px 10px 0;  }</style>');
    $('body').append('<style>.template_order.template_8 {border-radius:0 !important;}.template_order.template_7{padding: 0 5px;}.template_7 .step_template{border-width: 1px;border-color: #ddd;margin : 10px 5px !important;border-radius: 10px;border-style: var(--liBorderStyle)}.template_order.template_7  {animation:RotateDiv 5s linear infinite;}@keyframes RotateDiv{0%{transform: scale(0.97);}50%{transform: scale(1);}    100%{transform: scale(0.97);}}<style>')
    $('body').append('<style> .template_order   .step_template img,.template_order   .step_template svg{margin-bottom : 8px !important;}.step_template span:last-child {line-height: 1.7;}.chrismas_order  .template_order   .step_template img,.chrismas_order .template_order   .step_template svg{margin-bottom : 10px;}</style>')
    $('body').append('<style>.black_friday_coupon1 .right {width: 5%;background-image: radial-gradient(circle at 100% 50%, transparent 15px, #f1ebdd 16px);}.black_friday_coupon1 > div {display: flex;align-items: center;justify-content: center;padding: 30px 10px;}.black_friday_coupon1::before {left: 0;background-image: radial-gradient(circle at 0 50%, transparent 15px, #fff 16px);}.black_friday_coupon1 .center{background:#fff;width:80%}.black_friday_coupon1::before, .black_friday_coupon1::after {content: "";position: absolute;top: 0;width: 50%;height: 100%;z-index: -1;}.black_friday_coupon1{width: auto;border-radius: 10px;overflow: hidden;margin: auto;filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.5));display: flex;align-items: stretch;position: relative;}</style>');
    $('body').append('<style>.sb_delivery .animated_text {animation: text-animation 1s linear infinite alternate; }@keyframes text-animation {from {color: #ffe4d4;background: linear-gradient(rgb(243 226 186) 26%, rgb(245 146 232) 63%);-webkit-background-clip: text;text-shadow: 0 0 0 transparent, 0 0 10px #d36518, 0 0 20px rgb(177 57 30 / 50%), 0 0 40px #ff8026, 0 0 100px #ff8a26, 0 0 200px #ff4e26, 0 0 300px #ff5826, 0 0 500px #ff4426;}to {background: linear-gradient(rgb(241, 176, 22) 26%, rgb(229, 40, 204) 63%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;text-shadow: 0 0 0 transparent, 0 0 10px #d36518, 0 0 20px rgb(177 57 30 / 50%), 0 0 40px #ff8026, 0 0 100px #ff8a26, 0 0 200px #ff4e26, 0 0 300px #ff5826, 0 0 500px #ff4426;}}</style>');
    $('body').append('<style>.animated_text2{animation: move 2s ease-in-out infinite;}@keyframes move {0%, 100% {transform: translateY(0px);}50% {transform: translateY(8px);}}.sb_delivery .snow {background: white;border-radius: 100%;left: 50%;position: absolute;top: 0;width: 5px;height: 5px;z-index: 99;box-shadow: 0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff,100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff,-30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff,-130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff,-190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff,-100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff,-30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff,70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff,140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff,160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff,180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff,250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff,-220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff,-80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff,-250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff;-webkit-animation: snow 20s linear infinite;-moz-animation: snow 20s linear infinite;-ms-animation: snow 20s linear infinite;animation: snow 20s linear infinite;}.sb_delivery .snow::after {content: "";background: white;border-radius: 100%;left: 100px;position: absolute;top: -200px;width: 5px;height: 5px;z-index: 99;box-shadow: 0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff,100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff,-30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff,-130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff,-190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff,-100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff,-30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff,70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff,140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff,160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff,180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff,250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff,-220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff,-80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff,-250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff;}.sb_delivery .snow::before {content: "";background: white;border-radius: 100%;left: -200px;position: absolute;top: -300px;width: 5px;height: 5px;z-index: 99;box-shadow: 0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff,100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff,-30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff,-130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff,-190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff,-100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff,-30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff,70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff,140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff,160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff,180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff,250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff,-220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff,-80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff,-250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff;}@keyframes snow {0% {transform: translate(0, 0);opacity: 0.15;}20% {transform: translate(-20px, 100px);opacity: 1;}70% {transform: translate(-70px, 250px);opacity: 0.7;}100% {transform: translate(-100px, 300px);opacity: 0.1;}}@-moz-keyframes snow {0% {transform: translate(0, 0);opacity: 0.15;}20% {transform: translate(-20px, 100px);opacity: 1;}70% {transform: translate(-70px, 250px);opacity: 0.7;}100% {transform: translate(-100px, 300px);opacity: 0.1;}}@-webkit-keyframes snow {0% {transform: translate(0, 0);opacity: 0.15;}20% {transform: translate(-20px, 100px);opacity: 1;}70% {transform: translate(-70px, 250px);opacity: 0.7;}100% {transform: translate(-100px, 300px);opacity: 0.1;}}@-ms-keyframes snow {0% {transform: translate(0, 0);opacity: 0.15;}20% {transform: translate(-20px, 100px);opacity: 1;}70% {transform: translate(-70px, 250px);opacity: 0.7;}100% {transform: translate(-100px, 300px);opacity: 0.1;}}.sb_delivery .snow2 {content: "";position: absolute;top: -100px;left: 50%;border-radius: 50%;width: 8px;height: 8px;background: #fff;opacity: 0.8;-webkit-animation: slowSnow 40s linear infinite;-moz-animation: slowSnow 40s linear infinite;-ms-animation: slowSnow 40s linear infinite;animation: slowSnow 40s linear infinite;box-shadow: 0 0px 6px 0px #fff, -20px 50px 4px 1px #fff,80px 70px 4px 1px #fff, 200px 150px 4px 1px #fff, -200px 150px 4px 1px #fff,-100px 100px 4px 1px #fff, 90px 180px 4px 1px #fff, 190px 280px 4px 1px #fff,-150px 250px 4px 1px #fff, -190px 280px 4px 1px #fff,-190px 80px 4px 1px #fff, -250px 200px 4px 1px #fff,-270px 380px 4px 1px #fff, 270px 330px 4px 1px #fff,-200px 390px 4px 1px #fff, -240px 310px 4px 1px #fff,180px 380px 4px 1px #fff;}.sb_delivery .snow2::before {content: "";position: absolute;top: -500px;left: 50%;border-radius: 50%;width: 8px;height: 8px;background: #fff;opacity: 0.8;-webkit-animation: slowSnow 30s linear infinite;-moz-animation: slowSnow 30s linear infinite;-ms-animation: slowSnow 30s linear infinite;animation: slowSnow 30s linear infinite;box-shadow: 0 0px 6px 0px #fff, -20px 50px 4px 1px #fff,80px 70px 4px 1px #fff, 200px 150px 4px 1px #fff, -200px 150px 4px 1px #fff,-100px 100px 4px 1px #fff, 90px 180px 4px 1px #fff, 190px 280px 4px 1px #fff,-150px 250px 4px 1px #fff, -190px 280px 4px 1px #fff,-190px 80px 4px 1px #fff, -250px 200px 4px 1px #fff,-270px 380px 4px 1px #fff, 270px 330px 4px 1px #fff,-200px 390px 4px 1px #fff, -240px 310px 4px 1px #fff,180px 380px 4px 1px #fff;}@keyframes slowSnow {0% {transform: translate(0, 0);}20% {transform: translate(-20px, 100px);}70% {transform: translate(0px, 250px);}100% {transform: translate(10px, 300px);}}</style>')
    $('body').append('<style>.template_10 .three_step_card{display: flex;width: 100%;margin-top: 30px;}.template_10 .three_step_card_content{margin-left:15px;}.template_10 .step_template{float: unset !important;text-align: left !important;}.template_order.template_10 .li_border:after{display:none;}.template_order.template_10:after {content: "";height: 80%;width: 1px;background-color:var(--liBorderBgColor);position: absolute;top: 30px;left: 40px;z-index: 0;}.ETA_hover_effect.template_order.template_10:after{z-index: -1;}.template_10 .three_step_card:first-child{margin-top: 10px !important;}.template_order.template_10,.ETA_hover_effect_wrap .template_order.template_10.ETA_hover_effect.active{display: block !important; }.template_order.template_10{padding: 1px 15px !important;}.ETA_hover_effect_wrap .template_order.template_10.ETA_hover_effect{display:none !important}.template_10 .three_step_card_img{z-index:1}</style>')
    $('body').append('<style>.marco_animation {animation: marco_scroll 8s linear infinite;white-space: nowrap;word-wrap: break-word;}.marco_wrap_div {background: #303030;color: #fff;padding: 10px 0 ;font-weight: 600;font-size: 16px;overflow: hidden;}@keyframes marco_scroll {0% {transform: translateX(100%);}100% {transform: translateX(-100%);}}</style>')
    $('body').append("<style>.template_order.template_11 .step_template:after{margin-top: -22px !important;}.template_11.template_order  .step_template.active{width:40% !important; display: table;}.template_11.template_order  .step_template.active .three_step_card{width: auto  !important;}.template_11.template_order  .step_template.active,.template_11 .step-icon{z-index:2;}.template_11.template_order  .step_template.active:not(:first-child):not(:last-child) .three_step_card {margin: 10px auto 0 !important;}.template_11.template_order  .step_template.active:last-child .three_step_card {margin: 10px auto 0 !important;}.template_11.template_order{padding:10px 0 0; justify-content: center;}.template_11 .step_template{width:20% !important; }.template_11 .step_template:last-child:after {width: 100%;content: '';position: absolute;top: 1.6em;right: 25px;border-top: 4px;border-bottom: 0;border-left: 0;border-right: 0;border-style: var(--liBorderStyle);z-index: 0;margin-top: -25px;border-color: var(--liBorderBgColor);}.template_order.template_11 .li_border:after {content: '';position: absolute;top: 1.6em;left:0;border-top: 4px;border-bottom: 0;border-left: 0;border-right: 0;border-style: var(--liBorderStyle);z-index: 0;margin-top: -25px;width: 100%;border-color: var(--liBorderBgColor);}.template_11 .step-icon {width: 20px;height: 20px;background: #eee;border-radius: 50%;border: 4px solid #fbf4f4;position: absolute;top: -8px;transform: translateX(-50%);display: block;}.template_11 .step_template:first-child .step-icon,.template_order.template_11 .li_border:first-child:after{left: 25px;}.template_11 .step_template:not(:first-child):not(:last-child) .step-icon {right: 40%;}.template_11 .step_template:last-child .step-icon,.template_order.template_11 .li_border:last-child:after {right: 0px;}.template_11 .step_template.active .step-icon {background: #0e0d0d;}.template_11 .step_template.active .three_step_card .three_step_card_img img{background: transparent !important;}.template_11 .step_template.active .three_step_card {box-shadow: var(--p-card-shadow, 0 0 0 1px rgb(199 199 199 / 83%), 0 1px 3px 0 rgb(133 133 149 / 87%));display: flex !important;float:unset;background: #fff !important;justify-content: space-around;}.template_11 .step_template:first-child  .three_step_card{float: left;}.template_11 .step_template:last-child .three_step_card{float: right;}.template_11 .three_step_card {background: transparent !important;border-radius: 10px !important;padding: 10px !important;margin: 10px auto 0!important;width: 78px;transition: width 1s ease, opacity 0.5s ease;overflow: hidden;}@keyframes fadeInFromRight {0% {opacity: 0;transform: translateX(20px); }100% {opacity: 1;transform: translateX(0); }}.template_11 .three_step_card_img {padding: 0;background: none !important;}.template_11 .icon-img {width: 50px;height: 50px;margin-top: 0 !important;padding: 0;background: none !important;}.template_11 .three_step_card_content {display: none;opacity: 0;transform: translateX(20px); transition: opacity 0.8s ease-out, transform 0.8s ease-out; }.template_11 .step_template.active .three_step_card_content{animation: fadeInFromRight 1s ease-out forwards;display: block;}@keyframes fadeInStep {0% {opacity: 0;}100% {opacity: 1;}}@keyframes fadeOutStep {0% {opacity: 1;}100% {opacity: 0;}}.template_11.template_order .step_template img, .template_11 .template_order .step_template svg{margin-bottom:0!important}.template_11.step_template.inactive.three_step_card_content{animation: fadeOutStep 1s forwards;}</style>")
   
    $('.deliverydate').before('<!--- Order Delivery Estimation By SetuBridge  --->');
  }

  function displayOnCartPage($) {
    eval(edd_options.additional_script);
    if (typeof custom_cart_label == 'undefined') {
      if (changeCartLabel != '') {
      } else {
        changeCartLabel = 'Order Estimation';
      }
    } else {
      changeCartLabel = custom_cart_label;
    }

    $("form").each(function (index) {
      getForm = $(this).attr("action");
      if ((typeof getForm !== "undefined") && (getForm.indexOf("/cart/add") != -1)) {
        // if(getForm == "/cart/add"){   

        if (shopnamefull == 'kiwla-global.myshopify.com') {
          product_tag = get_product_tag;
          if (product_tag != 'not_set') {
            $(this).append('<input type="hidden" class="add_hidden_delivery_tag" name="properties[Tag]">');
            $('.add_hidden_delivery_tag').val(product_tag);
          }
        }
        if ($(this).find("input").hasClass("add_hidden_delivery")) {
        } else {
          addCartInputField($, this, changeCartLabel);
        }
      }
    });

    if ($('.add_hidden_delivery').length == 0) {
      addCartInputField($, '.delivery_message_cart_collection', changeCartLabel);
    }
  }

  function addCartInputField($, sb_cart_class, changeCartLabel) {
    $(sb_cart_class).append('<input type="hidden" id="add_hidden_delivery" class="add_hidden_delivery" name="properties[' + changeCartLabel + ']">');
    if (typeof edd_product_tag != 'undefined') {
      //$(sb_cart_class).append('<input type="hidden" id="add_hidden_delivery_tag" class="add_hidden_delivery_tag" name="properties[_sb_tag]" value="'+edd_product_tag+'">');
    }
    if (typeof edd_collection_id != 'undefined') {
      //$(sb_cart_class).append('<input type="hidden" id="add_hidden_delivery_collection" class="add_hidden_delivery_collection" name="properties[_sb_collection]" value="'+edd_collection_id+'">');
    }
  }
  function add_country_checker_shortcode(msg, $) {
    // if (msg.includes("country_checker")) {

    if (sb_set_specific_msg == '1') {
      var country_options = "";
      console.log("sb_edd 123 edd_user_country_code", edd_user_country_code, "edd_country_code", edd_country_code);
      //$("body").append(`<style>.edd_country_msg_change {border-radius: 5px; border: 1px solid #eee; padding: 1px; height: 22px; width: 100px;}</style>`)
      if (Object.keys(all_rule_country_array).length == 1 && Object.values(all_rule_country_array).includes("all_country")) {
        country_options += `<option value="${edd_user_country_code.toLowerCase()}" selected>${edd_user_country_name}</option>`;
      } else {

        if (Object.values(all_rule_country_array).includes("all_country") && !Object.values(all_rule_country_array).includes(edd_user_country_code)) {
          country_options += `<option value="${edd_user_country_code}" selected>${getCountryFullName(edd_user_country_code)}</option>`;
        }

        $.each(all_rule_country_array, function (index, value) {
          if (value != 'all_country') {
            if (!sb_edd_rule_list[0].country_code.includes(edd_country_code)) {
              if (value == edd_user_country_code) {
                country_options += `<option value="${value}" selected>${getCountryFullName(value)}</option>`;
              } else {
                country_options += `<option value="${value}">${getCountryFullName(value)}</option>`;
              }
            } else {
              if (value == edd_country_code) {
                country_options += `<option value="${value}" selected>${getCountryFullName(value)}</option>`;
              } else {
                country_options += `<option value="${value}">${getCountryFullName(value)}</option>`;
              }
            }
          }
        });
      }
      if (message.indexOf("{country_dropdown}") != -1) {
        message = msg.replaceAll("{country_dropdown}", `<span class="sb_edd_country_select_div"><select class="edd_country_msg_change">${country_options}</select></span>`);
      } else {
        if ($(".deliverydate.sb_delivery").parent().find(".edd_country_msg_change").length == 0) {
          $(".deliverydate.sb_delivery").before(`<select class="edd_country_msg_change">${country_options}</select>`);
        }
      }
    }
  }

  function add_country_checker(msg, $) {
    // if (msg.includes("country_checker")) {

    if (sb_set_specific_msg == '1') {
      var country_options = "";
      //$("body").append(`<style>.edd_country_msg_change {border-radius: 5px; border: 1px solid #eee; padding: 1px; height: 22px; width: 100px;}</style>`)
      if (Object.keys(all_rule_country_array).length == 1 && Object.values(all_rule_country_array).includes("all_country")) {
        country_options += `<option value="${edd_user_country_code.toLowerCase()}" selected>${edd_user_country_name}</option>`;
      } else {

        if (Object.values(all_rule_country_array).includes("all_country") && !Object.values(all_rule_country_array).includes(edd_country_code)) {
          country_options += `<option value="${edd_country_code}" selected>${getCountryFullName(edd_country_code)}</option>`;
        }

        $.each(all_rule_country_array, function (index, value) {
          if (value != 'all_country') {
            if (value == edd_country_code) {
              country_options += `<option value="${value}" selected>${getCountryFullName(value)}</option>`;
            } else {
              country_options += `<option value="${value}">${getCountryFullName(value)}</option>`;
            }
          }
        });
      }


      if ($(".deliverydate.sb_delivery").parent().find(".edd_country_msg_change").length == 0) {
        $(".deliverydate.sb_delivery").before(`<select class="edd_country_msg_change">${country_options}</select>`);
      }
    }
  }

  function getCountryFullName(countryCode) {
    sb_countries = [{ country: 'All Country', code: 'all_country' }, { country: 'Afghanistan', code: 'AF' }, { country: 'land Islands', code: 'AX' }, { country: 'Albania', code: 'AL' }, { country: 'Algeria', code: 'DZ' }, { country: 'American Samoa', code: 'AS' }, { country: 'AndorrA', code: 'AD' }, { country: 'Angola', code: 'AO' }, { country: 'Anguilla', code: 'AI' }, { country: 'Antarctica', code: 'AQ' }, { country: 'Antigua and Barbuda', code: 'AG' }, { country: 'Argentina', code: 'AR' }, { country: 'Armenia', code: 'AM' }, { country: 'Aruba', code: 'AW' }, { country: 'Australia', code: 'AU' }, { country: 'Austria', code: 'AT' }, { country: 'Azerbaijan', code: 'AZ' }, { country: 'Bahamas', code: 'BS' }, { country: 'Bahrain', code: 'BH' }, { country: 'Bangladesh', code: 'BD' }, { country: 'Barbados', code: 'BB' }, { country: 'Belarus', code: 'BY' }, { country: 'Belgium', code: 'BE' }, { country: 'Belize', code: 'BZ' }, { country: 'Benin', code: 'BJ' }, { country: 'Bermuda', code: 'BM' }, { country: 'Bhutan', code: 'BT' }, { country: 'Bolivia', code: 'BO' }, { country: 'Bosnia And Herzegovina', code: 'BA' }, { country: 'Botswana', code: 'BW' }, { country: 'Bouvet Island', code: 'BV' }, { country: 'Brazil', code: 'BR' }, { country: 'British Indian Ocean Territory', code: 'IO' }, { country: 'Brunei Darussalam', code: 'BN' }, { country: 'Saint Barthelemy', code: 'BL' }, { country: 'Bulgaria', code: 'BG' }, { country: 'Burkina Faso', code: 'BF' }, { country: 'Burundi', code: 'BI' }, { country: 'Cambodia', code: 'KH' }, { country: 'Cameroon', code: 'CM' }, { country: 'Canada', code: 'CA' }, { country: 'Cape Verde', code: 'CV' }, { country: 'Cayman Islands', code: 'KY' }, { country: 'Central African Republic', code: 'CF' }, { country: 'Chad', code: 'TD' }, { country: 'Chile', code: 'CL' }, { country: 'China', code: 'CN' }, { country: 'Christmas Island', code: 'CX' }, { country: 'Cocos (Keeling) Islands', code: 'CC' }, { country: 'Colombia', code: 'CO' }, { country: 'Comoros', code: 'KM' }, { country: 'Congo', code: 'CG' }, { country: 'Congo, The Democratic Republic of the', code: 'CD' }, { country: 'Cook Islands', code: 'CK' }, { country: 'Costa Rica', code: 'CR' }, { country: 'Cote D"Ivoire', code: 'CI' }, { country: 'Croatia', code: 'HR' }, { country: 'Cuba', code: 'CU' }, { country: 'Cyprus', code: 'CY' }, { country: 'Czech Republic', code: 'CZ' }, { country: 'Denmark', code: 'DK' }, { country: 'Djibouti', code: 'DJ' }, { country: 'Dominica', code: 'DM' }, { country: 'Dominican Republic', code: 'DO' }, { country: 'Ecuador', code: 'EC' }, { country: 'Egypt', code: 'EG' }, { country: 'El Salvador', code: 'SV' }, { country: 'Equatorial Guinea', code: 'GQ' }, { country: 'Eritrea', code: 'ER' }, { country: 'Estonia', code: 'EE' }, { country: 'Ethiopia', code: 'ET' }, { country: 'Falkland Islands (Malvinas)', code: 'FK' }, { country: 'Faroe Islands', code: 'FO' }, { country: 'Fiji', code: 'FJ' }, { country: 'Finland', code: 'FI' }, { country: 'France', code: 'FR' }, { country: 'French Guiana', code: 'GF' }, { country: 'French Polynesia', code: 'PF' }, { country: 'French Southern Territories', code: 'TF' }, { country: 'Gabon', code: 'GA' }, { country: 'Gambia', code: 'GM' }, { country: 'Georgia', code: 'GE' }, { country: 'Germany', code: 'DE' }, { country: 'Ghana', code: 'GH' }, { country: 'Gibraltar', code: 'GI' }, { country: 'Greece', code: 'GR' }, { country: 'Greenland', code: 'GL' }, { country: 'Grenada', code: 'GD' }, { country: 'Guadeloupe', code: 'GP' }, { country: 'Guam', code: 'GU' }, { country: 'Guatemala', code: 'GT' }, { country: 'Guernsey', code: 'GG' }, { country: 'Guinea', code: 'GN' }, { country: 'Guinea-Bissau', code: 'GW' }, { country: 'Guyana', code: 'GY' }, { country: 'Haiti', code: 'HT' }, { country: 'Heard Island & Mcdonald Islands', code: 'HM' }, { country: 'Holy See (Vatican City State)', code: 'VA' }, { country: 'Honduras', code: 'HN' }, { country: 'Hong Kong', code: 'HK' }, { country: 'Hungary', code: 'HU' }, { country: 'Iceland', code: 'IS' }, { country: 'India', code: 'IN' }, { country: 'Indonesia', code: 'ID' }, { country: 'Iran, Islamic Republic Of', code: 'IR' }, { country: 'Iraq', code: 'IQ' }, { country: 'Ireland', code: 'IE' }, { country: 'Isle Of Man', code: 'IM' }, { country: 'Israel', code: 'IL' }, { country: 'Italy', code: 'IT' }, { country: 'Jamaica', code: 'JM' }, { country: 'Japan', code: 'JP' }, { country: 'Jersey', code: 'JE' }, { country: 'Jordan', code: 'JO' }, { country: 'Kazakhstan', code: 'KZ' }, { country: 'Kenya', code: 'KE' }, { country: 'Kiribati', code: 'KI' }, { country: 'Korea', code: 'KP' }, { country: 'Korea, Republic of', code: 'KR' }, { country: 'Kuwait', code: 'KW' }, { country: 'Kyrgyzstan', code: 'KG' }, { country: 'Lao People"S Democratic Republic', code: 'LA' }, { country: 'Latvia', code: 'LV' }, { country: 'Lebanon', code: 'LB' }, { country: 'Lesotho', code: 'LS' }, { country: 'Liberia', code: 'LR' }, { country: 'Libyan Arab Jamahiriya', code: 'LY' }, { country: 'Liechtenstein', code: 'LI' }, { country: 'Lithuania', code: 'LT' }, { country: 'Luxembourg', code: 'LU' }, { country: 'Macao', code: 'MO' }, { country: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' }, { country: 'Madagascar', code: 'MG' }, { country: 'Malawi', code: 'MW' }, { country: 'Malaysia', code: 'MY' }, { country: 'Maldives', code: 'MV' }, { country: 'Mali', code: 'ML' }, { country: 'Malta', code: 'MT' }, { country: 'Marshall Islands', code: 'MH' }, { country: 'Martinique', code: 'MQ' }, { country: 'Mauritania', code: 'MR' }, { country: 'Mauritius', code: 'MU' }, { country: 'Mayotte', code: 'YT' }, { country: 'Mexico', code: 'MX' }, { country: 'Micronesia, Federated States of', code: 'FM' }, { country: 'Moldova', code: 'MD' }, { country: 'Monaco', code: 'MC' }, { country: 'Mongolia', code: 'MN' }, { country: 'Montenegro', code: 'ME' }, { country: 'Montserrat', code: 'MS' }, { country: 'Morocco', code: 'MA' }, { country: 'Mozambique', code: 'MZ' }, { country: 'Myanmar', code: 'MM' }, { country: 'Namibia', code: 'NA' }, { country: 'Nauru', code: 'NR' }, { country: 'Nepal', code: 'NP' }, { country: 'Netherlands', code: 'NL' }, { country: 'Netherlands Antilles', code: 'AN' }, { country: 'New Caledonia', code: 'NC' }, { country: 'New Zealand', code: 'NZ' }, { country: 'Nicaragua', code: 'NI' }, { country: 'Niger', code: 'NE' }, { country: 'Nigeria', code: 'NG' }, { country: 'Niue', code: 'NU' }, { country: 'Norfolk Island', code: 'NF' }, { country: 'Northern Mariana Islands', code: 'MP' }, { country: 'Norway', code: 'NO' }, { country: 'Oman', code: 'OM' }, { country: 'Pakistan', code: 'PK' }, { country: 'Palau', code: 'PW' }, { country: 'Palestinian Territory, Occupied', code: 'PS' }, { country: 'Panama', code: 'PA' }, { country: 'Papua New Guinea', code: 'PG' }, { country: 'Paraguay', code: 'PY' }, { country: 'Peru', code: 'PE' }, { country: 'Philippines', code: 'PH' }, { country: 'Pitcairn', code: 'PN' }, { country: 'Poland', code: 'PL' }, { country: 'Portugal', code: 'PT' }, { country: 'Puerto Rico', code: 'PR' }, { country: 'Qatar', code: 'QA' }, { country: 'Reunion', code: 'RE' }, { country: 'Romania', code: 'RO' }, { country: 'Russian Federation', code: 'RU' }, { country: 'Rwanda', code: 'RW' }, { country: 'Saint Helena', code: 'SH' }, { country: 'Saint Kitts And Nevis', code: 'KN' }, { country: 'Saint Lucia', code: 'LC' }, { country: 'Saint Pierre And Miquelon', code: 'PM' }, { country: 'Saint Vincent And Grenadines', code: 'VC' }, { country: 'Saint Martin', code: 'MF' }, { country: 'Samoa', code: 'WS' }, { country: 'San Marino', code: 'SM' }, { country: 'Sao Tome And Principe', code: 'ST' }, { country: 'Saudi Arabia', code: 'SA' }, { country: 'Senegal', code: 'SN' }, { country: 'Serbia', code: 'RS' }, { country: 'Seychelles', code: 'SC' }, { country: 'Sierra Leone', code: 'SL' }, { country: 'Singapore', code: 'SG' }, { country: 'Slovakia', code: 'SK' }, { country: 'Slovenia', code: 'SI' }, { country: 'Solomon Islands', code: 'SB' }, { country: 'Somalia', code: 'SO' }, { country: 'South Africa', code: 'ZA' }, { country: 'South Georgia And Sandwich Islands', code: 'GS' }, { country: 'Spain', code: 'ES' }, { country: 'Sri Lanka', code: 'LK' }, { country: 'Sudan', code: 'SD' }, { country: 'Suriname', code: 'SR' }, { country: 'Svalbard And Jan Mayen', code: 'SJ' }, { country: 'Swaziland', code: 'SZ' }, { country: 'Sweden', code: 'SE' }, { country: 'Switzerland', code: 'CH' }, { country: 'Syrian Arab Republic', code: 'SY' }, { country: 'Taiwan', code: 'TW' }, { country: 'Tajikistan', code: 'TJ' }, { country: 'Tanzania', code: 'TZ' }, { country: 'Thailand', code: 'TH' }, { country: 'Timor-Leste', code: 'TL' }, { country: 'Togo', code: 'TG' }, { country: 'Tokelau', code: 'TK' }, { country: 'Tonga', code: 'TO' }, { country: 'Trinidad And Tobago', code: 'TT' }, { country: 'Tunisia', code: 'TN' }, { country: 'Turkey', code: 'TR' }, { country: 'Turkmenistan', code: 'TM' }, { country: 'Turks And Caicos Islands', code: 'TC' }, { country: 'Tuvalu', code: 'TV' }, { country: 'Uganda', code: 'UG' }, { country: 'Ukraine', code: 'UA' }, { country: 'United Arab Emirates', code: 'AE' }, { country: 'United Kingdom', code: 'GB' }, { country: 'United States', code: 'US' }, { country: 'United States Outlying Islands', code: 'UM' }, { country: 'Uruguay', code: 'UY' }, { country: 'Uzbekistan', code: 'UZ' }, { country: 'Vanuatu', code: 'VU' }, { country: 'Venezuela', code: 'VE' }, { country: 'Viet Nam', code: 'VN' }, { country: 'Virgin Islands, British', code: 'VG' }, { country: 'Virgin Islands, U.S.', code: 'VI' }, { country: 'Wallis And Futuna', code: 'WF' }, { country: 'Western Sahara', code: 'EH' }, { country: 'Yemen', code: 'YE' }, { country: 'Zambia', code: 'ZM' }, { country: 'Zimbabwe', code: 'ZW' }]
    dataset = Object.keys(sb_countries).find(x => sb_countries[x].code === countryCode);
    country_checker = sb_countries[dataset].country;
    return country_checker; // Return null if country code is not found
  }

  function shipment_checker_change_event($) {
    $('body').append('<style>.sb_delivery select.shipment_method_selector{width:auto;height:auto}select.shipment_method_selector{border: 1px solid #767676;height: 37px;color: #000 !important;width: 100%;margin: 0.5rem 0;border-radius: 5px;}</style>')



    if (shopnamefull == 'ninetwofive-nl.myshopify.com') {
      checkShippingCoockie = ''
    } else {
      checkShippingCoockie = getSbScriptCookie("edd_choosen_shipping")
    }

    checkCoockiInterval = 0
    if (checkShippingCoockie != '' || Shopify.shop == "ninetwofive-nl.myshopify.com") {
      chekShippingCheckerdiv = setInterval(function () {
        if ($('.shipment_method_selector').length) {
          clearInterval(chekShippingCheckerdiv)
          if (Shopify.shop == "ninetwofive-nl.myshopify.com") {
            var selected_shipment_method = $(".selected_shipping_span").text();
          } else {
            if(typeof checkShippingCoockie == 'string'){
              checkShippingCoockie = JSON.parse(checkShippingCoockie)
            }
            var selected_shipment_method = checkShippingCoockie.shipping_value;
          }
          $('.shipment_method_selector').val(selected_shipment_method);
          $('input[name=shipping_method_readio_preview]').each(function () {
            $(this).removeAttr('checked')
          })
          $('.shipment_method_selector .Polaris-LegacyStack__Item').each(function (index) {
            shipping_border = $(this).attr('shipping_border');
            if (selected_shipment_method == index) {
              $(this).css('border', '2px solid ' + shipping_border)
            } else {
              $(this).css('border', '2px solid #ddd')
            }
          })
          if ($("#shipping_method_selection_" + selected_shipment_method).length) {
            $("#shipping_method_selection_" + selected_shipment_method).attr('checked', 'checked');
          }

          if (typeof edd_multiple_rule_for_shipping != 'undefined' && edd_multiple_rule_for_shipping.length > selected_shipment_method) {
            sb_edd_message = edd_multiple_rule_for_shipping[selected_shipment_method].message;
            sb_edd_message = getLanguageWiseMsg(edd_multiple_rule_for_shipping[selected_shipment_method], sb_edd_message);
            sb_edd_preview_design = edd_multiple_rule_for_shipping[selected_shipment_method].preview_design;
            sb_edd_store_locatore_list  = edd_multiple_rule_for_shipping[selected_shipment_method].store_locatore_list;
          }
          myAppcallForMessage($);
        }
        if (checkCoockiInterval == 10) {
          clearInterval(chekShippingCheckerdiv)
        }
        checkCoockiInterval++;
      }, 1000)

    } else {
      chekShippingCheckerdiv = setInterval(function () {
        if ($('.shipment_method_selector').length) {
          clearInterval(chekShippingCheckerdiv)
          $('.shipment_method_selector .Polaris-LegacyStack__Item').each(function (index, value) {
            if (index != 0) {
              $(this).css('border', '2px solid #ddd')
            }
          })
        }
      }, 1000)
    }

    $(document).on("change", "input[name=shipping_method_readio_preview]", function (e) {
      e.preventDefault();
      var selected_shipment_method = $(this).val();
      $('.shipment_method_selector .Polaris-LegacyStack__Item').each(function (index) {
        shipping_border = $(this).attr('shipping_border');
        if (selected_shipment_method == index) {
          $(this).css('border', '2px solid ' + shipping_border)
        } else {
          $(this).css('border', '2px solid #ddd')
        }
      })
      sb_set_specific_msg = 1;
      if (typeof edd_multiple_rule_for_shipping != 'undefined') {
        sb_edd_message = edd_multiple_rule_for_shipping[selected_shipment_method].message;
        sb_edd_message = getLanguageWiseMsg(edd_multiple_rule_for_shipping[selected_shipment_method], sb_edd_message);
        sb_edd_preview_design = edd_multiple_rule_for_shipping[selected_shipment_method].preview_design;
        sb_edd_store_locatore_list  = edd_multiple_rule_for_shipping[selected_shipment_method].store_locatore_list;

      }
      obj = {}
      obj['shipping_value'] = selected_shipment_method
      setCookieNew('edd_choosen_shipping', JSON.stringify(obj))

      myAppcallForMessage($);

    });
    $(document).on("change", "select.shipment_method_selector", function (e) {
      e.preventDefault();
      var selected_shipment_method = $(this).find(":selected").val();
      if (typeof edd_multiple_rule_for_shipping != 'undefined') {
        sb_edd_message = edd_multiple_rule_for_shipping[selected_shipment_method].message;
        sb_edd_message = getLanguageWiseMsg(edd_multiple_rule_for_shipping[selected_shipment_method], sb_edd_message);
        sb_edd_preview_design = edd_multiple_rule_for_shipping[selected_shipment_method].preview_design;
        sb_edd_store_locatore_list  = edd_multiple_rule_for_shipping[selected_shipment_method].store_locatore_list;
      }


      if (Shopify.shop == "ninetwofive-nl.myshopify.com") {
        $(".selected_shipping_span").text(selected_shipment_method);
      }

      obj = {}
      obj['shipping_value'] = selected_shipment_method
      obj['shipping_name'] = $(this).find(":selected").text();
      setCookieNew('edd_choosen_shipping', JSON.stringify(obj))

      myAppcallForMessage($);
    });
  }

  function shipment_checker($) {
    // shipping method checker

    var shipment_valuers_array = [];
    var shipment_method_options = '';
    var shipping_method_html = '<div class="Polaris-LegacyStack Polaris-LegacyStack--vertical shipment_method_selector">';

    if (typeof edd_multiple_rule_for_shipping != 'undefined') {
      for (let i = 0; i < edd_multiple_rule_for_shipping.length; i++) {
        if (edd_multiple_rule_for_shipping[i].shipping_enable == "1") {

          Shipping_id = edd_multiple_rule_for_shipping[i].shipping_id;

          value_exists = 0;
          for (k = 0; k < shipment_valuers_array.length; k++) {
            check_id = shipment_valuers_array[k];
            check_id = check_id.replaceAll(' ', '')
            check_Shipping_id = Shipping_id.replaceAll(' ', '')
            if (check_id == check_Shipping_id) {
              value_exists = 1;
            }
          }

          if (value_exists == 0) {
            shipment_valuers_array.push(Shipping_id);

            shipping_description = '';
            shipping_broder = '#303030';
            shipping_background = '#eeeeee';

            if (typeof edd_multiple_rule_for_shipping[i].shipping_description != 'undefined') {
              shipping_description_obj = edd_multiple_rule_for_shipping[i].shipping_description
              if (typeof shipping_description_obj.shipping_description != 'undefined') {
                shipping_description = shipping_description_obj.shipping_description
              }
              if (typeof shipping_description_obj.shipping_style_border != 'undefined') {
                shipping_broder = shipping_description_obj.shipping_style_border
              }
              if (typeof shipping_description_obj.shipping_style_background != 'undefined') {
                shipping_background = shipping_description_obj.shipping_style_background
              }
            }

            /*shipping drpdown */
            checkShippingCoockie = getSbScriptCookie("edd_choosen_shipping")

            if (checkShippingCoockie != '' || Shopify.shop == "ninetwofive-nl.myshopify.com") {
              if (Shopify.shop == "ninetwofive-nl.myshopify.com") {
                var selected_shipment_method = $(".selected_shipping_span").text();
              } else {
                if(typeof checkShippingCoockie == 'string'){
                  checkShippingCoockie = JSON.parse(checkShippingCoockie)
                }
                var selected_shipment_method = checkShippingCoockie.shipping_value;
              }

              if (shipment_method_options == '' && edd_multiple_rule_for_shipping.length > selected_shipment_method) {
                shipment_method_options += `<option value="${i}" >${edd_multiple_rule_for_shipping[selected_shipment_method].shipping_id}</option>`;
              }
              if (selected_shipment_method != i) {
                shipment_method_options += `<option value="${i}">${edd_multiple_rule_for_shipping[i].shipping_id}</option>`;
              }

            } else {
              shipment_method_options += `<option value="${i}">${edd_multiple_rule_for_shipping[i].shipping_id}</option>`;
            }
            /*shipping drpdown */

            /*shipping radio button */
            shipping_title_class = 'shipping_input_radio_btn'
            shipping_description_class = 'shipping_input_radio_description';

            if (shipping_description != '' && shipping_description != 'not_set') {
              shipping_title_class = 'shipping_input_radio_btn_with_desc';
              shipping_description_class = 'shipping_input_having_radio_description';
            }

            shipping_method_html += '<div class="Polaris-LegacyStack__Item" shipping_border="' + shipping_broder + '"  style="margin:10px 0 5px;border-radius: 10px;background:' + shipping_background + ';border:2px solid ' + shipping_broder + '">';
            shipping_method_html += '<div>';
            shipping_method_html += '<label class="Polaris-Choice Polaris-RadioButton__ChoiceLabel" style="position:relative;padding:10px; display: block;" for="shipping_method_selection_' + i + '">';
            shipping_method_html += '<span class="Polaris-Choice__Control ' + shipping_title_class + '">';
            shipping_method_html += '<span class="Polaris-RadioButton">';
            if (i == 0) {
              shipping_method_html += '<input id="shipping_method_selection_' + i + '" name="shipping_method_readio_preview" type="radio" class="Polaris-RadioButton__Input" aria-describedby="disabledHelpText"  checked value="' + i + '">';
            } else {
              shipping_method_html += '<input id="shipping_method_selection_' + i + '" name="shipping_method_readio_preview" type="radio" class="Polaris-RadioButton__Input" aria-describedby="disabledHelpText"  value="' + i + '">';
            }

            shipping_method_html += '<span class="Polaris-RadioButton__Backdrop"></span></span></span>';
            shipping_method_html += '<span class="Polaris-Choice__Label ' + shipping_description_class + '">';
            shipping_method_html += '<span class="Polaris-Text--root Polaris-Text--bodyMd">';
            shipping_method_html += '<span class="specific_label preview_shipping_title" style="font-weight: 600;font-size: 18px;color:#303030">' + edd_multiple_rule_for_shipping[i].shipping_id + '</span>';
            shipping_method_html += '<span class="preview_shipping_description"><br/>' + shipping_description + '</span>';
            shipping_method_html += '</span></span></label></div></div>';
            /*shipping radio button */
          }
        }
      }
    }
    shipping_method_html += '</div>'
    $('.shipment_method_selector').remove()

    if (shipment_valuers_array.length > 0) {
      if ($(".deliverydate.sb_delivery").parent().find(".shipment_method_selector").length == 0 && typeof sb_edd_zipcode_enable != 'undefined' && sb_edd_zipcode_enable == '0') {
        if ($('.shipping_shortcode').length == 0) {
          if (typeof sb_edd_options.shipping_layout != 'undefined' && (sb_edd_options.shipping_layout == 'dropdwon' || sb_edd_options.shipping_layout == 'dropdown')) {
            $(".deliverydate.sb_delivery").before(`<select class="shipment_method_selector">${shipment_method_options}</select>`);
          } else {
            $(".deliverydate.sb_delivery").before(shipping_method_html)
          }
        } else {
          $('.shipping_shortcode').append(`<select class="shipment_method_selector">${shipment_method_options}</select>`);
        }
      }
      if ($(".deliverydate.sb_delivery").parent().find(".shipment_method_selector").length == 0 && typeof sb_edd_zipcode_enable != 'undefined' && sb_edd_zipcode_enable == '1') {
        if ($('.shipping_shortcode').length == 0) {
          //$(".sb_edd_div").after(`<select class="shipment_method_selector">${shipment_method_options}</select>`);
          $(".sb_edd_div").after(shipping_method_html)
        } else {
          $('.shipping_shortcode').append(`<select class="shipment_method_selector">${shipment_method_options}</select>`);
        }
      }
    }
  }

  function changeCountryChecker($) {
    $(document).on("change", ".edd_country_msg_change", function () {
      selected_checker_country = $(this).find(":selected").val();
      edd_user_country_code = selected_checker_country;
      country_checker_active = '1';
      clearInterval(count_down_interval)


      $('.shipment_method_selector').remove()
      set_country_msg = 0;
      sb_set_specific_msg = 0;
      sb_is_set_msg_for_product = '0';
      is_set_msg_for_sb_product_type = '0';
      is_set_msg_for_sb_product_tag = '0';
      is_set_msg_for_sb_product_vendor = '0';
      is_set_msg_for_sb_all_product = '0';
      is_set_msg_for_sb_collection = '0';
      findSpecificEDDMsg();
      myAppcallForMessage($);
    });
  }

  // store locatore
  function updateStoreLocatorMessage(message) {
    
    if(typeof sb_edd_options.store_link_label != 'undefined'){
      store_locatore_msg = sb_edd_options.store_link_label
    }else{
    var store_locatore_msg = 'Check store locator availability';
    }
    // Replace 'store_pickup_link' with a span containing the locator message
    message = message.replaceAll('{store_pickup_link}', '<span class="store_pickup_link" id="checkAvailabilityLink" style="text-decoration: underline;cursor:pointer;">'+store_locatore_msg+'</span>');
    message = message.replaceAll('{Store_pickup_link}', '<span class="store_pickup_link" id="checkAvailabilityLink" style="text-decoration: underline;cursor:pointer;">'+store_locatore_msg+'</span>');
    message = message.replaceAll('{STORE_PICKUP_LINK}', '<span class="store_pickup_link" id="checkAvailabilityLink" style="text-decoration: underline;cursor:pointer;">'+store_locatore_msg+'</span>');

    return message;
}

  function displayStorePickup($) {

      if(sb_edd_store_locatore_enable == '1' && sb_edd_options.store_locatore != 'not_set'){
       
        var allLocatoreData = JSON.parse(sb_edd_options.store_locatore);
        var storeLocatoreData = [];
        if(sb_edd_store_locatore_list != 'not_set'){
          for(a=0;a<sb_edd_store_locatore_list.length;a++){
            check_handle = sb_edd_store_locatore_list[a]
            for(b=0;b<allLocatoreData.length;b++){
              get_handle  = allLocatoreData[b]['store_handle'];
              if(check_handle == get_handle){
                storeLocatoreData.push(allLocatoreData[b])
              }
            }
          }
        }
        console.log('storeLocatoreData ',storeLocatoreData)
        if (!Array.isArray(storeLocatoreData) || storeLocatoreData.length === 0 ) {
          //$('.store_locatore_link').css('display','none')
          $('.store_pickup_link').remove()
          console.error('No store locator data available.');
          return;
        }
      
        var storePickupHTML = '';
      
        storeLocatoreData.forEach(store => {
          console.log("Processing store:", store);
      
          var store_name = store.store_name || 'Store Name not provided';
          var availability = store.pickup_availability_message || 'Pickup availability not specified';
          var address = store.address || 'Address not provided';
      
          // Build the HTML structure
          storePickupHTML += `
            <div class="store">
              <div class="store-header ">
                <h3>${store_name}</h3>
                <p class="store-status">${availability}</p>
                
                ${address}
                
              </div>
            </div>
            <hr>
          `;
        
      });
    
      // Insert the generated HTML into the .store_pickup element
      var storePickupElement = document.querySelector('.store_pickup');
      if (storePickupElement) {
        $('.store_pickup').html(storePickupHTML) ;
      } else {
        console.error(".store_pickup element not found.");
      }
      }else{
          $('.store_pickup').html('No store found') ;
          $('.store_pickup_link').remove()
      }

    $(document).on('click','#checkAvailabilityLink',function(){
      $('#sbStoreLocatore').css('display','block')
      $('#sbStoreLocatore').addClass('show')
      $('body').append('<div class="sb_modal_overlay modal-overlay show" style="display:block;position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.5);z-index: 9998;cursor: pointer;"></div>')
    })
    $(document).on('click','#sbStoreLocatore #closeModal',function(){
      $('#sbStoreLocatore').css('display','none')
      $('#sbStoreLocatore').removeClass('show')
      $('.sb_modal_overlay').remove()
    })

  }
  /* store locatore */

  function add_country_flag_name(msg) {
    var find = ["{country_flag}", "{COUNTRY_FLAG}", "{Country_flag}", "{country_name}", "{COUNTRY_NAME}", "{Country_name}"];
    var replace = ["country_flag", "country_flag", "country_flag", "country_name", "country_name", "country_name", "country_name"];

    for (var i = replace.length - 1; i >= 0; i--) {
      if (msg.includes(find[i])) {
        msg = msg.replaceAll(find[i], replace[i]);
      }
    }

    if (typeof Shopify !== 'undefined' && typeof Shopify.country !== 'undefined') {
      edd_user_country_code = Shopify.country;
    } else {
      if (typeof sb_edd_options.store_country_code != 'undefined' && sb_edd_options.store_country_code != null) {
        edd_user_country_code = sb_edd_options.store_country_code;
      } else {
        edd_user_country_code = 'US';
      }
    }
    if (typeof sb_edd_options.store_country_code != 'undefined' && sb_edd_options.store_country_code != null) {
      edd_store_country_code = sb_edd_options.store_country_code;
    } else {
      edd_store_country_code = edd_user_country_code;
    }

    sb_countries = [{ country: 'All Country', code: 'all_country' }, { country: 'Afghanistan', code: 'AF' }, { country: 'land Islands', code: 'AX' }, { country: 'Albania', code: 'AL' }, { country: 'Algeria', code: 'DZ' }, { country: 'American Samoa', code: 'AS' }, { country: 'AndorrA', code: 'AD' }, { country: 'Angola', code: 'AO' }, { country: 'Anguilla', code: 'AI' }, { country: 'Antarctica', code: 'AQ' }, { country: 'Antigua and Barbuda', code: 'AG' }, { country: 'Argentina', code: 'AR' }, { country: 'Armenia', code: 'AM' }, { country: 'Aruba', code: 'AW' }, { country: 'Australia', code: 'AU' }, { country: 'Austria', code: 'AT' }, { country: 'Azerbaijan', code: 'AZ' }, { country: 'Bahamas', code: 'BS' }, { country: 'Bahrain', code: 'BH' }, { country: 'Bangladesh', code: 'BD' }, { country: 'Barbados', code: 'BB' }, { country: 'Belarus', code: 'BY' }, { country: 'Belgium', code: 'BE' }, { country: 'Belize', code: 'BZ' }, { country: 'Benin', code: 'BJ' }, { country: 'Bermuda', code: 'BM' }, { country: 'Bhutan', code: 'BT' }, { country: 'Bolivia', code: 'BO' }, { country: 'Bosnia And Herzegovina', code: 'BA' }, { country: 'Botswana', code: 'BW' }, { country: 'Bouvet Island', code: 'BV' }, { country: 'Brazil', code: 'BR' }, { country: 'British Indian Ocean Territory', code: 'IO' }, { country: 'Brunei Darussalam', code: 'BN' }, { country: 'Saint Barthelemy', code: 'BL' }, { country: 'Bulgaria', code: 'BG' }, { country: 'Burkina Faso', code: 'BF' }, { country: 'Burundi', code: 'BI' }, { country: 'Cambodia', code: 'KH' }, { country: 'Cameroon', code: 'CM' }, { country: 'Canada', code: 'CA' }, { country: 'Cape Verde', code: 'CV' }, { country: 'Cayman Islands', code: 'KY' }, { country: 'Central African Republic', code: 'CF' }, { country: 'Chad', code: 'TD' }, { country: 'Chile', code: 'CL' }, { country: 'China', code: 'CN' }, { country: 'Christmas Island', code: 'CX' }, { country: 'Cocos (Keeling) Islands', code: 'CC' }, { country: 'Colombia', code: 'CO' }, { country: 'Comoros', code: 'KM' }, { country: 'Congo', code: 'CG' }, { country: 'Congo, The Democratic Republic of the', code: 'CD' }, { country: 'Cook Islands', code: 'CK' }, { country: 'Costa Rica', code: 'CR' }, { country: 'Cote D"Ivoire', code: 'CI' }, { country: 'Croatia', code: 'HR' }, { country: 'Cuba', code: 'CU' }, { country: 'Cyprus', code: 'CY' }, { country: 'Czech Republic', code: 'CZ' }, { country: 'Denmark', code: 'DK' }, { country: 'Djibouti', code: 'DJ' }, { country: 'Dominica', code: 'DM' }, { country: 'Dominican Republic', code: 'DO' }, { country: 'Ecuador', code: 'EC' }, { country: 'Egypt', code: 'EG' }, { country: 'El Salvador', code: 'SV' }, { country: 'Equatorial Guinea', code: 'GQ' }, { country: 'Eritrea', code: 'ER' }, { country: 'Estonia', code: 'EE' }, { country: 'Ethiopia', code: 'ET' }, { country: 'Falkland Islands (Malvinas)', code: 'FK' }, { country: 'Faroe Islands', code: 'FO' }, { country: 'Fiji', code: 'FJ' }, { country: 'Finland', code: 'FI' }, { country: 'France', code: 'FR' }, { country: 'French Guiana', code: 'GF' }, { country: 'French Polynesia', code: 'PF' }, { country: 'French Southern Territories', code: 'TF' }, { country: 'Gabon', code: 'GA' }, { country: 'Gambia', code: 'GM' }, { country: 'Georgia', code: 'GE' }, { country: 'Germany', code: 'DE' }, { country: 'Ghana', code: 'GH' }, { country: 'Gibraltar', code: 'GI' }, { country: 'Greece', code: 'GR' }, { country: 'Greenland', code: 'GL' }, { country: 'Grenada', code: 'GD' }, { country: 'Guadeloupe', code: 'GP' }, { country: 'Guam', code: 'GU' }, { country: 'Guatemala', code: 'GT' }, { country: 'Guernsey', code: 'GG' }, { country: 'Guinea', code: 'GN' }, { country: 'Guinea-Bissau', code: 'GW' }, { country: 'Guyana', code: 'GY' }, { country: 'Haiti', code: 'HT' }, { country: 'Heard Island & Mcdonald Islands', code: 'HM' }, { country: 'Holy See (Vatican City State)', code: 'VA' }, { country: 'Honduras', code: 'HN' }, { country: 'Hong Kong', code: 'HK' }, { country: 'Hungary', code: 'HU' }, { country: 'Iceland', code: 'IS' }, { country: 'India', code: 'IN' }, { country: 'Indonesia', code: 'ID' }, { country: 'Iran, Islamic Republic Of', code: 'IR' }, { country: 'Iraq', code: 'IQ' }, { country: 'Ireland', code: 'IE' }, { country: 'Isle Of Man', code: 'IM' }, { country: 'Israel', code: 'IL' }, { country: 'Italy', code: 'IT' }, { country: 'Jamaica', code: 'JM' }, { country: 'Japan', code: 'JP' }, { country: 'Jersey', code: 'JE' }, { country: 'Jordan', code: 'JO' }, { country: 'Kazakhstan', code: 'KZ' }, { country: 'Kenya', code: 'KE' }, { country: 'Kiribati', code: 'KI' }, { country: 'Korea', code: 'KP' }, { country: 'Korea, Republic of', code: 'KR' }, { country: 'Kuwait', code: 'KW' }, { country: 'Kyrgyzstan', code: 'KG' }, { country: 'Lao People"S Democratic Republic', code: 'LA' }, { country: 'Latvia', code: 'LV' }, { country: 'Lebanon', code: 'LB' }, { country: 'Lesotho', code: 'LS' }, { country: 'Liberia', code: 'LR' }, { country: 'Libyan Arab Jamahiriya', code: 'LY' }, { country: 'Liechtenstein', code: 'LI' }, { country: 'Lithuania', code: 'LT' }, { country: 'Luxembourg', code: 'LU' }, { country: 'Macao', code: 'MO' }, { country: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' }, { country: 'Madagascar', code: 'MG' }, { country: 'Malawi', code: 'MW' }, { country: 'Malaysia', code: 'MY' }, { country: 'Maldives', code: 'MV' }, { country: 'Mali', code: 'ML' }, { country: 'Malta', code: 'MT' }, { country: 'Marshall Islands', code: 'MH' }, { country: 'Martinique', code: 'MQ' }, { country: 'Mauritania', code: 'MR' }, { country: 'Mauritius', code: 'MU' }, { country: 'Mayotte', code: 'YT' }, { country: 'Mexico', code: 'MX' }, { country: 'Micronesia, Federated States of', code: 'FM' }, { country: 'Moldova', code: 'MD' }, { country: 'Monaco', code: 'MC' }, { country: 'Mongolia', code: 'MN' }, { country: 'Montenegro', code: 'ME' }, { country: 'Montserrat', code: 'MS' }, { country: 'Morocco', code: 'MA' }, { country: 'Mozambique', code: 'MZ' }, { country: 'Myanmar', code: 'MM' }, { country: 'Namibia', code: 'NA' }, { country: 'Nauru', code: 'NR' }, { country: 'Nepal', code: 'NP' }, { country: 'Netherlands', code: 'NL' }, { country: 'Netherlands Antilles', code: 'AN' }, { country: 'New Caledonia', code: 'NC' }, { country: 'New Zealand', code: 'NZ' }, { country: 'Nicaragua', code: 'NI' }, { country: 'Niger', code: 'NE' }, { country: 'Nigeria', code: 'NG' }, { country: 'Niue', code: 'NU' }, { country: 'Norfolk Island', code: 'NF' }, { country: 'Northern Mariana Islands', code: 'MP' }, { country: 'Norway', code: 'NO' }, { country: 'Oman', code: 'OM' }, { country: 'Pakistan', code: 'PK' }, { country: 'Palau', code: 'PW' }, { country: 'Palestinian Territory, Occupied', code: 'PS' }, { country: 'Panama', code: 'PA' }, { country: 'Papua New Guinea', code: 'PG' }, { country: 'Paraguay', code: 'PY' }, { country: 'Peru', code: 'PE' }, { country: 'Philippines', code: 'PH' }, { country: 'Pitcairn', code: 'PN' }, { country: 'Poland', code: 'PL' }, { country: 'Portugal', code: 'PT' }, { country: 'Puerto Rico', code: 'PR' }, { country: 'Qatar', code: 'QA' }, { country: 'Reunion', code: 'RE' }, { country: 'Romania', code: 'RO' }, { country: 'Russian Federation', code: 'RU' }, { country: 'Rwanda', code: 'RW' }, { country: 'Saint Helena', code: 'SH' }, { country: 'Saint Kitts And Nevis', code: 'KN' }, { country: 'Saint Lucia', code: 'LC' }, { country: 'Saint Pierre And Miquelon', code: 'PM' }, { country: 'Saint Vincent And Grenadines', code: 'VC' }, { country: 'Saint Martin', code: 'MF' }, { country: 'Samoa', code: 'WS' }, { country: 'San Marino', code: 'SM' }, { country: 'Sao Tome And Principe', code: 'ST' }, { country: 'Saudi Arabia', code: 'SA' }, { country: 'Senegal', code: 'SN' }, { country: 'Serbia', code: 'RS' }, { country: 'Seychelles', code: 'SC' }, { country: 'Sierra Leone', code: 'SL' }, { country: 'Singapore', code: 'SG' }, { country: 'Slovakia', code: 'SK' }, { country: 'Slovenia', code: 'SI' }, { country: 'Solomon Islands', code: 'SB' }, { country: 'Somalia', code: 'SO' }, { country: 'South Africa', code: 'ZA' }, { country: 'South Georgia And Sandwich Islands', code: 'GS' }, { country: 'Spain', code: 'ES' }, { country: 'Sri Lanka', code: 'LK' }, { country: 'Sudan', code: 'SD' }, { country: 'Suriname', code: 'SR' }, { country: 'Svalbard And Jan Mayen', code: 'SJ' }, { country: 'Swaziland', code: 'SZ' }, { country: 'Sweden', code: 'SE' }, { country: 'Switzerland', code: 'CH' }, { country: 'Syrian Arab Republic', code: 'SY' }, { country: 'Taiwan', code: 'TW' }, { country: 'Tajikistan', code: 'TJ' }, { country: 'Tanzania', code: 'TZ' }, { country: 'Thailand', code: 'TH' }, { country: 'Timor-Leste', code: 'TL' }, { country: 'Togo', code: 'TG' }, { country: 'Tokelau', code: 'TK' }, { country: 'Tonga', code: 'TO' }, { country: 'Trinidad And Tobago', code: 'TT' }, { country: 'Tunisia', code: 'TN' }, { country: 'Turkey', code: 'TR' }, { country: 'Turkmenistan', code: 'TM' }, { country: 'Turks And Caicos Islands', code: 'TC' }, { country: 'Tuvalu', code: 'TV' }, { country: 'Uganda', code: 'UG' }, { country: 'Ukraine', code: 'UA' }, { country: 'United Arab Emirates', code: 'AE' }, { country: 'United Kingdom', code: 'GB' }, { country: 'United States', code: 'US' }, { country: 'United States Outlying Islands', code: 'UM' }, { country: 'Uruguay', code: 'UY' }, { country: 'Uzbekistan', code: 'UZ' }, { country: 'Vanuatu', code: 'VU' }, { country: 'Venezuela', code: 'VE' }, { country: 'Viet Nam', code: 'VN' }, { country: 'Virgin Islands, British', code: 'VG' }, { country: 'Virgin Islands, U.S.', code: 'VI' }, { country: 'Wallis And Futuna', code: 'WF' }, { country: 'Western Sahara', code: 'EH' }, { country: 'Yemen', code: 'YE' }, { country: 'Zambia', code: 'ZM' }, { country: 'Zimbabwe', code: 'ZW' }]

    dataset = Object.keys(sb_countries).find(x => sb_countries[x].code === edd_user_country_code);
    edd_user_country_name = sb_countries[dataset].country;
    dataset = Object.keys(sb_countries).find(x => sb_countries[x].code === edd_store_country_code);
    edd_store_country_name = sb_countries[dataset].country;

    if (set_country_msg == 1) {
      edd_country_name = edd_user_country_name;
      edd_country_code = edd_user_country_code;
    } else {
      edd_country_name = edd_store_country_name;
      edd_country_code = edd_store_country_code;
    }

    if (country_checker_active == '1') {
      edd_country_code = selected_checker_country;
      edd_country_name = getCountryFullName(edd_country_code)
    }

    if (msg.includes('country_flag')) {
      msg = msg.replaceAll('country_flag', '<span class="country_flag_wrapper"><img src="https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/img/country/' + edd_country_code + '.png" style="width:25px;margin:0 2px 3px;vertical-align: middle;"></span>');
    }

    if (msg.includes('country_name')) {
      msg = msg.replaceAll('country_name', '<span class="country_name_wrapper">' + edd_country_name + '</span>');
    }

    return msg;
  }

  /* specific message design    add changes*/
  function addPreViewDesgin($) {


    if (specific_preview_design == null) {
      applyDefaultPrevieDesign();
    }
    else if (specific_preview_design == "not_set" || specific_preview_design.preview_design == 'not_set') {
      applyDefaultPrevieDesign();
    } else {

      msg_preview = {
        'bold': specific_preview_design.font_weight,
        'italic': specific_preview_design.font_style,
        'text_align': specific_preview_design.text_align,
        'br_clr': specific_preview_design.border,
        'text_clr': specific_preview_design.color,
        'background': specific_preview_design.background,
        'background_option': specific_preview_design.background_option,
        'font_size': specific_preview_design.font_size + 'px',
        'text_transfrom': specific_preview_design.text_transform,
        'icon': msg_preview.icon,
        'background_clr': specific_preview_design.background,
        'highlight_clr': specific_preview_design.highlight_color
      };
      if (typeof (specific_preview_design.margin) !== "undefined") {
        msg_preview['margin'] = specific_preview_design.margin;
      } else {
        msg_preview['margin'] = "10px 0px";
      }
      if (typeof (specific_preview_design.padding) !== "undefined") {
        msg_preview['padding'] = specific_preview_design.padding;
      } else {
        msg_preview['padding'] = "10px";
      }
      if (typeof (specific_preview_design.border_radius) !== "undefined") {
        msg_preview['border_radius'] = specific_preview_design.border_radius;
      } else {
        msg_preview['border_radius'] = "0px";
      }
    }


    if (msg_preview.icon != 0 && $.type(msg_preview.icon) != 'undefined' && ($('.delivery_icon img').length == 0)) {

      icon_src = 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/' + msg_preview.icon;
      $('.deliverydate .delivery_icon').append('<img src=' + icon_src + ' style="vertical-align: middle;margin: 0px 4px 3px;">');

    }

    if (typeof msg_preview.background_option != 'undefined' && msg_preview.background_option.indexOf("image") != -1) {
      msg_preview.background = msg_preview.background.replace('https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/', '')
      msg_preview.background = 'https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/admin/' + msg_preview.background;
      $('.deliverydate').css({ 'background-image': "url('" + msg_preview.background + "')" });
      $('.deliverydate').css({ 'background-repeat': 'no-repeat', 'background-position': 'center', 'background-size': ' cover' });
    } else {
      $('.deliverydate').css({ 'background': msg_preview.background_clr });
    }

    $('.deliverydate').css({
      'color': msg_preview.text_clr,
      'border': '1px solid ' + msg_preview.br_clr,
      'font-weight': msg_preview.bold,
      'font-style': msg_preview.italic,
      'text-transform': msg_preview.text_transfrom,
      'text-align': msg_preview.text_align,
      'position': 'relative',
      'padding': msg_preview.padding,
      'overflow': 'hidden',
      'display': 'inline-block ',
      'width': '100%',
      'margin': msg_preview.margin,
      'border-radius': msg_preview.border_radius
    });
  }

}
function applyDefaultPrevieDesign() {
  if (msg_preview.font_weight == 'bold') {
    font_weight = 'bold';
  } else {
    font_weight = 'unset';
  }

  if (msg_preview.font_style == 'italic') {
    font_style = 'italic';
  } else {
    font_style = 'unset';
  }

  if (typeof (msg_preview.margin) !== "undefined") {
    msg_previewmargin = msg_preview.margin;
  } else {
    msg_previewmargin = "10px 0px";
  }
  if (typeof (msg_preview.padding) !== "undefined") {
    msg_previewpadding = msg_preview.padding;
  } else {
    msg_previewpadding = "10px";
  }
  if (typeof (msg_preview.border_radius) !== "undefined") {
    msg_previewborder_radius = msg_preview.border_radius;
  } else {
    msg_previewborder_radius = "10px";
  }

  msg_preview = {
    'bold': font_weight,
    'italic': font_style,
    'text_align': msg_preview.text_align,
    'br_clr': msg_preview.border,
    'text_clr': msg_preview.color,
    'background': msg_preview.background,
    'background_option': msg_preview.background_option,
    'font_size': msg_preview.font_size + 'px',
    'text_transfrom': msg_preview.text_transfrom,
    'icon': msg_preview.icon,
    'background_clr': msg_preview.background_clr,
    'highlight_clr': msg_preview.highlight_clr,
    'margin': msg_previewmargin,
    'padding': msg_previewpadding,
    'border_radius': msg_previewborder_radius
  };

}
function add_additional_code($) {
  loadScript('https://estimated-delivery-days.setubridgeapps.com/estimated-delivery-days/app/edd-proxy/main/edd_additional_script.js?17-04-2025', function () { })
}